export function PlayerBadge(cjs, an) {
  var p; // shortcut to reference prototypes
  var lib = {};
  var ss = {};
  var img = {};
  lib.ssMetadata = [
    {
      name: 'PlayerBadge_atlas_1',
      frames: [
        [0, 0, 380, 380],
        [0, 382, 380, 380],
        [0, 764, 380, 380],
        [0, 1146, 380, 380],
        [0, 1528, 380, 380],
        [382, 0, 380, 380],
        [382, 382, 380, 380],
        [382, 764, 380, 380],
        [382, 1146, 380, 380],
        [382, 1528, 380, 380],
        [764, 0, 380, 380],
        [764, 382, 380, 380],
        [764, 764, 380, 380],
        [764, 1146, 380, 380],
        [764, 1528, 380, 380],
        [1146, 0, 380, 380],
        [1146, 382, 380, 380],
        [1146, 764, 380, 380],
        [1146, 1146, 380, 380],
        [1146, 1528, 380, 380],
      ],
    },
  ];

  (lib.AnMovieClip = function () {
    this.actionFrames = [];
    this.ignorePause = false;
    this.gotoAndPlay = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndPlay.call(this, positionOrLabel);
    };
    this.play = function () {
      cjs.MovieClip.prototype.play.call(this);
    };
    this.gotoAndStop = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndStop.call(this, positionOrLabel);
    };
    this.stop = function () {
      cjs.MovieClip.prototype.stop.call(this);
    };
  }).prototype = p = new cjs.MovieClip();
  // symbols:

  (lib.africanboy = function () {
    this.initialize(ss['PlayerBadge_atlas_1']);
    this.gotoAndStop(0);
  }).prototype = p = new cjs.Sprite();

  (lib.africangirl = function () {
    this.initialize(ss['PlayerBadge_atlas_1']);
    this.gotoAndStop(1);
  }).prototype = p = new cjs.Sprite();

  (lib.asianboy = function () {
    this.initialize(ss['PlayerBadge_atlas_1']);
    this.gotoAndStop(2);
  }).prototype = p = new cjs.Sprite();

  (lib.asiangirl = function () {
    this.initialize(ss['PlayerBadge_atlas_1']);
    this.gotoAndStop(3);
  }).prototype = p = new cjs.Sprite();

  (lib.caucasianboy = function () {
    this.initialize(ss['PlayerBadge_atlas_1']);
    this.gotoAndStop(4);
  }).prototype = p = new cjs.Sprite();

  (lib.caucasiangirl = function () {
    this.initialize(ss['PlayerBadge_atlas_1']);
    this.gotoAndStop(5);
  }).prototype = p = new cjs.Sprite();

  (lib.cobra = function () {
    this.initialize(ss['PlayerBadge_atlas_1']);
    this.gotoAndStop(6);
  }).prototype = p = new cjs.Sprite();

  (lib.dragon = function () {
    this.initialize(ss['PlayerBadge_atlas_1']);
    this.gotoAndStop(7);
  }).prototype = p = new cjs.Sprite();

  (lib.elephant = function () {
    this.initialize(ss['PlayerBadge_atlas_1']);
    this.gotoAndStop(8);
  }).prototype = p = new cjs.Sprite();

  (lib.hispanicboy = function () {
    this.initialize(ss['PlayerBadge_atlas_1']);
    this.gotoAndStop(9);
  }).prototype = p = new cjs.Sprite();

  (lib.hispanicgirl = function () {
    this.initialize(ss['PlayerBadge_atlas_1']);
    this.gotoAndStop(10);
  }).prototype = p = new cjs.Sprite();

  (lib.indianboy = function () {
    this.initialize(ss['PlayerBadge_atlas_1']);
    this.gotoAndStop(11);
  }).prototype = p = new cjs.Sprite();

  (lib.indiangirl = function () {
    this.initialize(ss['PlayerBadge_atlas_1']);
    this.gotoAndStop(12);
  }).prototype = p = new cjs.Sprite();

  (lib.kitsune = function () {
    this.initialize(ss['PlayerBadge_atlas_1']);
    this.gotoAndStop(13);
  }).prototype = p = new cjs.Sprite();

  (lib.phoenix = function () {
    this.initialize(ss['PlayerBadge_atlas_1']);
    this.gotoAndStop(14);
  }).prototype = p = new cjs.Sprite();

  (lib.redpanda = function () {
    this.initialize(ss['PlayerBadge_atlas_1']);
    this.gotoAndStop(15);
  }).prototype = p = new cjs.Sprite();

  (lib.sloth = function () {
    this.initialize(ss['PlayerBadge_atlas_1']);
    this.gotoAndStop(16);
  }).prototype = p = new cjs.Sprite();

  (lib.taurus = function () {
    this.initialize(ss['PlayerBadge_atlas_1']);
    this.gotoAndStop(17);
  }).prototype = p = new cjs.Sprite();

  (lib.tiger = function () {
    this.initialize(ss['PlayerBadge_atlas_1']);
    this.gotoAndStop(18);
  }).prototype = p = new cjs.Sprite();

  (lib.unicorn = function () {
    this.initialize(ss['PlayerBadge_atlas_1']);
    this.gotoAndStop(19);
  }).prototype = p = new cjs.Sprite();
  // helper functions:

  function mc_symbol_clone() {
    var clone = this._cloneProps(
      new this.constructor(
        this.mode,
        this.startPosition,
        this.loop,
        this.reversed,
      ),
    );
    clone.gotoAndStop(this.currentFrame);
    clone.paused = this.paused;
    clone.framerate = this.framerate;
    return clone;
  }

  function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
    var prototype = cjs.extend(symbol, cjs.MovieClip);
    prototype.clone = mc_symbol_clone;
    prototype.nominalBounds = nominalBounds;
    prototype.frameBounds = frameBounds;
    return prototype;
  }

  (lib.gcbadge10xai = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // gc-badge-10x.ai
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p('Ai6AtImokmIEdhzID8DFIAok7IEZhyIhgH+IHLE7IkjB1IkSjJIg3FPIkhB1g');
    this.shape.setTransform(216.05, 157.45);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p(
        'AgRHYQhSgGhGgwQgyghgyhJQgzhLgmhfQhhjsA0iFQA0iEC4hKQBYgkBCgCQBAgCAyASQAxATAkAdQAlAeAfAqQA+BTApBmQBcDjgmCKQgmCKjGBQQhhAnhMAAIgTAAgAhxkTQg8AYgEBGQgDBGBACcQBACgA1AuQA1AuA4gWQAlgPASgkQARgjgJg8QgJg6guhxQhCimg1guQgigeglAAQgUAAgVAJg',
      );
    this.shape_1.setTransform(140.3115, 186.9259);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p('AhdhRQgqBEgtAwQgtAwhLA8IhNi+QBuhaAuhQQAwhRAGhfIDKhRIFXNRIj3Bkg');
    this.shape_2.setTransform(76.7, 208.55);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p('AiLAwIAagyIBIAiIAphUIhIgkIAagzIC6BcIgaAyIhOglIgoBUIBNAmIgZA0g');
    this.shape_3.setTransform(285.1, 227.725);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p('AgwAMIgoA3IghgXIB1idIAfAZIgpA3ICHBkIgiAvg');
    this.shape_4.setTransform(271, 244.75);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        'Ah/hKIA1g1IDKBcIgsArIgzgXIgzAyIAYAzIgpAqgAhOhKIAUAlIAVApIAngmIgqgVIglgTg',
      );
    this.shape_5.setTransform(263.2, 264.875);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p(
        'AingZIBBgpIA6AuQAhAZAYAaIABgBIgShLIgOhKIA+goIB8CpIgwAeIguhBQgdgqgSgdIgBAAQALAqAIAqIARBUIgmAYIhBg2QgkgdgbgaIgBAAIAqBLIAnBFIgtAdg',
      );
    this.shape_6.setTransform(239.625, 279.575);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#000000')
      .s()
      .p(
        'AiBhGIBAgSIBHA6QAhAaAbAeIABAAQgOgfgPgyIgRg7IAzgPIA6DIIg6ARIhJg+QgngggYgaIgBABQAOApANAtIASA8IgzAPg',
      );
    this.shape_7.setTransform(206.575, 293.725);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics.f('#000000').s().p('AgrhjIA5gIIAeDOIg5AJg');
    this.shape_8.setTransform(189.175, 297.5);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#000000')
      .s()
      .p('AghBoIAEinIhEgCIABgoIDCAFIgBAoIhFgCIgFCog');
    this.shape_9.setTransform(168.125, 298.65);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#000000')
      .s()
      .p(
        'AgdBnQgrgIgagSIATgkQAaASAiAHQAnAHAEgWQACgKgIgIQgIgIgVgLQhBgfAHgqQAFgbAdgMQAdgNArAIQAkAHAaAQIgUAjQgXgPgcgFQgRgDgLAEQgJAEgCAIQgCAJAKAJQAHAHAZANQAgAPANASQANASgEAVQgFAcgcAMQgSAJgZAAQgQAAgUgEg',
      );
    this.shape_10.setTransform(147.425, 296.6146);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#000000')
      .s()
      .p(
        'AAMBtQgDgLADgoQACgUgGgKQgGgJgQgHIgQgGIgdBNIg1gTIBHjBQAeAGAqARQA2ATASAZQARAWgKAaQgGARgTAJQgQAIgTgBIAAAAQATAQgBAgIgBAmQgBATABAGgAgTgZIAVAIQAUAIAOgEQAOgEAFgNQAKgbgogOIgZgIg',
      );
    this.shape_11.setTransform(127.0986, 291.45);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics.f('#000000').s().p('AhIBQIBfi5IAyAbIheC4g');
    this.shape_12.setTransform(113, 284.6);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#000000')
      .s()
      .p('Ah6BHIB1itICABXIgWAfIhRg1IgaAmIBLAzIgVAgIhLgzIgvBGg');
    this.shape_13.setTransform(100.725, 274.625);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#000000')
      .s()
      .p(
        'AgHAnQgQgDgJgOQgJgOADgPQAEgQANgJQAOgJAPADQAQAEAJANQAJAOgDAPQgEAQgNAJQgKAHgLAAIgIgBg',
      );
    this.shape_14.setTransform(293.7269, 196.8269);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#000000')
      .s()
      .p('AhnA/IB7h3IiAAGIgDhFIDUgKIADBIIh1BxIB6gGIADBGIjUAJg');
    this.shape_15.setTransform(295.1, 166.25);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#000000')
      .s()
      .p(
        'AgtB6QgpgdgSg8QgTg6ARgwQASgxAugOQAtgOAqAdQAqAeASA7QATA7gSAwQgRAwguAOQgPAFgPAAQgdAAgdgUgAgVhFQgaAIgKAZQgLAZAKAeQAKAfAXAOQAXAOAYgIQAZgIALgYQAKgZgJgeQgKgggXgOQgOgJgPAAQgJAAgJADg',
      );
    this.shape_16.setTransform(289.6, 134.8886);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics.f('#000000').s().p('AhuATIC8hiIAgA9Ii7Big');
    this.shape_17.setTransform(281, 114.175);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#000000')
      .s()
      .p(
        'AA7B1QgggJgbgjIgmg0Ig6AsIgpg4ICph/IBRBsQAaAigBAhQgBAfgZASQgQANgUAAQgIAAgJgCgAgBgGIAhAsQAJALAKAEQALADAIgGQAJgHAAgLQAAgLgJgMIghgsg',
      );
    this.shape_18.setTransform(269.3541, 94.4353);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#000000')
      .s()
      .p('AAACHIBYhxIiNBHIgYgTIAkiaIhZBwIg3gqICEinIBLA7IgeCBIB2g7IBMA7IiECng');
    this.shape_19.setTransform(247.975, 74.375);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#000000')
      .s()
      .p('ABABqIAAgjIhmgsIgZAZIhGgdICvidIBRAiIALDrgAgDgIIBEAdIgBheg');
    this.shape_20.setTransform(215.175, 59.45);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#000000')
      .s()
      .p('AAnByIANhVIhtgRIgOBVIhEgLIAgjRIBFAKIgMBPIBtARIAMhPIBFAKIghDTg');
    this.shape_21.setTransform(190.05, 49.25);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#000000')
      .s()
      .p(
        'AhTBZQgsgcgFgwQgFgvAngjQAmgjA8gFQBTgIApA2Ig6AcQgIgNgQgHQgSgIgUACQgeADgTAUQgTATACAaQADAaAWAPQAWAQAfgDQAUgCAQgKQAOgKAGgOIA+ARQggA8hSAIIgUABQgvAAgkgWg',
      );
    this.shape_22.setTransform(160.2265, 48.2015);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#000000')
      .s()
      .p(
        'AiPg/IBmgvQA6gaAwAJQAyAKAUAsQAUAtgZAqQgZArg6AaIhmAvgAgUhCIgoASIAwBqIAngSQAfgOAMgZQAKgWgKgXQgKgXgYgHQgIgCgJAAQgTAAgUAKg',
      );
    this.shape_23.setTransform(119.1068, 60.5609);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f('#000000')
      .s()
      .p('AijgEIA3gtIChAcIhMhgIA2gsICFCmIg0AqIiogeIBPBlIg1Arg');
    this.shape_24.setTransform(93.775, 75.05);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f('#000000')
      .s()
      .p('AiNhGIA1hFIDmA0IguA7IgigJIhEBXIAQAeIgtA8gAgfAHIAtg6IhbgYg');
    this.shape_25.setTransform(76.725, 99.45);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f('#000000')
      .s()
      .p(
        'AiQAtIA5h4QATgoAdgOQAcgNAcANQAWALAJAXQAHATgEAXIBfgQIgjBGIhUAKIgQAgIBCAfIgeA/gAghhAQgKAFgHANIgXAxIArAUIAYgwQAGgNgCgLQgBgMgLgFQgEgCgEAAQgFAAgGAEg',
      );
    this.shape_26.setTransform(59.6, 119.2311);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f('#000000')
      .s()
      .p(
        'AgdCFQgxgKgVgxQgVguANg8QAQhMA4gaIAMA+QgNAGgKANQgKAOgEARQgGAfANAZQANAYAZAFQAZAGAWgRQAWgRAGggQAGgegIgWIgSgDIgMA7IgsgIIAah/IBRARQAgA3gPBFQgNA8glAiQgfAcgjAAQgKAAgLgCg',
      );
    this.shape_27.setTransform(50.2552, 146.2349);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .lf(
        [
          '#541513',
          '#8D5027',
          '#CB9552',
          '#FFF2DB',
          '#D7B189',
          '#AB6C2E',
          '#9C530D',
        ],
        [0.004, 0.082, 0.38, 0.561, 0.804, 0.918, 0.957],
        -168.6,
        0,
        168.6,
        0,
      )
      .s()
      .p(
        'AqOYSQkviBjpjpQjqjqiAkvQiFk5AAlWQAAlVCFk6QCAkuDqjpQDpjqEviAQE5iFFWAAQFWAAE5CFQEuCADqDqQDpDpCAEuQCFE6AAFVQAAFWiFE5QiAEvjpDqQjqDpkuCBQk5CElWAAQlWAAk5iEgApg2hQkZB3jZDYQjZDZh3EZQh7EjAAE9QAAE+B7EjQB3EZDZDZQDZDZEZB2QEjB8E+AAQE+AAEih8QEZh2DZjZQDZjZB3kZQB7kjAAk+QAAk9h7kjQh3kZjZjZQjZjYkZh3Qkih8k+AAQk9AAkkB8g',
      );
    this.shape_28.setTransform(171.625, 171.6);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .lf(
        ['#EBC17D', '#EDD089', '#F4E8D9', '#C08329', '#EABE81'],
        [0.004, 0.184, 0.412, 0.729, 0.949],
        -88.8,
        153.8,
        93.5,
        -161.9,
      )
      .s()
      .p(
        'AqOYSQkviBjpjpQjqjqiAkvQiFk5AAlWQAAlVCFk6QCAkuDqjpQDpjqEviAQE5iFFWAAQFWAAE5CFQEuCADqDqQDpDpCAEuQCFE6AAFVQAAFWiFE5QiAEvjpDqQjqDpkuCBQk5CElWAAQlWAAk5iEg',
      );
    this.shape_29.setTransform(171.625, 171.6);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f('#FBAE33')
      .s()
      .p(
        'AqaYtQk0iCjujuQjujuiCk0QiHk/AAlcQAAlcCHk/QCCk0DujtQDujtE0iDQE/iHFcAAQFcAAE/CHQE0CDDtDtQDuDtCCE0QCHE/AAFcQAAFciHE/QiCE0juDuQjtDuk0CCQk/CHlcAAQlcAAk/iHgAqO4QQkvCAjpDqQjqDpiAEuQiFE6AAFVQAAFWCFE5QCAEvDqDqQDpDpEvCBQE5CEFWAAQFWAAE5iEQEuiBDqjpQDpjqCAkvQCFk5AAlWQAAlViFk6QiAkujpjpQjqjqkuiAQk5iFlWAAQlWAAk5CFg',
      );
    this.shape_30.setTransform(171.625, 171.6);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f('#FBAE33')
      .s()
      .p(
        'AqUYfQkxiBjsjsQjsjsiBkwQiGk9AAlZQAAlZCGk7QCBkyDsjrQDsjsExiBQE8iGFZAAQFZAAE8CGQExCBDsDsQDrDrCBEyQCGE7AAFZQAAFZiGE9QiBEwjrDsQjsDskxCBQk8CGlZAAQlZAAk8iGg',
      );
    this.shape_31.setTransform(171.625, 171.6);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_31 },
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 343.3, 343.2);

  (lib.gcbadge9xai = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // gc-badge-9x.ai
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p('AjjA7InkkNIFeiOIEeC4IBJlJIFaiMIidIXIINEgIllCQIk4i6IhdFeIlkCQg');
    this.shape.setTransform(205.3, 162.35);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p(
        'AkGH0QhNgUg8g2IFdivQAiArApAGQAqAGAwgUQBYgjAahMQATg4gliMQgwBEg8AvQg8AwhaAkQivBHiZggQiYgegyh7QgihSAihdQAiheBehOQBchOCkhDQDDhOCHgFQCHgFBuBBQBtBCA+CZQBbDihqClQhqCmkHBqQidA/hhANQgoAFgkAAQg2AAgvgMgAh8kfQhIAdgiA2QghA3AcBFQAcBGBBAQQBAASBKgeQBMgfAkg3QAkg6gbhCQgbhEhFgQQgYgHgaAAQguAAgxAUg',
      );
    this.shape_1.setTransform(102.5446, 203.0003);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p('AiLAwIAagyIBIAiIAphUIhIgkIAagzIC6BcIgaAyIhOglIgoBUIBNAmIgZA0g');
    this.shape_2.setTransform(285.1, 227.725);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p('AgwAMIgoA3IghgXIB1idIAfAZIgpA3ICHBkIgiAvg');
    this.shape_3.setTransform(271, 244.75);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p(
        'Ah/hKIA1g1IDKBcIgsArIgzgXIgzAyIAYAzIgpAqgAhOhKIAUAlIAVApIAngmIgqgVIglgTg',
      );
    this.shape_4.setTransform(263.2, 264.875);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        'AingZIBBgpIA6AuQAhAZAYAaIABgBIgShLIgOhKIA+goIB8CpIgwAeIguhBQgdgqgSgdIgBAAQALAqAIAqIARBUIgmAYIhBg2QgkgdgbgaIgBAAIAqBLIAnBFIgtAdg',
      );
    this.shape_5.setTransform(239.625, 279.575);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p(
        'AiBhGIBAgSIBHA6QAhAaAbAeIABAAQgOgfgPgyIgRg7IAzgPIA6DIIg6ARIhJg+QgngggYgaIgBABQAOApANAtIASA8IgzAPg',
      );
    this.shape_6.setTransform(206.575, 293.725);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics.f('#000000').s().p('AgrhjIA5gIIAeDOIg5AJg');
    this.shape_7.setTransform(189.175, 297.5);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#000000')
      .s()
      .p('AghBoIAEinIhEgCIABgoIDCAFIgBAoIhFgCIgFCog');
    this.shape_8.setTransform(168.125, 298.65);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#000000')
      .s()
      .p(
        'AgdBnQgrgIgagSIATgkQAaASAiAHQAnAHAEgWQACgKgIgIQgIgIgVgLQhBgfAHgqQAFgbAdgMQAdgNArAIQAkAHAaAQIgUAjQgXgPgcgFQgRgDgLAEQgJAEgCAIQgCAJAKAJQAHAHAZANQAgAPANASQANASgEAVQgFAcgcAMQgSAJgZAAQgQAAgUgEg',
      );
    this.shape_9.setTransform(147.425, 296.6146);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#000000')
      .s()
      .p(
        'AAMBtQgDgLADgoQACgUgGgKQgGgJgQgHIgQgGIgdBNIg1gTIBHjBQAeAGAqARQA2ATASAZQARAWgKAaQgGARgTAJQgQAIgTgBIAAAAQATAQgBAgIgBAmQgBATABAGgAgTgZIAVAIQAUAIAOgEQAOgEAFgNQAKgbgogOIgZgIg',
      );
    this.shape_10.setTransform(127.0986, 291.45);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics.f('#000000').s().p('AhIBQIBfi5IAyAbIheC4g');
    this.shape_11.setTransform(113, 284.6);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#000000')
      .s()
      .p('Ah6BHIB1itICABXIgWAfIhRg1IgaAmIBLAzIgVAgIhLgzIgvBGg');
    this.shape_12.setTransform(100.725, 274.625);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#000000')
      .s()
      .p(
        'AgHAnQgQgDgJgOQgJgOADgPQAEgQANgJQAOgJAPADQAQAEAJANQAJAOgDAPQgEAQgNAJQgKAHgLAAIgIgBg',
      );
    this.shape_13.setTransform(293.7269, 196.8269);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#000000')
      .s()
      .p('AhnA/IB7h3IiAAGIgDhFIDUgKIADBIIh1BxIB6gGIADBGIjUAJg');
    this.shape_14.setTransform(295.1, 166.25);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#000000')
      .s()
      .p(
        'AgtB6QgpgdgSg8QgTg6ARgwQASgxAugOQAtgOAqAdQAqAeASA7QATA7gSAwQgRAwguAOQgPAFgPAAQgdAAgdgUgAgVhFQgaAIgKAZQgLAZAKAeQAKAfAXAOQAXAOAYgIQAZgIALgYQAKgZgJgeQgKgggXgOQgOgJgPAAQgJAAgJADg',
      );
    this.shape_15.setTransform(289.6, 134.8886);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics.f('#000000').s().p('AhuATIC8hiIAgA9Ii7Big');
    this.shape_16.setTransform(281, 114.175);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#000000')
      .s()
      .p(
        'AA7B1QgggJgbgjIgmg0Ig6AsIgpg4ICph/IBRBsQAaAigBAhQgBAfgZASQgQANgUAAQgIAAgJgCgAgBgGIAhAsQAJALAKAEQALADAIgGQAJgHAAgLQAAgLgJgMIghgsg',
      );
    this.shape_17.setTransform(269.3541, 94.4353);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#000000')
      .s()
      .p('AAACHIBYhxIiNBHIgYgTIAkiaIhZBwIg3gqICEinIBLA7IgeCBIB2g7IBMA7IiECng');
    this.shape_18.setTransform(247.975, 74.375);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#000000')
      .s()
      .p('ABABqIAAgjIhmgsIgZAZIhGgdICvidIBRAiIALDrgAgDgIIBEAdIgBheg');
    this.shape_19.setTransform(215.175, 59.45);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#000000')
      .s()
      .p('AAnByIANhVIhtgRIgOBVIhEgLIAgjRIBFAKIgMBPIBtARIAMhPIBFAKIghDTg');
    this.shape_20.setTransform(190.05, 49.25);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#000000')
      .s()
      .p(
        'AhTBZQgsgcgFgwQgFgvAngjQAmgjA8gFQBTgIApA2Ig6AcQgIgNgQgHQgSgIgUACQgeADgTAUQgTATACAaQADAaAWAPQAWAQAfgDQAUgCAQgKQAOgKAGgOIA+ARQggA8hSAIIgUABQgvAAgkgWg',
      );
    this.shape_21.setTransform(160.2265, 48.2015);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#000000')
      .s()
      .p(
        'AiPg/IBmgvQA6gaAwAJQAyAKAUAsQAUAtgZAqQgZArg6AaIhmAvgAgUhCIgoASIAwBqIAngSQAfgOAMgZQAKgWgKgXQgKgXgYgHQgIgCgJAAQgTAAgUAKg',
      );
    this.shape_22.setTransform(119.1068, 60.5609);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#000000')
      .s()
      .p('AijgEIA3gtIChAcIhMhgIA2gsICFCmIg0AqIiogeIBPBlIg1Arg');
    this.shape_23.setTransform(93.775, 75.05);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f('#000000')
      .s()
      .p('AiNhGIA1hFIDmA0IguA7IgigJIhEBXIAQAeIgtA8gAgfAHIAtg6IhbgYg');
    this.shape_24.setTransform(76.725, 99.45);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f('#000000')
      .s()
      .p(
        'AiQAtIA5h4QATgoAdgOQAcgNAcANQAWALAJAXQAHATgEAXIBfgQIgjBGIhUAKIgQAgIBCAfIgeA/gAghhAQgKAFgHANIgXAxIArAUIAYgwQAGgNgCgLQgBgMgLgFQgEgCgEAAQgFAAgGAEg',
      );
    this.shape_25.setTransform(59.6, 119.2311);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f('#000000')
      .s()
      .p(
        'AgdCFQgxgKgVgxQgVguANg8QAQhMA4gaIAMA+QgNAGgKANQgKAOgEARQgGAfANAZQANAYAZAFQAZAGAWgRQAWgRAGggQAGgegIgWIgSgDIgMA7IgsgIIAah/IBRARQAgA3gPBFQgNA8glAiQgfAcgjAAQgKAAgLgCg',
      );
    this.shape_26.setTransform(50.2552, 146.2349);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .lf(
        [
          '#541513',
          '#8D5027',
          '#CB9552',
          '#FFF2DB',
          '#D7B189',
          '#AB6C2E',
          '#9C530D',
        ],
        [0.004, 0.082, 0.38, 0.561, 0.804, 0.918, 0.957],
        -168.6,
        0,
        168.6,
        0,
      )
      .s()
      .p(
        'AqOYSQkviBjpjpQjqjqiAkvQiFk5AAlWQAAlVCFk6QCAkuDqjpQDpjqEviAQE5iFFWAAQFWAAE5CFQEuCADqDqQDpDpCAEuQCFE6AAFVQAAFWiFE5QiAEvjpDqQjqDpkuCBQk5CElWAAQlWAAk5iEgApg2hQkZB3jZDYQjZDZh3EZQh7EjAAE9QAAE+B7EjQB3EZDZDZQDZDZEZB2QEjB8E+AAQE+AAEih8QEZh2DZjZQDZjZB3kZQB7kjAAk+QAAk9h7kjQh3kZjZjZQjZjYkZh3Qkih8k+AAQk9AAkkB8g',
      );
    this.shape_27.setTransform(171.625, 171.6);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .lf(
        ['#EBC17D', '#EDD089', '#F4E8D9', '#C08329', '#EABE81'],
        [0.004, 0.184, 0.412, 0.729, 0.949],
        -88.8,
        153.8,
        93.5,
        -161.9,
      )
      .s()
      .p(
        'AqOYSQkviBjpjpQjqjqiAkvQiFk5AAlWQAAlVCFk6QCAkuDqjpQDpjqEviAQE5iFFWAAQFWAAE5CFQEuCADqDqQDpDpCAEuQCFE6AAFVQAAFWiFE5QiAEvjpDqQjqDpkuCBQk5CElWAAQlWAAk5iEg',
      );
    this.shape_28.setTransform(171.625, 171.6);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f('#FBAE33')
      .s()
      .p(
        'AqaYtQk0iCjujuQjujuiCk0QiHk/AAlcQAAlcCHk/QCCk0DujtQDujtE0iDQE/iHFcAAQFcAAE/CHQE0CDDtDtQDuDtCCE0QCHE/AAFcQAAFciHE/QiCE0juDuQjtDuk0CCQk/CHlcAAQlcAAk/iHgAqO4QQkvCAjpDqQjqDpiAEuQiFE6AAFVQAAFWCFE5QCAEvDqDqQDpDpEvCBQE5CEFWAAQFWAAE5iEQEuiBDqjpQDpjqCAkvQCFk5AAlWQAAlViFk6QiAkujpjpQjqjqkuiAQk5iFlWAAQlWAAk5CFg',
      );
    this.shape_29.setTransform(171.625, 171.6);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f('#FBAE33')
      .s()
      .p(
        'AqUYfQkxiBjsjsQjsjsiBkwQiGk9AAlZQAAlZCGk7QCBkyDsjrQDsjsExiBQE8iGFZAAQFZAAE8CGQExCBDsDsQDrDrCBEyQCGE7AAFZQAAFZiGE9QiBEwjrDsQjsDskxCBQk8CGlZAAQlZAAk8iGg',
      );
    this.shape_30.setTransform(171.625, 171.6);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 343.3, 343.2);

  (lib.gcbadge8xai = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // gc-badge-8x.ai
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p('AjiA7InlkNIFeiOIEeC4IBKlJIFZiMIicIWIIMEhIllCQIk4i6IheFeIliCQg');
    this.shape.setTransform(205.7, 162);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p(
        'AlZHoQhPgmgfhMQgehKAfhIQAehIBghHQheAFg0gVQhHgdgag+QgqhpB5h/QBghjC9hMQD6hlCSAPQCSAPAnBhQAXA4gcBFQgUAxhABEQBygJBIAhQBIAiAaBBQAaA+gVBHQgWBJgyA2QgyA3hZA0QhYA0hrArQjGBRh2ALQgaACgYAAQhVAAg+gegAAAAhQhBAagjA2QgjA3AYA5QAWA4BBAOQA/APBCgaQA+gZAjg4QAkg4gWg3QgXg2hAgQQgYgGgXAAQgpAAgpARgAiFkmQhAAZgcArQgdAqAQArQASAsAzAJQAzALBEgcQA8gZAbgpQAcgqgRgpQgRgrgygMQgQgDgQAAQgmAAgsASg',
      );
    this.shape_1.setTransform(104.7968, 202.6244);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p('AiLAwIAagyIBIAiIAphUIhIgkIAagzIC6BcIgaAyIhOglIgoBUIBNAmIgZA0g');
    this.shape_2.setTransform(285.1, 227.725);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p('AgwAMIgoA3IghgXIB1idIAfAZIgpA3ICHBkIgiAvg');
    this.shape_3.setTransform(271, 244.75);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p(
        'Ah/hKIA1g1IDKBcIgsArIgzgXIgzAyIAYAzIgpAqgAhOhKIAUAlIAVApIAngmIgqgVIglgTg',
      );
    this.shape_4.setTransform(263.2, 264.875);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        'AingZIBBgpIA6AuQAhAZAYAaIABgBIgShLIgOhKIA+goIB8CpIgwAeIguhBQgdgqgSgdIgBAAQALAqAIAqIARBUIgmAYIhBg2QgkgdgbgaIgBAAIAqBLIAnBFIgtAdg',
      );
    this.shape_5.setTransform(239.625, 279.575);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p(
        'AiBhGIBAgSIBHA6QAhAaAbAeIABAAQgOgfgPgyIgRg7IAzgPIA6DIIg6ARIhJg+QgngggYgaIgBABQAOApANAtIASA8IgzAPg',
      );
    this.shape_6.setTransform(206.575, 293.725);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics.f('#000000').s().p('AgrhjIA5gIIAeDOIg5AJg');
    this.shape_7.setTransform(189.175, 297.5);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#000000')
      .s()
      .p('AghBoIAEinIhEgCIABgoIDCAFIgBAoIhFgCIgFCog');
    this.shape_8.setTransform(168.125, 298.65);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#000000')
      .s()
      .p(
        'AgdBnQgrgIgagSIATgkQAaASAiAHQAnAHAEgWQACgKgIgIQgIgIgVgLQhBgfAHgqQAFgbAdgMQAdgNArAIQAkAHAaAQIgUAjQgXgPgcgFQgRgDgLAEQgJAEgCAIQgCAJAKAJQAHAHAZANQAgAPANASQANASgEAVQgFAcgcAMQgSAJgZAAQgQAAgUgEg',
      );
    this.shape_9.setTransform(147.425, 296.6146);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#000000')
      .s()
      .p(
        'AAMBtQgDgLADgoQACgUgGgKQgGgJgQgHIgQgGIgdBNIg1gTIBHjBQAeAGAqARQA2ATASAZQARAWgKAaQgGARgTAJQgQAIgTgBIAAAAQATAQgBAgIgBAmQgBATABAGgAgTgZIAVAIQAUAIAOgEQAOgEAFgNQAKgbgogOIgZgIg',
      );
    this.shape_10.setTransform(127.0986, 291.45);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics.f('#000000').s().p('AhIBQIBfi5IAyAbIheC4g');
    this.shape_11.setTransform(113, 284.6);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#000000')
      .s()
      .p('Ah6BHIB1itICABXIgWAfIhRg1IgaAmIBLAzIgVAgIhLgzIgvBGg');
    this.shape_12.setTransform(100.725, 274.625);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#000000')
      .s()
      .p(
        'AgHAnQgQgDgJgOQgJgOADgPQAEgQANgJQAOgJAPADQAQAEAJANQAJAOgDAPQgEAQgNAJQgKAHgLAAIgIgBg',
      );
    this.shape_13.setTransform(293.7269, 196.8269);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#000000')
      .s()
      .p('AhnA/IB7h3IiAAGIgDhFIDUgKIADBIIh1BxIB6gGIADBGIjUAJg');
    this.shape_14.setTransform(295.1, 166.25);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#000000')
      .s()
      .p(
        'AgtB6QgpgdgSg8QgTg6ARgwQASgxAugOQAtgOAqAdQAqAeASA7QATA7gSAwQgRAwguAOQgPAFgPAAQgdAAgdgUgAgVhFQgaAIgKAZQgLAZAKAeQAKAfAXAOQAXAOAYgIQAZgIALgYQAKgZgJgeQgKgggXgOQgOgJgPAAQgJAAgJADg',
      );
    this.shape_15.setTransform(289.6, 134.8886);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics.f('#000000').s().p('AhuATIC8hiIAgA9Ii7Big');
    this.shape_16.setTransform(281, 114.175);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#000000')
      .s()
      .p(
        'AA7B1QgggJgbgjIgmg0Ig6AsIgpg4ICph/IBRBsQAaAigBAhQgBAfgZASQgQANgUAAQgIAAgJgCgAgBgGIAhAsQAJALAKAEQALADAIgGQAJgHAAgLQAAgLgJgMIghgsg',
      );
    this.shape_17.setTransform(269.3541, 94.4353);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#000000')
      .s()
      .p('AAACHIBYhxIiNBHIgYgTIAkiaIhZBwIg3gqICEinIBLA7IgeCBIB2g7IBMA7IiECng');
    this.shape_18.setTransform(247.975, 74.375);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#000000')
      .s()
      .p('ABABqIAAgjIhmgsIgZAZIhGgdICvidIBRAiIALDrgAgDgIIBEAdIgBheg');
    this.shape_19.setTransform(215.175, 59.45);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#000000')
      .s()
      .p('AAnByIANhVIhtgRIgOBVIhEgLIAgjRIBFAKIgMBPIBtARIAMhPIBFAKIghDTg');
    this.shape_20.setTransform(190.05, 49.25);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#000000')
      .s()
      .p(
        'AhTBZQgsgcgFgwQgFgvAngjQAmgjA8gFQBTgIApA2Ig6AcQgIgNgQgHQgSgIgUACQgeADgTAUQgTATACAaQADAaAWAPQAWAQAfgDQAUgCAQgKQAOgKAGgOIA+ARQggA8hSAIIgUABQgvAAgkgWg',
      );
    this.shape_21.setTransform(160.2265, 48.2015);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#000000')
      .s()
      .p(
        'AiPg/IBmgvQA6gaAwAJQAyAKAUAsQAUAtgZAqQgZArg6AaIhmAvgAgUhCIgoASIAwBqIAngSQAfgOAMgZQAKgWgKgXQgKgXgYgHQgIgCgJAAQgTAAgUAKg',
      );
    this.shape_22.setTransform(119.1068, 60.5609);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#000000')
      .s()
      .p('AijgEIA3gtIChAcIhMhgIA2gsICFCmIg0AqIiogeIBPBlIg1Arg');
    this.shape_23.setTransform(93.775, 75.05);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f('#000000')
      .s()
      .p('AiNhGIA1hFIDmA0IguA7IgigJIhEBXIAQAeIgtA8gAgfAHIAtg6IhbgYg');
    this.shape_24.setTransform(76.725, 99.45);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f('#000000')
      .s()
      .p(
        'AiQAtIA5h4QATgoAdgOQAcgNAcANQAWALAJAXQAHATgEAXIBfgQIgjBGIhUAKIgQAgIBCAfIgeA/gAghhAQgKAFgHANIgXAxIArAUIAYgwQAGgNgCgLQgBgMgLgFQgEgCgEAAQgFAAgGAEg',
      );
    this.shape_25.setTransform(59.6, 119.2311);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f('#000000')
      .s()
      .p(
        'AgdCFQgxgKgVgxQgVguANg8QAQhMA4gaIAMA+QgNAGgKANQgKAOgEARQgGAfANAZQANAYAZAFQAZAGAWgRQAWgRAGggQAGgegIgWIgSgDIgMA7IgsgIIAah/IBRARQAgA3gPBFQgNA8glAiQgfAcgjAAQgKAAgLgCg',
      );
    this.shape_26.setTransform(50.2552, 146.2349);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .lf(
        [
          '#541513',
          '#8D5027',
          '#CB9552',
          '#FFF2DB',
          '#D7B189',
          '#AB6C2E',
          '#9C530D',
        ],
        [0.004, 0.082, 0.38, 0.561, 0.804, 0.918, 0.957],
        -168.6,
        0,
        168.6,
        0,
      )
      .s()
      .p(
        'AqOYSQkviBjpjpQjqjqiAkvQiFk5AAlWQAAlVCFk6QCAkuDqjpQDpjqEviAQE5iFFWAAQFWAAE5CFQEuCADqDqQDpDpCAEuQCFE6AAFVQAAFWiFE5QiAEvjpDqQjqDpkuCBQk5CElWAAQlWAAk5iEgApg2hQkZB3jZDYQjZDZh3EZQh7EjAAE9QAAE+B7EjQB3EZDZDZQDZDZEZB2QEjB8E+AAQE+AAEih8QEZh2DZjZQDZjZB3kZQB7kjAAk+QAAk9h7kjQh3kZjZjZQjZjYkZh3Qkih8k+AAQk9AAkkB8g',
      );
    this.shape_27.setTransform(171.625, 171.6);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .lf(
        ['#EBC17D', '#EDD089', '#F4E8D9', '#C08329', '#EABE81'],
        [0.004, 0.184, 0.412, 0.729, 0.949],
        -88.8,
        153.8,
        93.5,
        -161.9,
      )
      .s()
      .p(
        'AqOYSQkviBjpjpQjqjqiAkvQiFk5AAlWQAAlVCFk6QCAkuDqjpQDpjqEviAQE5iFFWAAQFWAAE5CFQEuCADqDqQDpDpCAEuQCFE6AAFVQAAFWiFE5QiAEvjpDqQjqDpkuCBQk5CElWAAQlWAAk5iEg',
      );
    this.shape_28.setTransform(171.625, 171.6);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f('#FBAE33')
      .s()
      .p(
        'AqaYtQk0iCjujuQjujuiCk0QiHk/AAlcQAAlcCHk/QCCk0DujtQDujtE0iDQE/iHFcAAQFcAAE/CHQE0CDDtDtQDuDtCCE0QCHE/AAFcQAAFciHE/QiCE0juDuQjtDuk0CCQk/CHlcAAQlcAAk/iHgAqO4QQkvCAjpDqQjqDpiAEuQiFE6AAFVQAAFWCFE5QCAEvDqDqQDpDpEvCBQE5CEFWAAQFWAAE5iEQEuiBDqjpQDpjqCAkvQCFk5AAlWQAAlViFk6QiAkujpjpQjqjqkuiAQk5iFlWAAQlWAAk5CFg',
      );
    this.shape_29.setTransform(171.625, 171.6);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f('#FBAE33')
      .s()
      .p(
        'AqUYfQkxiBjsjsQjsjsiBkwQiGk9AAlZQAAlZCGk7QCBkyDsjrQDsjsExiBQE8iGFZAAQFZAAE8CGQExCBDsDsQDrDrCBEyQCGE7AAFZQAAFZiGE9QiBEwjrDsQjsDskxCBQk8CGlZAAQlZAAk8iGg',
      );
    this.shape_30.setTransform(171.625, 171.6);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 343.3, 343.2);

  (lib.gcbadge7xai = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // gc-badge-7x.ai
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p('AjjA7InkkNIFeiNIEeC3IBJlJIFaiMIidIWIINEhIllCQIk4i6IhdFfIlkCPg');
    this.shape.setTransform(207.9, 162.2);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p(
        'AAAC6QAgivB/jqIprD6IhPjEIP4mbIA/CdQhlCIgyB+Qg/CegGCiQgGB/AqCbIlbCMQgpjfAgisg',
      );
    this.shape_1.setTransform(88.625, 199.3);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p('AiLAwIAagyIBIAiIAphUIhIgkIAagzIC6BcIgaAyIhOglIgoBUIBNAmIgZA0g');
    this.shape_2.setTransform(285.1, 227.725);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p('AgwAMIgoA3IghgXIB1idIAfAZIgpA3ICHBkIgiAvg');
    this.shape_3.setTransform(271, 244.75);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p(
        'Ah/hKIA1g1IDKBcIgsArIgzgXIgzAyIAYAzIgpAqgAhOhKIAUAlIAVApIAngmIgqgVIglgTg',
      );
    this.shape_4.setTransform(263.2, 264.875);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        'AingZIBBgpIA6AuQAhAZAYAaIABgBIgShLIgOhKIA+goIB8CpIgwAeIguhBQgdgqgSgdIgBAAQALAqAIAqIARBUIgmAYIhBg2QgkgdgbgaIgBAAIAqBLIAnBFIgtAdg',
      );
    this.shape_5.setTransform(239.625, 279.575);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p(
        'AiBhGIBAgSIBHA6QAhAaAbAeIABAAQgOgfgPgyIgRg7IAzgPIA6DIIg6ARIhJg+QgngggYgaIgBABQAOApANAtIASA8IgzAPg',
      );
    this.shape_6.setTransform(206.575, 293.725);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics.f('#000000').s().p('AgrhjIA5gIIAeDOIg5AJg');
    this.shape_7.setTransform(189.175, 297.5);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#000000')
      .s()
      .p('AghBoIAEinIhEgCIABgoIDCAFIgBAoIhFgCIgFCog');
    this.shape_8.setTransform(168.125, 298.65);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#000000')
      .s()
      .p(
        'AgdBnQgrgIgagSIATgkQAaASAiAHQAnAHAEgWQACgKgIgIQgIgIgVgLQhBgfAHgqQAFgbAdgMQAdgNArAIQAkAHAaAQIgUAjQgXgPgcgFQgRgDgLAEQgJAEgCAIQgCAJAKAJQAHAHAZANQAgAPANASQANASgEAVQgFAcgcAMQgSAJgZAAQgQAAgUgEg',
      );
    this.shape_9.setTransform(147.425, 296.6146);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#000000')
      .s()
      .p(
        'AAMBtQgDgLADgoQACgUgGgKQgGgJgQgHIgQgGIgdBNIg1gTIBHjBQAeAGAqARQA2ATASAZQARAWgKAaQgGARgTAJQgQAIgTgBIAAAAQATAQgBAgIgBAmQgBATABAGgAgTgZIAVAIQAUAIAOgEQAOgEAFgNQAKgbgogOIgZgIg',
      );
    this.shape_10.setTransform(127.0986, 291.45);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics.f('#000000').s().p('AhIBQIBfi5IAyAbIheC4g');
    this.shape_11.setTransform(113, 284.6);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#000000')
      .s()
      .p('Ah6BHIB1itICABXIgWAfIhRg1IgaAmIBLAzIgVAgIhLgzIgvBGg');
    this.shape_12.setTransform(100.725, 274.625);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#000000')
      .s()
      .p(
        'AgHAnQgQgDgJgOQgJgOADgPQAEgQANgJQAOgJAPADQAQAEAJANQAJAOgDAPQgEAQgNAJQgKAHgLAAIgIgBg',
      );
    this.shape_13.setTransform(293.7269, 196.8269);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#000000')
      .s()
      .p('AhnA/IB7h3IiAAGIgDhFIDUgKIADBIIh1BxIB6gGIADBGIjUAJg');
    this.shape_14.setTransform(295.1, 166.25);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#000000')
      .s()
      .p(
        'AgtB6QgpgdgSg8QgTg6ARgwQASgxAugOQAtgOAqAdQAqAeASA7QATA7gSAwQgRAwguAOQgPAFgPAAQgdAAgdgUgAgVhFQgaAIgKAZQgLAZAKAeQAKAfAXAOQAXAOAYgIQAZgIALgYQAKgZgJgeQgKgggXgOQgOgJgPAAQgJAAgJADg',
      );
    this.shape_15.setTransform(289.6, 134.8886);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics.f('#000000').s().p('AhuATIC8hiIAgA9Ii7Big');
    this.shape_16.setTransform(281, 114.175);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#000000')
      .s()
      .p(
        'AA7B1QgggJgbgjIgmg0Ig6AsIgpg4ICph/IBRBsQAaAigBAhQgBAfgZASQgQANgUAAQgIAAgJgCgAgBgGIAhAsQAJALAKAEQALADAIgGQAJgHAAgLQAAgLgJgMIghgsg',
      );
    this.shape_17.setTransform(269.3541, 94.4353);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#000000')
      .s()
      .p('AAACHIBYhxIiNBHIgYgTIAkiaIhZBwIg3gqICEinIBLA7IgeCBIB2g7IBMA7IiECng');
    this.shape_18.setTransform(247.975, 74.375);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#000000')
      .s()
      .p('ABABqIAAgjIhmgsIgZAZIhGgdICvidIBRAiIALDrgAgDgIIBEAdIgBheg');
    this.shape_19.setTransform(215.175, 59.45);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#000000')
      .s()
      .p('AAnByIANhVIhtgRIgOBVIhEgLIAgjRIBFAKIgMBPIBtARIAMhPIBFAKIghDTg');
    this.shape_20.setTransform(190.05, 49.25);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#000000')
      .s()
      .p(
        'AhTBZQgsgcgFgwQgFgvAngjQAmgjA8gFQBTgIApA2Ig6AcQgIgNgQgHQgSgIgUACQgeADgTAUQgTATACAaQADAaAWAPQAWAQAfgDQAUgCAQgKQAOgKAGgOIA+ARQggA8hSAIIgUABQgvAAgkgWg',
      );
    this.shape_21.setTransform(160.2265, 48.2015);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#000000')
      .s()
      .p(
        'AiPg/IBmgvQA6gaAwAJQAyAKAUAsQAUAtgZAqQgZArg6AaIhmAvgAgUhCIgoASIAwBqIAngSQAfgOAMgZQAKgWgKgXQgKgXgYgHQgIgCgJAAQgTAAgUAKg',
      );
    this.shape_22.setTransform(119.1068, 60.5609);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#000000')
      .s()
      .p('AijgEIA3gtIChAcIhMhgIA2gsICFCmIg0AqIiogeIBPBlIg1Arg');
    this.shape_23.setTransform(93.775, 75.05);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f('#000000')
      .s()
      .p('AiNhGIA1hFIDmA0IguA7IgigJIhEBXIAQAeIgtA8gAgfAHIAtg6IhbgYg');
    this.shape_24.setTransform(76.725, 99.45);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f('#000000')
      .s()
      .p(
        'AiQAtIA5h4QATgoAdgOQAcgNAcANQAWALAJAXQAHATgEAXIBfgQIgjBGIhUAKIgQAgIBCAfIgeA/gAghhAQgKAFgHANIgXAxIArAUIAYgwQAGgNgCgLQgBgMgLgFQgEgCgEAAQgFAAgGAEg',
      );
    this.shape_25.setTransform(59.6, 119.2311);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f('#000000')
      .s()
      .p(
        'AgdCFQgxgKgVgxQgVguANg8QAQhMA4gaIAMA+QgNAGgKANQgKAOgEARQgGAfANAZQANAYAZAFQAZAGAWgRQAWgRAGggQAGgegIgWIgSgDIgMA7IgsgIIAah/IBRARQAgA3gPBFQgNA8glAiQgfAcgjAAQgKAAgLgCg',
      );
    this.shape_26.setTransform(50.2552, 146.2349);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .lf(
        [
          '#541513',
          '#8D5027',
          '#CB9552',
          '#FFF2DB',
          '#D7B189',
          '#AB6C2E',
          '#9C530D',
        ],
        [0.004, 0.082, 0.38, 0.561, 0.804, 0.918, 0.957],
        -168.6,
        0,
        168.6,
        0,
      )
      .s()
      .p(
        'AqOYSQkviBjpjpQjqjqiAkvQiFk5AAlWQAAlVCFk6QCAkuDqjpQDpjqEviAQE5iFFWAAQFWAAE5CFQEuCADqDqQDpDpCAEuQCFE6AAFVQAAFWiFE5QiAEvjpDqQjqDpkuCBQk5CElWAAQlWAAk5iEgApg2hQkZB3jZDYQjZDZh3EZQh7EjAAE9QAAE+B7EjQB3EZDZDZQDZDZEZB2QEjB8E+AAQE+AAEih8QEZh2DZjZQDZjZB3kZQB7kjAAk+QAAk9h7kjQh3kZjZjZQjZjYkZh3Qkih8k+AAQk9AAkkB8g',
      );
    this.shape_27.setTransform(171.625, 171.6);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .lf(
        ['#EBC17D', '#EDD089', '#F4E8D9', '#C08329', '#EABE81'],
        [0.004, 0.184, 0.412, 0.729, 0.949],
        -88.8,
        153.8,
        93.5,
        -161.9,
      )
      .s()
      .p(
        'AqOYSQkviBjpjpQjqjqiAkvQiFk5AAlWQAAlVCFk6QCAkuDqjpQDpjqEviAQE5iFFWAAQFWAAE5CFQEuCADqDqQDpDpCAEuQCFE6AAFVQAAFWiFE5QiAEvjpDqQjqDpkuCBQk5CElWAAQlWAAk5iEg',
      );
    this.shape_28.setTransform(171.625, 171.6);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f('#FBAE33')
      .s()
      .p(
        'AqaYtQk0iCjujuQjujuiCk0QiHk/AAlcQAAlcCHk/QCCk0DujtQDujtE0iDQE/iHFcAAQFcAAE/CHQE0CDDtDtQDuDtCCE0QCHE/AAFcQAAFciHE/QiCE0juDuQjtDuk0CCQk/CHlcAAQlcAAk/iHgAqO4QQkvCAjpDqQjqDpiAEuQiFE6AAFVQAAFWCFE5QCAEvDqDqQDpDpEvCBQE5CEFWAAQFWAAE5iEQEuiBDqjpQDpjqCAkvQCFk5AAlWQAAlViFk6QiAkujpjpQjqjqkuiAQk5iFlWAAQlWAAk5CFg',
      );
    this.shape_29.setTransform(171.625, 171.6);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f('#FBAE33')
      .s()
      .p(
        'AqUYfQkxiBjsjsQjsjsiBkwQiGk9AAlZQAAlZCGk7QCBkyDsjrQDsjsExiBQE8iGFZAAQFZAAE8CGQExCBDsDsQDrDrCBEyQCGE7AAFZQAAFZiGE9QiBEwjrDsQjsDskxCBQk8CGlZAAQlZAAk8iGg',
      );
    this.shape_30.setTransform(171.625, 171.6);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 343.3, 343.2);

  (lib.gcbadge6xai = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // gc-badge-6x.ai
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p('AjjA7InkkNIFeiOIEeC4IBJlJIFaiMIicIXIIMEgIllCRIk4i7IheFeIliCQg');
    this.shape.setTransform(205.5, 163.4);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p(
        'AlxG/QhrhCg+iaQhbjjBmijQBnijEAhoQCWg9BigNQBhgMBMAVQBMAVA6A3IlUCqQgigrgngGQgpgHgvATQhWAjgZBMQgSA4AmCLQAvhDA6gvQA7gvBWgjQCrhFCVAhQCWAgAxB7QAiBRggBdQggBdhbBNQhZBMihBCQjABNiCADIgPAAQh8AAhlg+gAAEAGQhJAegjA4QgjA4AbBDQAbBEBEASQBCARBMgeQBGgdAgg1QAhg2gchFQgchHhAgQQgYgHgYAAQgqAAguARg',
      );
    this.shape_1.setTransform(104.9558, 202.3782);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p('AiLAwIAagyIBIAiIAphUIhIgkIAagzIC6BcIgaAyIhOglIgoBUIBNAmIgZA0g');
    this.shape_2.setTransform(285.1, 227.725);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p('AgwAMIgoA3IghgXIB1idIAfAZIgpA3ICHBkIgiAvg');
    this.shape_3.setTransform(271, 244.75);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p(
        'Ah/hKIA1g1IDKBcIgsArIgzgXIgzAyIAYAzIgpAqgAhOhKIAUAlIAVApIAngmIgqgVIglgTg',
      );
    this.shape_4.setTransform(263.2, 264.875);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        'AingZIBBgpIA6AuQAhAZAYAaIABgBIgShLIgOhKIA+goIB8CpIgwAeIguhBQgdgqgSgdIgBAAQALAqAIAqIARBUIgmAYIhBg2QgkgdgbgaIgBAAIAqBLIAnBFIgtAdg',
      );
    this.shape_5.setTransform(239.625, 279.575);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p(
        'AiBhGIBAgSIBHA6QAhAaAbAeIABAAQgOgfgPgyIgRg7IAzgPIA6DIIg6ARIhJg+QgngggYgaIgBABQAOApANAtIASA8IgzAPg',
      );
    this.shape_6.setTransform(206.575, 293.725);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics.f('#000000').s().p('AgrhjIA5gIIAeDOIg5AJg');
    this.shape_7.setTransform(189.175, 297.5);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#000000')
      .s()
      .p('AghBoIAEinIhEgCIABgoIDCAFIgBAoIhFgCIgFCog');
    this.shape_8.setTransform(168.125, 298.65);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#000000')
      .s()
      .p(
        'AgdBnQgrgIgagSIATgkQAaASAiAHQAnAHAEgWQACgKgIgIQgIgIgVgLQhBgfAHgqQAFgbAdgMQAdgNArAIQAkAHAaAQIgUAjQgXgPgcgFQgRgDgLAEQgJAEgCAIQgCAJAKAJQAHAHAZANQAgAPANASQANASgEAVQgFAcgcAMQgSAJgZAAQgQAAgUgEg',
      );
    this.shape_9.setTransform(147.425, 296.6146);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#000000')
      .s()
      .p(
        'AAMBtQgDgLADgoQACgUgGgKQgGgJgQgHIgQgGIgdBNIg1gTIBHjBQAeAGAqARQA2ATASAZQARAWgKAaQgGARgTAJQgQAIgTgBIAAAAQATAQgBAgIgBAmQgBATABAGgAgTgZIAVAIQAUAIAOgEQAOgEAFgNQAKgbgogOIgZgIg',
      );
    this.shape_10.setTransform(127.0986, 291.45);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics.f('#000000').s().p('AhIBQIBfi5IAyAbIheC4g');
    this.shape_11.setTransform(113, 284.6);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#000000')
      .s()
      .p('Ah6BHIB1itICABXIgWAfIhRg1IgaAmIBLAzIgVAgIhLgzIgvBGg');
    this.shape_12.setTransform(100.725, 274.625);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#000000')
      .s()
      .p(
        'AgHAnQgQgDgJgOQgJgOADgPQAEgQANgJQAOgJAPADQAQAEAJANQAJAOgDAPQgEAQgNAJQgKAHgLAAIgIgBg',
      );
    this.shape_13.setTransform(293.7269, 196.8269);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#000000')
      .s()
      .p('AhnA/IB7h3IiAAGIgDhFIDUgKIADBIIh1BxIB6gGIADBGIjUAJg');
    this.shape_14.setTransform(295.1, 166.25);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#000000')
      .s()
      .p(
        'AgtB6QgpgdgSg8QgTg6ARgwQASgxAugOQAtgOAqAdQAqAeASA7QATA7gSAwQgRAwguAOQgPAFgPAAQgdAAgdgUgAgVhFQgaAIgKAZQgLAZAKAeQAKAfAXAOQAXAOAYgIQAZgIALgYQAKgZgJgeQgKgggXgOQgOgJgPAAQgJAAgJADg',
      );
    this.shape_15.setTransform(289.6, 134.8886);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics.f('#000000').s().p('AhuATIC8hiIAgA9Ii7Big');
    this.shape_16.setTransform(281, 114.175);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#000000')
      .s()
      .p(
        'AA7B1QgggJgbgjIgmg0Ig6AsIgpg4ICph/IBRBsQAaAigBAhQgBAfgZASQgQANgUAAQgIAAgJgCgAgBgGIAhAsQAJALAKAEQALADAIgGQAJgHAAgLQAAgLgJgMIghgsg',
      );
    this.shape_17.setTransform(269.3541, 94.4353);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#000000')
      .s()
      .p('AAACHIBYhxIiNBHIgYgTIAkiaIhZBwIg3gqICEinIBLA7IgeCBIB2g7IBMA7IiECng');
    this.shape_18.setTransform(247.975, 74.375);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#000000')
      .s()
      .p('ABABqIAAgjIhmgsIgZAZIhGgdICvidIBRAiIALDrgAgDgIIBEAdIgBheg');
    this.shape_19.setTransform(215.175, 59.45);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#000000')
      .s()
      .p('AAnByIANhVIhtgRIgOBVIhEgLIAgjRIBFAKIgMBPIBtARIAMhPIBFAKIghDTg');
    this.shape_20.setTransform(190.05, 49.25);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#000000')
      .s()
      .p(
        'AhTBZQgsgcgFgwQgFgvAngjQAmgjA8gFQBTgIApA2Ig6AcQgIgNgQgHQgSgIgUACQgeADgTAUQgTATACAaQADAaAWAPQAWAQAfgDQAUgCAQgKQAOgKAGgOIA+ARQggA8hSAIIgUABQgvAAgkgWg',
      );
    this.shape_21.setTransform(160.2265, 48.2015);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#000000')
      .s()
      .p(
        'AiPg/IBmgvQA6gaAwAJQAyAKAUAsQAUAtgZAqQgZArg6AaIhmAvgAgUhCIgoASIAwBqIAngSQAfgOAMgZQAKgWgKgXQgKgXgYgHQgIgCgJAAQgTAAgUAKg',
      );
    this.shape_22.setTransform(119.1068, 60.5609);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#000000')
      .s()
      .p('AijgEIA3gtIChAcIhMhgIA2gsICFCmIg0AqIiogeIBPBlIg1Arg');
    this.shape_23.setTransform(93.775, 75.05);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f('#000000')
      .s()
      .p('AiNhGIA1hFIDmA0IguA7IgigJIhEBXIAQAeIgtA8gAgfAHIAtg6IhbgYg');
    this.shape_24.setTransform(76.725, 99.45);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f('#000000')
      .s()
      .p(
        'AiQAtIA5h4QATgoAdgOQAcgNAcANQAWALAJAXQAHATgEAXIBfgQIgjBGIhUAKIgQAgIBCAfIgeA/gAghhAQgKAFgHANIgXAxIArAUIAYgwQAGgNgCgLQgBgMgLgFQgEgCgEAAQgFAAgGAEg',
      );
    this.shape_25.setTransform(59.6, 119.2311);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f('#000000')
      .s()
      .p(
        'AgdCFQgxgKgVgxQgVguANg8QAQhMA4gaIAMA+QgNAGgKANQgKAOgEARQgGAfANAZQANAYAZAFQAZAGAWgRQAWgRAGggQAGgegIgWIgSgDIgMA7IgsgIIAah/IBRARQAgA3gPBFQgNA8glAiQgfAcgjAAQgKAAgLgCg',
      );
    this.shape_26.setTransform(50.2552, 146.2349);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .lf(
        [
          '#541513',
          '#8D5027',
          '#CB9552',
          '#FFF2DB',
          '#D7B189',
          '#AB6C2E',
          '#9C530D',
        ],
        [0.004, 0.082, 0.38, 0.561, 0.804, 0.918, 0.957],
        -168.6,
        0,
        168.6,
        0,
      )
      .s()
      .p(
        'AqOYSQkviBjpjpQjqjqiAkvQiFk5AAlWQAAlVCFk6QCAkuDqjpQDpjqEviAQE5iFFWAAQFWAAE5CFQEuCADqDqQDpDpCAEuQCFE6AAFVQAAFWiFE5QiAEvjpDqQjqDpkuCBQk5CElWAAQlWAAk5iEgApg2hQkZB3jZDYQjZDZh3EZQh7EjAAE9QAAE+B7EjQB3EZDZDZQDZDZEZB2QEjB8E+AAQE+AAEih8QEZh2DZjZQDZjZB3kZQB7kjAAk+QAAk9h7kjQh3kZjZjZQjZjYkZh3Qkih8k+AAQk9AAkkB8g',
      );
    this.shape_27.setTransform(171.625, 171.6);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .lf(
        ['#EBC17D', '#EDD089', '#F4E8D9', '#C08329', '#EABE81'],
        [0.004, 0.184, 0.412, 0.729, 0.949],
        -88.8,
        153.8,
        93.5,
        -161.9,
      )
      .s()
      .p(
        'AqOYSQkviBjpjpQjqjqiAkvQiFk5AAlWQAAlVCFk6QCAkuDqjpQDpjqEviAQE5iFFWAAQFWAAE5CFQEuCADqDqQDpDpCAEuQCFE6AAFVQAAFWiFE5QiAEvjpDqQjqDpkuCBQk5CElWAAQlWAAk5iEg',
      );
    this.shape_28.setTransform(171.625, 171.6);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f('#FBAE33')
      .s()
      .p(
        'AqaYtQk0iCjujuQjujuiCk0QiHk/AAlcQAAlcCHk/QCCk0DujtQDujtE0iDQE/iHFcAAQFcAAE/CHQE0CDDtDtQDuDtCCE0QCHE/AAFcQAAFciHE/QiCE0juDuQjtDuk0CCQk/CHlcAAQlcAAk/iHgAqO4QQkvCAjpDqQjqDpiAEuQiFE6AAFVQAAFWCFE5QCAEvDqDqQDpDpEvCBQE5CEFWAAQFWAAE5iEQEuiBDqjpQDpjqCAkvQCFk5AAlWQAAlViFk6QiAkujpjpQjqjqkuiAQk5iFlWAAQlWAAk5CFg',
      );
    this.shape_29.setTransform(171.625, 171.6);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f('#FBAE33')
      .s()
      .p(
        'AqUYfQkxiBjsjsQjsjsiBkwQiGk9AAlZQAAlZCGk7QCBkyDsjrQDsjsExiBQE8iGFZAAQFZAAE8CGQExCBDsDsQDrDrCBEyQCGE7AAFZQAAFZiGE9QiBEwjrDsQjsDskxCBQk8CGlZAAQlZAAk8iGg',
      );
    this.shape_30.setTransform(171.625, 171.6);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 343.3, 343.2);

  (lib.gcbadge5xai = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // gc-badge-5x.ai
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p('AjjA6InkkNIFeiNIEeC4IBJlJIFaiMIidIWIINEhIllCQIk4i6IhdFfIlkCPg');
    this.shape.setTransform(207.8, 161.75);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p(
        'AjpIvQhNgHg0gXQg3gYgxgxIFWioQAjA0A8AKQA6AKBBgaQBJgdAgg4QAhg4gehJQgfhLg9gPQg+gQhPAgQgxAUgqAkQgdAageAxIk0BbIhIntIM7lOIBLC5IowDjIAVCJQAwgoA4giQAzgfA5gXQC8hMCUAcQCUAdAuBzQAhBQgeBjQgeBkhfBTQhfBUitBGQh+AzhcATQhKAQg9AAIgigBg',
      );
    this.shape_1.setTransform(104.1575, 198.9679);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p('AiLAwIAagyIBIAiIAphUIhIgkIAagzIC6BcIgaAyIhOglIgoBUIBNAmIgZA0g');
    this.shape_2.setTransform(285.1, 227.725);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p('AgwAMIgoA3IghgXIB1idIAfAZIgpA3ICHBkIgiAvg');
    this.shape_3.setTransform(271, 244.75);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p(
        'Ah/hKIA1g1IDKBcIgsArIgzgXIgzAyIAYAzIgpAqgAhOhKIAUAlIAVApIAngmIgqgVIglgTg',
      );
    this.shape_4.setTransform(263.2, 264.875);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        'AingZIBBgpIA6AuQAhAZAYAaIABgBIgShLIgOhKIA+goIB8CpIgwAeIguhBQgdgqgSgdIgBAAQALAqAIAqIARBUIgmAYIhBg2QgkgdgbgaIgBAAIAqBLIAnBFIgtAdg',
      );
    this.shape_5.setTransform(239.625, 279.575);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p(
        'AiBhGIBAgSIBHA6QAhAaAbAeIABAAQgOgfgPgyIgRg7IAzgPIA6DIIg6ARIhJg+QgngggYgaIgBABQAOApANAtIASA8IgzAPg',
      );
    this.shape_6.setTransform(206.575, 293.725);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics.f('#000000').s().p('AgrhjIA5gIIAeDOIg5AJg');
    this.shape_7.setTransform(189.175, 297.5);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#000000')
      .s()
      .p('AghBoIAEinIhEgCIABgoIDCAFIgBAoIhFgCIgFCog');
    this.shape_8.setTransform(168.125, 298.65);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#000000')
      .s()
      .p(
        'AgdBnQgrgIgagSIATgkQAaASAiAHQAnAHAEgWQACgKgIgIQgIgIgVgLQhBgfAHgqQAFgbAdgMQAdgNArAIQAkAHAaAQIgUAjQgXgPgcgFQgRgDgLAEQgJAEgCAIQgCAJAKAJQAHAHAZANQAgAPANASQANASgEAVQgFAcgcAMQgSAJgZAAQgQAAgUgEg',
      );
    this.shape_9.setTransform(147.425, 296.6146);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#000000')
      .s()
      .p(
        'AAMBtQgDgLADgoQACgUgGgKQgGgJgQgHIgQgGIgdBNIg1gTIBHjBQAeAGAqARQA2ATASAZQARAWgKAaQgGARgTAJQgQAIgTgBIAAAAQATAQgBAgIgBAmQgBATABAGgAgTgZIAVAIQAUAIAOgEQAOgEAFgNQAKgbgogOIgZgIg',
      );
    this.shape_10.setTransform(127.0986, 291.45);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics.f('#000000').s().p('AhIBQIBfi5IAyAbIheC4g');
    this.shape_11.setTransform(113, 284.6);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#000000')
      .s()
      .p('Ah6BHIB1itICABXIgWAfIhRg1IgaAmIBLAzIgVAgIhLgzIgvBGg');
    this.shape_12.setTransform(100.725, 274.625);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#000000')
      .s()
      .p(
        'AgHAnQgQgDgJgOQgJgOADgPQAEgQANgJQAOgJAPADQAQAEAJANQAJAOgDAPQgEAQgNAJQgKAHgLAAIgIgBg',
      );
    this.shape_13.setTransform(293.7269, 196.8269);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#000000')
      .s()
      .p('AhnA/IB7h3IiAAGIgDhFIDUgKIADBIIh1BxIB6gGIADBGIjUAJg');
    this.shape_14.setTransform(295.1, 166.25);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#000000')
      .s()
      .p(
        'AgtB6QgpgdgSg8QgTg6ARgwQASgxAugOQAtgOAqAdQAqAeASA7QATA7gSAwQgRAwguAOQgPAFgPAAQgdAAgdgUgAgVhFQgaAIgKAZQgLAZAKAeQAKAfAXAOQAXAOAYgIQAZgIALgYQAKgZgJgeQgKgggXgOQgOgJgPAAQgJAAgJADg',
      );
    this.shape_15.setTransform(289.6, 134.8886);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics.f('#000000').s().p('AhuATIC8hiIAgA9Ii7Big');
    this.shape_16.setTransform(281, 114.175);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#000000')
      .s()
      .p(
        'AA7B1QgggJgbgjIgmg0Ig6AsIgpg4ICph/IBRBsQAaAigBAhQgBAfgZASQgQANgUAAQgIAAgJgCgAgBgGIAhAsQAJALAKAEQALADAIgGQAJgHAAgLQAAgLgJgMIghgsg',
      );
    this.shape_17.setTransform(269.3541, 94.4353);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#000000')
      .s()
      .p('AAACHIBYhxIiNBHIgYgTIAkiaIhZBwIg3gqICEinIBLA7IgeCBIB2g7IBMA7IiECng');
    this.shape_18.setTransform(247.975, 74.375);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#000000')
      .s()
      .p('ABABqIAAgjIhmgsIgZAZIhGgdICvidIBRAiIALDrgAgDgIIBEAdIgBheg');
    this.shape_19.setTransform(215.175, 59.45);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#000000')
      .s()
      .p('AAnByIANhVIhtgRIgOBVIhEgLIAgjRIBFAKIgMBPIBtARIAMhPIBFAKIghDTg');
    this.shape_20.setTransform(190.05, 49.25);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#000000')
      .s()
      .p(
        'AhTBZQgsgcgFgwQgFgvAngjQAmgjA8gFQBTgIApA2Ig6AcQgIgNgQgHQgSgIgUACQgeADgTAUQgTATACAaQADAaAWAPQAWAQAfgDQAUgCAQgKQAOgKAGgOIA+ARQggA8hSAIIgUABQgvAAgkgWg',
      );
    this.shape_21.setTransform(160.2265, 48.2015);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#000000')
      .s()
      .p(
        'AiPg/IBmgvQA6gaAwAJQAyAKAUAsQAUAtgZAqQgZArg6AaIhmAvgAgUhCIgoASIAwBqIAngSQAfgOAMgZQAKgWgKgXQgKgXgYgHQgIgCgJAAQgTAAgUAKg',
      );
    this.shape_22.setTransform(119.1068, 60.5609);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#000000')
      .s()
      .p('AijgEIA3gtIChAcIhMhgIA2gsICFCmIg0AqIiogeIBPBlIg1Arg');
    this.shape_23.setTransform(93.775, 75.05);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f('#000000')
      .s()
      .p('AiNhGIA1hFIDmA0IguA7IgigJIhEBXIAQAeIgtA8gAgfAHIAtg6IhbgYg');
    this.shape_24.setTransform(76.725, 99.45);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f('#000000')
      .s()
      .p(
        'AiQAtIA5h4QATgoAdgOQAcgNAcANQAWALAJAXQAHATgEAXIBfgQIgjBGIhUAKIgQAgIBCAfIgeA/gAghhAQgKAFgHANIgXAxIArAUIAYgwQAGgNgCgLQgBgMgLgFQgEgCgEAAQgFAAgGAEg',
      );
    this.shape_25.setTransform(59.6, 119.2311);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f('#000000')
      .s()
      .p(
        'AgdCFQgxgKgVgxQgVguANg8QAQhMA4gaIAMA+QgNAGgKANQgKAOgEARQgGAfANAZQANAYAZAFQAZAGAWgRQAWgRAGggQAGgegIgWIgSgDIgMA7IgsgIIAah/IBRARQAgA3gPBFQgNA8glAiQgfAcgjAAQgKAAgLgCg',
      );
    this.shape_26.setTransform(50.2552, 146.2349);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .lf(
        [
          '#541513',
          '#8D5027',
          '#CB9552',
          '#FFF2DB',
          '#D7B189',
          '#AB6C2E',
          '#9C530D',
        ],
        [0.004, 0.082, 0.38, 0.561, 0.804, 0.918, 0.957],
        -168.6,
        0,
        168.6,
        0,
      )
      .s()
      .p(
        'AqOYSQkviBjpjpQjqjqiAkvQiFk5AAlWQAAlVCFk6QCAkuDqjpQDpjqEviAQE5iFFWAAQFWAAE5CFQEuCADqDqQDpDpCAEuQCFE6AAFVQAAFWiFE5QiAEvjpDqQjqDpkuCBQk5CElWAAQlWAAk5iEgApg2hQkZB3jZDYQjZDZh3EZQh7EjAAE9QAAE+B7EjQB3EZDZDZQDZDZEZB2QEjB8E+AAQE+AAEih8QEZh2DZjZQDZjZB3kZQB7kjAAk+QAAk9h7kjQh3kZjZjZQjZjYkZh3Qkih8k+AAQk9AAkkB8g',
      );
    this.shape_27.setTransform(171.625, 171.6);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .lf(
        ['#EBC17D', '#EDD089', '#F4E8D9', '#C08329', '#EABE81'],
        [0.004, 0.184, 0.412, 0.729, 0.949],
        -88.8,
        153.8,
        93.5,
        -161.9,
      )
      .s()
      .p(
        'AqOYSQkviBjpjpQjqjqiAkvQiFk5AAlWQAAlVCFk6QCAkuDqjpQDpjqEviAQE5iFFWAAQFWAAE5CFQEuCADqDqQDpDpCAEuQCFE6AAFVQAAFWiFE5QiAEvjpDqQjqDpkuCBQk5CElWAAQlWAAk5iEg',
      );
    this.shape_28.setTransform(171.625, 171.6);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f('#FBAE33')
      .s()
      .p(
        'AqaYtQk0iCjujuQjujuiCk0QiHk/AAlcQAAlcCHk/QCCk0DujtQDujtE0iDQE/iHFcAAQFcAAE/CHQE0CDDtDtQDuDtCCE0QCHE/AAFcQAAFciHE/QiCE0juDuQjtDuk0CCQk/CHlcAAQlcAAk/iHgAqO4QQkvCAjpDqQjqDpiAEuQiFE6AAFVQAAFWCFE5QCAEvDqDqQDpDpEvCBQE5CEFWAAQFWAAE5iEQEuiBDqjpQDpjqCAkvQCFk5AAlWQAAlViFk6QiAkujpjpQjqjqkuiAQk5iFlWAAQlWAAk5CFg',
      );
    this.shape_29.setTransform(171.625, 171.6);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f('#FBAE33')
      .s()
      .p(
        'AqUYfQkxiBjsjsQjsjsiBkwQiGk9AAlZQAAlZCGk7QCBkyDsjrQDsjsExiBQE8iGFZAAQFZAAE8CGQExCBDsDsQDrDrCBEyQCGE7AAFZQAAFZiGE9QiBEwjrDsQjsDskxCBQk8CGlZAAQlZAAk8iGg',
      );
    this.shape_30.setTransform(171.625, 171.6);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 343.3, 343.2);

  (lib.gcbadge4xai = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // gc-badge-4x.ai
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p('AjTA1InMkXIFEiCIERC9IA8lEIFAiCIiFINIHzErIlLCGIkpjBIhOFZIlJCFg');
    this.shape.setTransform(207.525, 161.9);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p(
        'ApGFYIGsr1IEsh5IDQICICcg/IBJCzIidA/IBACcIkuB6Ig/idIp1EAgAkYDrIFMiHIhpkGg',
      );
    this.shape_1.setTransform(110.55, 197.25);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p('AiLAwIAagyIBIAiIAphUIhIgkIAagzIC6BcIgaAyIhOglIgoBUIBNAmIgZA0g');
    this.shape_2.setTransform(285.1, 227.725);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p('AgwAMIgoA3IghgXIB1idIAfAZIgpA3ICHBkIgiAvg');
    this.shape_3.setTransform(271, 244.75);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p(
        'Ah/hKIA1g1IDKBcIgsArIgzgXIgzAyIAYAzIgpAqgAhOhKIAUAlIAVApIAngmIgqgVIglgTg',
      );
    this.shape_4.setTransform(263.2, 264.875);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        'AingZIBBgpIA6AuQAhAZAYAaIABgBIgShLIgOhKIA+goIB8CpIgwAeIguhBQgdgqgSgdIgBAAQALAqAIAqIARBUIgmAYIhBg2QgkgdgbgaIgBAAIAqBLIAnBFIgtAdg',
      );
    this.shape_5.setTransform(239.625, 279.575);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p(
        'AiBhGIBAgSIBHA6QAhAaAbAeIABAAQgOgfgPgyIgRg7IAzgPIA6DIIg6ARIhJg+QgngggYgaIgBABQAOApANAtIASA8IgzAPg',
      );
    this.shape_6.setTransform(206.575, 293.725);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics.f('#000000').s().p('AgrhjIA5gIIAeDOIg5AJg');
    this.shape_7.setTransform(189.175, 297.5);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#000000')
      .s()
      .p('AghBoIAEinIhEgCIABgoIDCAFIgBAoIhFgCIgFCog');
    this.shape_8.setTransform(168.125, 298.65);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#000000')
      .s()
      .p(
        'AgdBnQgrgIgagSIATgkQAaASAiAHQAnAHAEgWQACgKgIgIQgIgIgVgLQhBgfAHgqQAFgbAdgMQAdgNArAIQAkAHAaAQIgUAjQgXgPgcgFQgRgDgLAEQgJAEgCAIQgCAJAKAJQAHAHAZANQAgAPANASQANASgEAVQgFAcgcAMQgSAJgZAAQgQAAgUgEg',
      );
    this.shape_9.setTransform(147.425, 296.6146);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#000000')
      .s()
      .p(
        'AAMBtQgDgLADgoQACgUgGgKQgGgJgQgHIgQgGIgdBNIg1gTIBHjBQAeAGAqARQA2ATASAZQARAWgKAaQgGARgTAJQgQAIgTgBIAAAAQATAQgBAgIgBAmQgBATABAGgAgTgZIAVAIQAUAIAOgEQAOgEAFgNQAKgbgogOIgZgIg',
      );
    this.shape_10.setTransform(127.0986, 291.45);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics.f('#000000').s().p('AhIBQIBfi5IAyAbIheC4g');
    this.shape_11.setTransform(113, 284.6);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#000000')
      .s()
      .p('Ah6BHIB1itICABXIgWAfIhRg1IgaAmIBLAzIgVAgIhLgzIgvBGg');
    this.shape_12.setTransform(100.725, 274.625);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#000000')
      .s()
      .p(
        'AgHAnQgQgDgJgOQgJgOADgPQAEgQANgJQAOgJAPADQAQAEAJANQAJAOgDAPQgEAQgNAJQgKAHgLAAIgIgBg',
      );
    this.shape_13.setTransform(293.7269, 196.8269);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#000000')
      .s()
      .p('AhnA/IB7h3IiAAGIgDhFIDUgKIADBIIh1BxIB6gGIADBGIjUAJg');
    this.shape_14.setTransform(295.1, 166.25);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#000000')
      .s()
      .p(
        'AgtB6QgpgdgSg8QgTg6ARgwQASgxAugOQAtgOAqAdQAqAeASA7QATA7gSAwQgRAwguAOQgPAFgPAAQgdAAgdgUgAgVhFQgaAIgKAZQgLAZAKAeQAKAfAXAOQAXAOAYgIQAZgIALgYQAKgZgJgeQgKgggXgOQgOgJgPAAQgJAAgJADg',
      );
    this.shape_15.setTransform(289.6, 134.8886);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics.f('#000000').s().p('AhuATIC8hiIAgA9Ii7Big');
    this.shape_16.setTransform(281, 114.175);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#000000')
      .s()
      .p(
        'AA7B1QgggJgbgjIgmg0Ig6AsIgpg4ICph/IBRBsQAaAigBAhQgBAfgZASQgQANgUAAQgIAAgJgCgAgBgGIAhAsQAJALAKAEQALADAIgGQAJgHAAgLQAAgLgJgMIghgsg',
      );
    this.shape_17.setTransform(269.3541, 94.4353);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#000000')
      .s()
      .p('AAACHIBYhxIiNBHIgYgTIAkiaIhZBwIg3gqICEinIBLA7IgeCBIB2g7IBMA7IiECng');
    this.shape_18.setTransform(247.975, 74.375);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#000000')
      .s()
      .p('ABABqIAAgjIhmgsIgZAZIhGgdICvidIBRAiIALDrgAgDgIIBEAdIgBheg');
    this.shape_19.setTransform(215.175, 59.45);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#000000')
      .s()
      .p('AAnByIANhVIhtgRIgOBVIhEgLIAgjRIBFAKIgMBPIBtARIAMhPIBFAKIghDTg');
    this.shape_20.setTransform(190.05, 49.25);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#000000')
      .s()
      .p(
        'AhTBZQgsgcgFgwQgFgvAngjQAmgjA8gFQBTgIApA2Ig6AcQgIgNgQgHQgSgIgUACQgeADgTAUQgTATACAaQADAaAWAPQAWAQAfgDQAUgCAQgKQAOgKAGgOIA+ARQggA8hSAIIgUABQgvAAgkgWg',
      );
    this.shape_21.setTransform(160.2265, 48.2015);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#000000')
      .s()
      .p(
        'AiPg/IBmgvQA6gaAwAJQAyAKAUAsQAUAtgZAqQgZArg6AaIhmAvgAgUhCIgoASIAwBqIAngSQAfgOAMgZQAKgWgKgXQgKgXgYgHQgIgCgJAAQgTAAgUAKg',
      );
    this.shape_22.setTransform(119.1068, 60.5609);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#000000')
      .s()
      .p('AijgEIA3gtIChAcIhMhgIA2gsICFCmIg0AqIiogeIBPBlIg1Arg');
    this.shape_23.setTransform(93.775, 75.05);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f('#000000')
      .s()
      .p('AiNhGIA1hFIDmA0IguA7IgigJIhEBXIAQAeIgtA8gAgfAHIAtg6IhbgYg');
    this.shape_24.setTransform(76.725, 99.45);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f('#000000')
      .s()
      .p(
        'AiQAtIA5h4QATgoAdgOQAcgNAcANQAWALAJAXQAHATgEAXIBfgQIgjBGIhUAKIgQAgIBCAfIgeA/gAghhAQgKAFgHANIgXAxIArAUIAYgwQAGgNgCgLQgBgMgLgFQgEgCgEAAQgFAAgGAEg',
      );
    this.shape_25.setTransform(59.6, 119.2311);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f('#000000')
      .s()
      .p(
        'AgdCFQgxgKgVgxQgVguANg8QAQhMA4gaIAMA+QgNAGgKANQgKAOgEARQgGAfANAZQANAYAZAFQAZAGAWgRQAWgRAGggQAGgegIgWIgSgDIgMA7IgsgIIAah/IBRARQAgA3gPBFQgNA8glAiQgfAcgjAAQgKAAgLgCg',
      );
    this.shape_26.setTransform(50.2552, 146.2349);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .lf(
        [
          '#541513',
          '#8D5027',
          '#CB9552',
          '#FFF2DB',
          '#D7B189',
          '#AB6C2E',
          '#9C530D',
        ],
        [0.004, 0.082, 0.38, 0.561, 0.804, 0.918, 0.957],
        -168.6,
        0,
        168.6,
        0,
      )
      .s()
      .p(
        'AqOYSQkviBjpjpQjqjqiAkvQiFk5AAlWQAAlVCFk6QCAkuDqjpQDpjqEviAQE5iFFWAAQFWAAE5CFQEuCADqDqQDpDpCAEuQCFE6AAFVQAAFWiFE5QiAEvjpDqQjqDpkuCBQk5CElWAAQlWAAk5iEgApg2hQkZB3jZDYQjZDZh3EZQh7EjAAE9QAAE+B7EjQB3EZDZDZQDZDZEZB2QEjB8E+AAQE+AAEih8QEZh2DZjZQDZjZB3kZQB7kjAAk+QAAk9h7kjQh3kZjZjZQjZjYkZh3Qkih8k+AAQk9AAkkB8g',
      );
    this.shape_27.setTransform(171.625, 171.6);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .lf(
        ['#EBC17D', '#EDD089', '#F4E8D9', '#C08329', '#EABE81'],
        [0.004, 0.184, 0.412, 0.729, 0.949],
        -88.8,
        153.8,
        93.5,
        -161.9,
      )
      .s()
      .p(
        'AqOYSQkviBjpjpQjqjqiAkvQiFk5AAlWQAAlVCFk6QCAkuDqjpQDpjqEviAQE5iFFWAAQFWAAE5CFQEuCADqDqQDpDpCAEuQCFE6AAFVQAAFWiFE5QiAEvjpDqQjqDpkuCBQk5CElWAAQlWAAk5iEg',
      );
    this.shape_28.setTransform(171.625, 171.6);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f('#FBAE33')
      .s()
      .p(
        'AqaYtQk0iCjujuQjujuiCk0QiHk/AAlcQAAlcCHk/QCCk0DujtQDujtE0iDQE/iHFcAAQFcAAE/CHQE0CDDtDtQDuDtCCE0QCHE/AAFcQAAFciHE/QiCE0juDuQjtDuk0CCQk/CHlcAAQlcAAk/iHgAqO4QQkvCAjpDqQjqDpiAEuQiFE6AAFVQAAFWCFE5QCAEvDqDqQDpDpEvCBQE5CEFWAAQFWAAE5iEQEuiBDqjpQDpjqCAkvQCFk5AAlWQAAlViFk6QiAkujpjpQjqjqkuiAQk5iFlWAAQlWAAk5CFg',
      );
    this.shape_29.setTransform(171.625, 171.6);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f('#FBAE33')
      .s()
      .p(
        'AqUYfQkxiBjsjsQjsjsiBkwQiGk9AAlZQAAlZCGk7QCBkyDsjrQDsjsExiBQE8iGFZAAQFZAAE8CGQExCBDsDsQDrDrCBEyQCGE7AAFZQAAFZiGE9QiBEwjrDsQjsDskxCBQk8CGlZAAQlZAAk8iGg',
      );
    this.shape_30.setTransform(171.625, 171.6);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 343.3, 343.2);

  (lib.gcbadge3xai = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // gc-badge-3x.ai
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p('AjjA7InkkOIFeiNIEeC4IBJlJIFaiMIidIWIINEhIllCQIk4i6IhdFfIlkCPg');
    this.shape.setTransform(206, 162.55);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p(
        'Ak0H3QhXgZhDhAIFeixQAxA+A4AJQA3AJBGgdQBJgdAig2QAjg2gXg5QgYg6g7gNQg8gNhQAgQgpARhGAtIgwitQAdgJATgHQBHgdAjgwQAjgxgPgoQgQgmgsgIQgsgJg/AZQhAAbgeAoQgeAqALBDIlmBjQAAh6BjhpQBjhpDehaQD9hnCMAPQCLAPAlBdQAWA2gdA+QgcBAhQBGQBPgTAwAAQBLAAA1AbQA1AcAYA5QAdBJggBaQghBbhiBSQhhBSi2BJQi0BJhvAOQgrAGgnAAQhAAAg3gQg',
      );
    this.shape_1.setTransform(105.5393, 202.1109);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p('AiLAwIAagyIBIAiIAphUIhIgkIAagzIC6BcIgaAyIhOglIgoBUIBNAmIgZA0g');
    this.shape_2.setTransform(285.1, 227.725);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p('AgwAMIgoA3IghgXIB1idIAfAZIgpA3ICHBkIgiAvg');
    this.shape_3.setTransform(271, 244.75);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p(
        'Ah/hKIA1g1IDKBcIgsArIgzgXIgzAyIAYAzIgpAqgAhOhKIAUAlIAVApIAngmIgqgVIglgTg',
      );
    this.shape_4.setTransform(263.2, 264.875);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        'AingZIBBgpIA6AuQAhAZAYAaIABgBIgShLIgOhKIA+goIB8CpIgwAeIguhBQgdgqgSgdIgBAAQALAqAIAqIARBUIgmAYIhBg2QgkgdgbgaIgBAAIAqBLIAnBFIgtAdg',
      );
    this.shape_5.setTransform(239.625, 279.575);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p(
        'AiBhGIBAgSIBHA6QAhAaAbAeIABAAQgOgfgPgyIgRg7IAzgPIA6DIIg6ARIhJg+QgngggYgaIgBABQAOApANAtIASA8IgzAPg',
      );
    this.shape_6.setTransform(206.575, 293.725);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics.f('#000000').s().p('AgrhjIA5gIIAeDOIg5AJg');
    this.shape_7.setTransform(189.175, 297.5);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#000000')
      .s()
      .p('AghBoIAEinIhEgCIABgoIDCAFIgBAoIhFgCIgFCog');
    this.shape_8.setTransform(168.125, 298.65);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#000000')
      .s()
      .p(
        'AgdBnQgrgIgagSIATgkQAaASAiAHQAnAHAEgWQACgKgIgIQgIgIgVgLQhBgfAHgqQAFgbAdgMQAdgNArAIQAkAHAaAQIgUAjQgXgPgcgFQgRgDgLAEQgJAEgCAIQgCAJAKAJQAHAHAZANQAgAPANASQANASgEAVQgFAcgcAMQgSAJgZAAQgQAAgUgEg',
      );
    this.shape_9.setTransform(147.425, 296.6146);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#000000')
      .s()
      .p(
        'AAMBtQgDgLADgoQACgUgGgKQgGgJgQgHIgQgGIgdBNIg1gTIBHjBQAeAGAqARQA2ATASAZQARAWgKAaQgGARgTAJQgQAIgTgBIAAAAQATAQgBAgIgBAmQgBATABAGgAgTgZIAVAIQAUAIAOgEQAOgEAFgNQAKgbgogOIgZgIg',
      );
    this.shape_10.setTransform(127.0986, 291.45);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics.f('#000000').s().p('AhIBQIBfi5IAyAbIheC4g');
    this.shape_11.setTransform(113, 284.6);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#000000')
      .s()
      .p('Ah6BHIB1itICABXIgWAfIhRg1IgaAmIBLAzIgVAgIhLgzIgvBGg');
    this.shape_12.setTransform(100.725, 274.625);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#000000')
      .s()
      .p(
        'AgHAnQgQgDgJgOQgJgOADgPQAEgQANgJQAOgJAPADQAQAEAJANQAJAOgDAPQgEAQgNAJQgKAHgLAAIgIgBg',
      );
    this.shape_13.setTransform(293.7269, 196.8269);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#000000')
      .s()
      .p('AhnA/IB7h3IiAAGIgDhFIDUgKIADBIIh1BxIB6gGIADBGIjUAJg');
    this.shape_14.setTransform(295.1, 166.25);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#000000')
      .s()
      .p(
        'AgtB6QgpgdgSg8QgTg6ARgwQASgxAugOQAtgOAqAdQAqAeASA7QATA7gSAwQgRAwguAOQgPAFgPAAQgdAAgdgUgAgVhFQgaAIgKAZQgLAZAKAeQAKAfAXAOQAXAOAYgIQAZgIALgYQAKgZgJgeQgKgggXgOQgOgJgPAAQgJAAgJADg',
      );
    this.shape_15.setTransform(289.6, 134.8886);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics.f('#000000').s().p('AhuATIC8hiIAgA9Ii7Big');
    this.shape_16.setTransform(281, 114.175);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#000000')
      .s()
      .p(
        'AA7B1QgggJgbgjIgmg0Ig6AsIgpg4ICph/IBRBsQAaAigBAhQgBAfgZASQgQANgUAAQgIAAgJgCgAgBgGIAhAsQAJALAKAEQALADAIgGQAJgHAAgLQAAgLgJgMIghgsg',
      );
    this.shape_17.setTransform(269.3541, 94.4353);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#000000')
      .s()
      .p('AAACHIBYhxIiNBHIgYgTIAkiaIhZBwIg3gqICEinIBLA7IgeCBIB2g7IBMA7IiECng');
    this.shape_18.setTransform(247.975, 74.375);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#000000')
      .s()
      .p('ABABqIAAgjIhmgsIgZAZIhGgdICvidIBRAiIALDrgAgDgIIBEAdIgBheg');
    this.shape_19.setTransform(215.175, 59.45);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#000000')
      .s()
      .p('AAnByIANhVIhtgRIgOBVIhEgLIAgjRIBFAKIgMBPIBtARIAMhPIBFAKIghDTg');
    this.shape_20.setTransform(190.05, 49.25);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#000000')
      .s()
      .p(
        'AhTBZQgsgcgFgwQgFgvAngjQAmgjA8gFQBTgIApA2Ig6AcQgIgNgQgHQgSgIgUACQgeADgTAUQgTATACAaQADAaAWAPQAWAQAfgDQAUgCAQgKQAOgKAGgOIA+ARQggA8hSAIIgUABQgvAAgkgWg',
      );
    this.shape_21.setTransform(160.2265, 48.2015);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#000000')
      .s()
      .p(
        'AiPg/IBmgvQA6gaAwAJQAyAKAUAsQAUAtgZAqQgZArg6AaIhmAvgAgUhCIgoASIAwBqIAngSQAfgOAMgZQAKgWgKgXQgKgXgYgHQgIgCgJAAQgTAAgUAKg',
      );
    this.shape_22.setTransform(119.1068, 60.5609);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#000000')
      .s()
      .p('AijgEIA3gtIChAcIhMhgIA2gsICFCmIg0AqIiogeIBPBlIg1Arg');
    this.shape_23.setTransform(93.775, 75.05);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f('#000000')
      .s()
      .p('AiNhGIA1hFIDmA0IguA7IgigJIhEBXIAQAeIgtA8gAgfAHIAtg6IhbgYg');
    this.shape_24.setTransform(76.725, 99.45);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f('#000000')
      .s()
      .p(
        'AiQAtIA5h4QATgoAdgOQAcgNAcANQAWALAJAXQAHATgEAXIBfgQIgjBGIhUAKIgQAgIBCAfIgeA/gAghhAQgKAFgHANIgXAxIArAUIAYgwQAGgNgCgLQgBgMgLgFQgEgCgEAAQgFAAgGAEg',
      );
    this.shape_25.setTransform(59.6, 119.2311);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f('#000000')
      .s()
      .p(
        'AgdCFQgxgKgVgxQgVguANg8QAQhMA4gaIAMA+QgNAGgKANQgKAOgEARQgGAfANAZQANAYAZAFQAZAGAWgRQAWgRAGggQAGgegIgWIgSgDIgMA7IgsgIIAah/IBRARQAgA3gPBFQgNA8glAiQgfAcgjAAQgKAAgLgCg',
      );
    this.shape_26.setTransform(50.2552, 146.2349);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .lf(
        [
          '#541513',
          '#8D5027',
          '#CB9552',
          '#FFF2DB',
          '#D7B189',
          '#AB6C2E',
          '#9C530D',
        ],
        [0.004, 0.082, 0.38, 0.561, 0.804, 0.918, 0.957],
        -168.6,
        0,
        168.6,
        0,
      )
      .s()
      .p(
        'AqOYSQkviBjpjpQjqjqiAkvQiFk5AAlWQAAlVCFk6QCAkuDqjpQDpjqEviAQE5iFFWAAQFWAAE5CFQEuCADqDqQDpDpCAEuQCFE6AAFVQAAFWiFE5QiAEvjpDqQjqDpkuCBQk5CElWAAQlWAAk5iEgApg2hQkZB3jZDYQjZDZh3EZQh7EjAAE9QAAE+B7EjQB3EZDZDZQDZDZEZB2QEjB8E+AAQE+AAEih8QEZh2DZjZQDZjZB3kZQB7kjAAk+QAAk9h7kjQh3kZjZjZQjZjYkZh3Qkih8k+AAQk9AAkkB8g',
      );
    this.shape_27.setTransform(171.625, 171.6);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .lf(
        ['#EBC17D', '#EDD089', '#F4E8D9', '#C08329', '#EABE81'],
        [0.004, 0.184, 0.412, 0.729, 0.949],
        -88.8,
        153.8,
        93.5,
        -161.9,
      )
      .s()
      .p(
        'AqOYSQkviBjpjpQjqjqiAkvQiFk5AAlWQAAlVCFk6QCAkuDqjpQDpjqEviAQE5iFFWAAQFWAAE5CFQEuCADqDqQDpDpCAEuQCFE6AAFVQAAFWiFE5QiAEvjpDqQjqDpkuCBQk5CElWAAQlWAAk5iEg',
      );
    this.shape_28.setTransform(171.625, 171.6);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f('#FBAE33')
      .s()
      .p(
        'AqaYtQk0iCjujuQjujuiCk0QiHk/AAlcQAAlcCHk/QCCk0DujtQDujtE0iDQE/iHFcAAQFcAAE/CHQE0CDDtDtQDuDtCCE0QCHE/AAFcQAAFciHE/QiCE0juDuQjtDuk0CCQk/CHlcAAQlcAAk/iHgAqO4QQkvCAjpDqQjqDpiAEuQiFE6AAFVQAAFWCFE5QCAEvDqDqQDpDpEvCBQE5CEFWAAQFWAAE5iEQEuiBDqjpQDpjqCAkvQCFk5AAlWQAAlViFk6QiAkujpjpQjqjqkuiAQk5iFlWAAQlWAAk5CFg',
      );
    this.shape_29.setTransform(171.625, 171.6);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f('#FBAE33')
      .s()
      .p(
        'AqUYfQkxiBjsjsQjsjsiBkwQiGk9AAlZQAAlZCGk7QCBkyDsjrQDsjsExiBQE8iGFZAAQFZAAE8CGQExCBDsDsQDrDrCBEyQCGE7AAFZQAAFZiGE9QiBEwjrDsQjsDskxCBQk8CGlZAAQlZAAk8iGg',
      );
    this.shape_30.setTransform(171.625, 171.6);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 343.3, 343.2);

  (lib.gcbadge2xai = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // gc-badge-2x.ai
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p('AjiA7InlkNIFeiOIEeC3IBKlIIFZiMIicIWIIMEhIllCQIk3i6IhfFeIliCQg');
    this.shape.setTransform(207.3, 160.7);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p(
        'AlzFRQA0h/DCjdQB2iIAZg5QAag4gOgjQgQgngzgKQg1gKg+AZQhBAageAtQgeAsAPBNIlbB2QgUhpAfhOQAghNBUhEQBVhECshGQC1hIBsgMQBugMBRAiQBRAkAdBHQAeBMglBhQgmBhiKCXQhUBbgZAgQgcAhghAyIISjVIBMC9Iv5GbQgYhvA0h+g',
      );
    this.shape_1.setTransform(108.1828, 206.8952);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p('AiLAwIAagyIBIAiIAphUIhIgkIAagzIC6BcIgaAyIhOglIgoBUIBNAmIgZA0g');
    this.shape_2.setTransform(285.1, 227.725);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p('AgwAMIgoA3IghgXIB1idIAfAZIgpA3ICHBkIgiAvg');
    this.shape_3.setTransform(271, 244.75);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p(
        'Ah/hKIA1g1IDKBcIgsArIgzgXIgzAyIAYAzIgpAqgAhOhKIAUAlIAVApIAngmIgqgVIglgTg',
      );
    this.shape_4.setTransform(263.2, 264.875);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        'AingZIBBgpIA6AuQAhAZAYAaIABgBIgShLIgOhKIA+goIB8CpIgwAeIguhBQgdgqgSgdIgBAAQALAqAIAqIARBUIgmAYIhBg2QgkgdgbgaIgBAAIAqBLIAnBFIgtAdg',
      );
    this.shape_5.setTransform(239.625, 279.575);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p(
        'AiBhGIBAgSIBHA6QAhAaAbAeIABAAQgOgfgPgyIgRg7IAzgPIA6DIIg6ARIhJg+QgngggYgaIgBABQAOApANAtIASA8IgzAPg',
      );
    this.shape_6.setTransform(206.575, 293.725);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics.f('#000000').s().p('AgrhjIA5gIIAeDOIg5AJg');
    this.shape_7.setTransform(189.175, 297.5);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#000000')
      .s()
      .p('AghBoIAEinIhEgCIABgoIDCAFIgBAoIhFgCIgFCog');
    this.shape_8.setTransform(168.125, 298.65);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#000000')
      .s()
      .p(
        'AgdBnQgrgIgagSIATgkQAaASAiAHQAnAHAEgWQACgKgIgIQgIgIgVgLQhBgfAHgqQAFgbAdgMQAdgNArAIQAkAHAaAQIgUAjQgXgPgcgFQgRgDgLAEQgJAEgCAIQgCAJAKAJQAHAHAZANQAgAPANASQANASgEAVQgFAcgcAMQgSAJgZAAQgQAAgUgEg',
      );
    this.shape_9.setTransform(147.425, 296.6146);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#000000')
      .s()
      .p(
        'AAMBtQgDgLADgoQACgUgGgKQgGgJgQgHIgQgGIgdBNIg1gTIBHjBQAeAGAqARQA2ATASAZQARAWgKAaQgGARgTAJQgQAIgTgBIAAAAQATAQgBAgIgBAmQgBATABAGgAgTgZIAVAIQAUAIAOgEQAOgEAFgNQAKgbgogOIgZgIg',
      );
    this.shape_10.setTransform(127.0986, 291.45);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics.f('#000000').s().p('AhIBQIBfi5IAyAbIheC4g');
    this.shape_11.setTransform(113, 284.6);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#000000')
      .s()
      .p('Ah6BHIB1itICABXIgWAfIhRg1IgaAmIBLAzIgVAgIhLgzIgvBGg');
    this.shape_12.setTransform(100.725, 274.625);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#000000')
      .s()
      .p(
        'AgHAnQgQgDgJgOQgJgOADgPQAEgQANgJQAOgJAPADQAQAEAJANQAJAOgDAPQgEAQgNAJQgKAHgLAAIgIgBg',
      );
    this.shape_13.setTransform(293.7269, 196.8269);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#000000')
      .s()
      .p('AhnA/IB7h3IiAAGIgDhFIDUgKIADBIIh1BxIB6gGIADBGIjUAJg');
    this.shape_14.setTransform(295.1, 166.25);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#000000')
      .s()
      .p(
        'AgtB6QgpgdgSg8QgTg6ARgwQASgxAugOQAtgOAqAdQAqAeASA7QATA7gSAwQgRAwguAOQgPAFgPAAQgdAAgdgUgAgVhFQgaAIgKAZQgLAZAKAeQAKAfAXAOQAXAOAYgIQAZgIALgYQAKgZgJgeQgKgggXgOQgOgJgPAAQgJAAgJADg',
      );
    this.shape_15.setTransform(289.6, 134.8886);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics.f('#000000').s().p('AhuATIC8hiIAgA9Ii7Big');
    this.shape_16.setTransform(281, 114.175);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#000000')
      .s()
      .p(
        'AA7B1QgggJgbgjIgmg0Ig6AsIgpg4ICph/IBRBsQAaAigBAhQgBAfgZASQgQANgUAAQgIAAgJgCgAgBgGIAhAsQAJALAKAEQALADAIgGQAJgHAAgLQAAgLgJgMIghgsg',
      );
    this.shape_17.setTransform(269.3541, 94.4353);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#000000')
      .s()
      .p('AAACHIBYhxIiNBHIgYgTIAkiaIhZBwIg3gqICEinIBLA7IgeCBIB2g7IBMA7IiECng');
    this.shape_18.setTransform(247.975, 74.375);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#000000')
      .s()
      .p('ABABqIAAgjIhmgsIgZAZIhGgdICvidIBRAiIALDrgAgDgIIBEAdIgBheg');
    this.shape_19.setTransform(215.175, 59.45);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#000000')
      .s()
      .p('AAnByIANhVIhtgRIgOBVIhEgLIAgjRIBFAKIgMBPIBtARIAMhPIBFAKIghDTg');
    this.shape_20.setTransform(190.05, 49.25);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#000000')
      .s()
      .p(
        'AhTBZQgsgcgFgwQgFgvAngjQAmgjA8gFQBTgIApA2Ig6AcQgIgNgQgHQgSgIgUACQgeADgTAUQgTATACAaQADAaAWAPQAWAQAfgDQAUgCAQgKQAOgKAGgOIA+ARQggA8hSAIIgUABQgvAAgkgWg',
      );
    this.shape_21.setTransform(160.2265, 48.2015);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#000000')
      .s()
      .p(
        'AiPg/IBmgvQA6gaAwAJQAyAKAUAsQAUAtgZAqQgZArg6AaIhmAvgAgUhCIgoASIAwBqIAngSQAfgOAMgZQAKgWgKgXQgKgXgYgHQgIgCgJAAQgTAAgUAKg',
      );
    this.shape_22.setTransform(119.1068, 60.5609);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#000000')
      .s()
      .p('AijgEIA3gtIChAcIhMhgIA2gsICFCmIg0AqIiogeIBPBlIg1Arg');
    this.shape_23.setTransform(93.775, 75.05);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f('#000000')
      .s()
      .p('AiNhGIA1hFIDmA0IguA7IgigJIhEBXIAQAeIgtA8gAgfAHIAtg6IhbgYg');
    this.shape_24.setTransform(76.725, 99.45);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f('#000000')
      .s()
      .p(
        'AiQAtIA5h4QATgoAdgOQAcgNAcANQAWALAJAXQAHATgEAXIBfgQIgjBGIhUAKIgQAgIBCAfIgeA/gAghhAQgKAFgHANIgXAxIArAUIAYgwQAGgNgCgLQgBgMgLgFQgEgCgEAAQgFAAgGAEg',
      );
    this.shape_25.setTransform(59.6, 119.2311);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f('#000000')
      .s()
      .p(
        'AgdCFQgxgKgVgxQgVguANg8QAQhMA4gaIAMA+QgNAGgKANQgKAOgEARQgGAfANAZQANAYAZAFQAZAGAWgRQAWgRAGggQAGgegIgWIgSgDIgMA7IgsgIIAah/IBRARQAgA3gPBFQgNA8glAiQgfAcgjAAQgKAAgLgCg',
      );
    this.shape_26.setTransform(50.2552, 146.2349);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .lf(
        [
          '#541513',
          '#8D5027',
          '#CB9552',
          '#FFF2DB',
          '#D7B189',
          '#AB6C2E',
          '#9C530D',
        ],
        [0.004, 0.082, 0.38, 0.561, 0.804, 0.918, 0.957],
        -168.6,
        0,
        168.6,
        0,
      )
      .s()
      .p(
        'AqOYSQkviBjpjpQjqjqiAkvQiFk5AAlWQAAlVCFk6QCAkuDqjpQDpjqEviAQE5iFFWAAQFWAAE5CFQEuCADqDqQDpDpCAEuQCFE6AAFVQAAFWiFE5QiAEvjpDqQjqDpkuCBQk5CElWAAQlWAAk5iEgApg2hQkZB3jZDYQjZDZh3EZQh7EjAAE9QAAE+B7EjQB3EZDZDZQDZDZEZB2QEjB8E+AAQE+AAEih8QEZh2DZjZQDZjZB3kZQB7kjAAk+QAAk9h7kjQh3kZjZjZQjZjYkZh3Qkih8k+AAQk9AAkkB8g',
      );
    this.shape_27.setTransform(171.625, 171.6);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .lf(
        ['#EBC17D', '#EDD089', '#F4E8D9', '#C08329', '#EABE81'],
        [0.004, 0.184, 0.412, 0.729, 0.949],
        -88.8,
        153.8,
        93.5,
        -161.9,
      )
      .s()
      .p(
        'AqOYSQkviBjpjpQjqjqiAkvQiFk5AAlWQAAlVCFk6QCAkuDqjpQDpjqEviAQE5iFFWAAQFWAAE5CFQEuCADqDqQDpDpCAEuQCFE6AAFVQAAFWiFE5QiAEvjpDqQjqDpkuCBQk5CElWAAQlWAAk5iEg',
      );
    this.shape_28.setTransform(171.625, 171.6);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f('#FBAE33')
      .s()
      .p(
        'AqaYtQk0iCjujuQjujuiCk0QiHk/AAlcQAAlcCHk/QCCk0DujtQDujtE0iDQE/iHFcAAQFcAAE/CHQE0CDDtDtQDuDtCCE0QCHE/AAFcQAAFciHE/QiCE0juDuQjtDuk0CCQk/CHlcAAQlcAAk/iHgAqO4QQkvCAjpDqQjqDpiAEuQiFE6AAFVQAAFWCFE5QCAEvDqDqQDpDpEvCBQE5CEFWAAQFWAAE5iEQEuiBDqjpQDpjqCAkvQCFk5AAlWQAAlViFk6QiAkujpjpQjqjqkuiAQk5iFlWAAQlWAAk5CFg',
      );
    this.shape_29.setTransform(171.625, 171.6);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f('#FBAE33')
      .s()
      .p(
        'AqUYfQkxiBjsjsQjsjsiBkwQiGk9AAlZQAAlZCGk7QCBkyDsjrQDsjsExiBQE8iGFZAAQFZAAE8CGQExCBDsDsQDrDrCBEyQCGE7AAFZQAAFZiGE9QiBEwjrDsQjsDskxCBQk8CGlZAAQlZAAk8iGg',
      );
    this.shape_30.setTransform(171.625, 171.6);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 343.3, 343.2);

  (lib.gcbadge1xai = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // gc-badge-1x.ai
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        'AlRGyQh2hEg/ibQhUjQBdimQBdinD8hmQDFhQCKASQCLASBtBvIkJCmQgegggYgMQgmgSgvgBQgtAAgwAUQhuAtgeBeQgXBGAuBvQA4CLBJAeQBIAfBhgnQBcglAfg9QAeg9gKhXIE3guQAKBqgkBZQgkBZhNBEQhPBGiMA4QirBGh6ADIgPAAQh0AAhwhAg',
      );
    this.shape.setTransform(210.7655, 158.2477);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p(
        'AitIAQiKgEhphKQhphLg1iBQg2iJAdiBQAeiCByhrQBahUC0hIQCthGBfgKQBhgJBNAdQBPAeA9BGIkmCqQgngog3gGQg5gGhGAcQhqArgnBVQgoBTA0CAQA3CHBXAhQBYAhBxgvQA3gWArggQAvgjAwg1IgghPIjYBXIhFitIHyjJICQFjQhxCKhhBHQhjBJiXA9QiyBIiHAAIgKAAg',
      );
    this.shape_1.setTransform(103.2714, 202.2006);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p('AiLAwIAagyIBIAiIAphUIhIgkIAagzIC6BcIgaAyIhOglIgoBUIBNAmIgZA0g');
    this.shape_2.setTransform(285.1, 227.725);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p('AgwAMIgoA3IghgXIB1idIAfAZIgpA3ICHBkIgiAvg');
    this.shape_3.setTransform(271, 244.75);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p(
        'Ah/hKIA1g1IDKBcIgsArIgzgXIgzAyIAYAzIgpAqgAhOhKIAUAlIAVApIAngmIgqgVIglgTg',
      );
    this.shape_4.setTransform(263.2, 264.875);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        'AingZIBBgpIA6AuQAhAZAYAaIABgBIgShLIgOhKIA+goIB8CpIgwAeIguhBQgdgqgSgdIgBAAQALAqAIAqIARBUIgmAYIhBg2QgkgdgbgaIgBAAIAqBLIAnBFIgtAdg',
      );
    this.shape_5.setTransform(239.625, 279.575);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p(
        'AiBhGIBAgSIBHA6QAhAaAbAeIABAAQgOgfgPgyIgRg7IAzgPIA6DIIg6ARIhJg+QgngggYgaIgBABQAOApANAtIASA8IgzAPg',
      );
    this.shape_6.setTransform(206.575, 293.725);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics.f('#000000').s().p('AgrhjIA5gIIAeDOIg5AJg');
    this.shape_7.setTransform(189.175, 297.5);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#000000')
      .s()
      .p('AghBoIAEinIhEgCIABgoIDCAFIgBAoIhFgCIgFCog');
    this.shape_8.setTransform(168.125, 298.65);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#000000')
      .s()
      .p(
        'AgdBnQgrgIgagSIATgkQAaASAiAHQAnAHAEgWQACgKgIgIQgIgIgVgLQhBgfAHgqQAFgbAdgMQAdgNArAIQAkAHAaAQIgUAjQgXgPgcgFQgRgDgLAEQgJAEgCAIQgCAJAKAJQAHAHAZANQAgAPANASQANASgEAVQgFAcgcAMQgSAJgZAAQgQAAgUgEg',
      );
    this.shape_9.setTransform(147.425, 296.6146);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#000000')
      .s()
      .p(
        'AAMBtQgDgLADgoQACgUgGgKQgGgJgQgHIgQgGIgdBNIg1gTIBHjBQAeAGAqARQA2ATASAZQARAWgKAaQgGARgTAJQgQAIgTgBIAAAAQATAQgBAgIgBAmQgBATABAGgAgTgZIAVAIQAUAIAOgEQAOgEAFgNQAKgbgogOIgZgIg',
      );
    this.shape_10.setTransform(127.0986, 291.45);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics.f('#000000').s().p('AhIBQIBfi5IAyAbIheC4g');
    this.shape_11.setTransform(113, 284.6);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#000000')
      .s()
      .p('Ah6BHIB1itICABXIgWAfIhRg1IgaAmIBLAzIgVAgIhLgzIgvBGg');
    this.shape_12.setTransform(100.725, 274.625);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#000000')
      .s()
      .p(
        'AgHAnQgQgDgJgOQgJgOADgPQAEgQANgJQAOgJAPADQAQAEAJANQAJAOgDAPQgEAQgNAJQgKAHgLAAIgIgBg',
      );
    this.shape_13.setTransform(293.7269, 196.8269);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#000000')
      .s()
      .p('AhnA/IB7h3IiAAGIgDhFIDUgKIADBIIh1BxIB6gGIADBGIjUAJg');
    this.shape_14.setTransform(295.1, 166.25);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#000000')
      .s()
      .p(
        'AgtB6QgpgdgSg8QgTg6ARgwQASgxAugOQAtgOAqAdQAqAeASA7QATA7gSAwQgRAwguAOQgPAFgPAAQgdAAgdgUgAgVhFQgaAIgKAZQgLAZAKAeQAKAfAXAOQAXAOAYgIQAZgIALgYQAKgZgJgeQgKgggXgOQgOgJgPAAQgJAAgJADg',
      );
    this.shape_15.setTransform(289.6, 134.8886);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics.f('#000000').s().p('AhuATIC8hiIAgA9Ii7Big');
    this.shape_16.setTransform(281, 114.175);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#000000')
      .s()
      .p(
        'AA7B1QgggJgbgjIgmg0Ig6AsIgpg4ICph/IBRBsQAaAigBAhQgBAfgZASQgQANgUAAQgIAAgJgCgAgBgGIAhAsQAJALAKAEQALADAIgGQAJgHAAgLQAAgLgJgMIghgsg',
      );
    this.shape_17.setTransform(269.3541, 94.4353);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#000000')
      .s()
      .p('AAACHIBYhxIiNBHIgYgTIAkiaIhZBwIg3gqICEinIBLA7IgeCBIB2g7IBMA7IiECng');
    this.shape_18.setTransform(247.975, 74.375);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#000000')
      .s()
      .p('ABABqIAAgjIhmgsIgZAZIhGgdICvidIBRAiIALDrgAgDgIIBEAdIgBheg');
    this.shape_19.setTransform(215.175, 59.45);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#000000')
      .s()
      .p('AAnByIANhVIhtgRIgOBVIhEgLIAgjRIBFAKIgMBPIBtARIAMhPIBFAKIghDTg');
    this.shape_20.setTransform(190.05, 49.25);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#000000')
      .s()
      .p(
        'AhTBZQgsgcgFgwQgFgvAngjQAmgjA8gFQBTgIApA2Ig6AcQgIgNgQgHQgSgIgUACQgeADgTAUQgTATACAaQADAaAWAPQAWAQAfgDQAUgCAQgKQAOgKAGgOIA+ARQggA8hSAIIgUABQgvAAgkgWg',
      );
    this.shape_21.setTransform(160.2265, 48.2015);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#000000')
      .s()
      .p(
        'AiPg/IBmgvQA6gaAwAJQAyAKAUAsQAUAtgZAqQgZArg6AaIhmAvgAgUhCIgoASIAwBqIAngSQAfgOAMgZQAKgWgKgXQgKgXgYgHQgIgCgJAAQgTAAgUAKg',
      );
    this.shape_22.setTransform(119.1068, 60.5609);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#000000')
      .s()
      .p('AijgEIA3gtIChAcIhMhgIA2gsICFCmIg0AqIiogeIBPBlIg1Arg');
    this.shape_23.setTransform(93.775, 75.05);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f('#000000')
      .s()
      .p('AiNhGIA1hFIDmA0IguA7IgigJIhEBXIAQAeIgtA8gAgfAHIAtg6IhbgYg');
    this.shape_24.setTransform(76.725, 99.45);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f('#000000')
      .s()
      .p(
        'AiQAtIA5h4QATgoAdgOQAcgNAcANQAWALAJAXQAHATgEAXIBfgQIgjBGIhUAKIgQAgIBCAfIgeA/gAghhAQgKAFgHANIgXAxIArAUIAYgwQAGgNgCgLQgBgMgLgFQgEgCgEAAQgFAAgGAEg',
      );
    this.shape_25.setTransform(59.6, 119.2311);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f('#000000')
      .s()
      .p(
        'AgdCFQgxgKgVgxQgVguANg8QAQhMA4gaIAMA+QgNAGgKANQgKAOgEARQgGAfANAZQANAYAZAFQAZAGAWgRQAWgRAGggQAGgegIgWIgSgDIgMA7IgsgIIAah/IBRARQAgA3gPBFQgNA8glAiQgfAcgjAAQgKAAgLgCg',
      );
    this.shape_26.setTransform(50.2552, 146.2349);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .lf(
        [
          '#541513',
          '#8D5027',
          '#CB9552',
          '#FFF2DB',
          '#D7B189',
          '#AB6C2E',
          '#9C530D',
        ],
        [0.004, 0.082, 0.38, 0.561, 0.804, 0.918, 0.957],
        -168.6,
        0,
        168.6,
        0,
      )
      .s()
      .p(
        'AqOYSQkviBjpjpQjqjqiAkvQiFk5AAlWQAAlVCFk6QCAkuDqjpQDpjqEviAQE5iFFWAAQFWAAE5CFQEuCADqDqQDpDpCAEuQCFE6AAFVQAAFWiFE5QiAEvjpDqQjqDpkuCBQk5CElWAAQlWAAk5iEgApg2hQkZB3jZDYQjZDZh3EZQh7EjAAE9QAAE+B7EjQB3EZDZDZQDZDZEZB2QEjB8E+AAQE+AAEih8QEZh2DZjZQDZjZB3kZQB7kjAAk+QAAk9h7kjQh3kZjZjZQjZjYkZh3Qkih8k+AAQk9AAkkB8g',
      );
    this.shape_27.setTransform(171.625, 171.6);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .lf(
        ['#EBC17D', '#EDD089', '#F4E8D9', '#C08329', '#EABE81'],
        [0.004, 0.184, 0.412, 0.729, 0.949],
        -88.8,
        153.8,
        93.5,
        -161.9,
      )
      .s()
      .p(
        'AqOYSQkviBjpjpQjqjqiAkvQiFk5AAlWQAAlVCFk6QCAkuDqjpQDpjqEviAQE5iFFWAAQFWAAE5CFQEuCADqDqQDpDpCAEuQCFE6AAFVQAAFWiFE5QiAEvjpDqQjqDpkuCBQk5CElWAAQlWAAk5iEg',
      );
    this.shape_28.setTransform(171.625, 171.6);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f('#FBAE33')
      .s()
      .p(
        'AqaYtQk0iCjujuQjujuiCk0QiHk/AAlcQAAlcCHk/QCCk0DujtQDujtE0iDQE/iHFcAAQFcAAE/CHQE0CDDtDtQDuDtCCE0QCHE/AAFcQAAFciHE/QiCE0juDuQjtDuk0CCQk/CHlcAAQlcAAk/iHgAqO4QQkvCAjpDqQjqDpiAEuQiFE6AAFVQAAFWCFE5QCAEvDqDqQDpDpEvCBQE5CEFWAAQFWAAE5iEQEuiBDqjpQDpjqCAkvQCFk5AAlWQAAlViFk6QiAkujpjpQjqjqkuiAQk5iFlWAAQlWAAk5CFg',
      );
    this.shape_29.setTransform(171.625, 171.6);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f('#FBAE33')
      .s()
      .p(
        'AqUYfQkxiBjsjsQjsjsiBkwQiGk9AAlZQAAlZCGk7QCBkyDsjrQDsjsExiBQE8iGFZAAQFZAAE8CGQExCBDsDsQDrDrCBEyQCGE7AAFZQAAFZiGE9QiBEwjrDsQjsDskxCBQk8CGlZAAQlZAAk8iGg',
      );
    this.shape_30.setTransform(171.625, 171.6);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 343.3, 343.2);

  (lib.bg = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#333333')
      .s()
      .p(
        'Ao0I2QjrjqAAlMQAAlLDrjpQDpjrFLAAQFMAADqDrQDqDpAAFLQAAFMjqDqQjqDqlMAAQlLAAjpjqg',
      );

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-80, -80, 160, 160);

  (lib.BadgeLabel = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#333333')
      .s()
      .p(
        'AFbBWQgWgUAAggQAAggAVgUQAUgTAgAAQAggBAVAWQAUAUgBAkIhkAAQACATAMAKQAMALAUAAQAYgBAbgTIAAAbQgZASgkAAQglAAgWgTgAFzASIA8AAQgDgegbAAQgbAAgDAegAhNBVQgWgUAAggQAAggAWgTQAXgTAhAAQAggBAWAUQAXASAAAiQAAAhgXAUQgXASgfAAQgiAAgWgUgAgsAAQgJALAAAWQAAAvAgAAQAeAAAAgwQAAgsgeAAQgPAAgIAMgAkABVQgWgUAAggQAAggAXgTQAWgTAiAAQAggBAXAUQAWASAAAiQAAAhgXAUQgXASgfAAQgjAAgWgUgAjfAAQgIALAAAWQAAAvAgAAQAfAAAAgwQAAgsgfAAQgPAAgJAMgAD8BmIAAiJIArAAIAACJgAC4BmIg2hDIAAAAIAABDIgsAAIAAjLIAsAAIAACGIAAAAIA2hEIAzAAIg2BEIA4BFgAlaBmIgRgmQgMgcgJgJQgJgHgKgBIgPAAIAABTIgzAAIAAjLIBcAAQAdAAATARQASARAAAYQAAAjgjAPQAQAHAOAeIAaA6gAmigRIAbAAQANAAAIgGQAHgGAAgMQAAgWgdAAIgaAAgAEAg/QgHgHAAgKQAAgJAHgIQAHgHAKAAQAKAAAHAHQAHAIAAAJQAAAKgHAHQgHAIgKAAQgKAAgHgIg',
      );
    this.shape.setTransform(0.6774, 3.65);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#333333')
      .s()
      .p(
        'AHUBcQgOgNAAgZIAAg7IgUAAIAAgJIA6hBIAGAAIAAAsIAyAAIAAAeIgyAAIAAA4QAAAKAFAGQAFAGAKAAQAOAAAQgIIAAAgQgVAIgUAAQgZAAgOgNgAB7BWQgWgUAAggQAAggAUgUQAVgTAgAAQAggBAVAWQATAUAAAkIhkAAQABATAMAKQAMALAVAAQAYgBAbgTIAAAbQgZASgkAAQglAAgWgTgACTASIA8AAQgDgegbAAQgbAAgDAegAg3BUQgSgUgBgfQAAggATgTQATgTAeAAQARAAASAIIAAhIIArAAIAADLIgrAAIAAgLQgRAOgUAAQgdAAgSgVgAgUACQgKAMAAAUQABATAIALQAKAMAOAAQANAAANgMIAAhAQgMgJgNABQgPAAgJAKgAjjBbQgOgNAAgZIAAhYIAsAAIAABVQgBAaAWAAQANAAAIgKQAJgJAAgEIAAhYIAsAAIAACJIgsAAIAAgUQgTAXgaAAQgWAAgOgOgAlXBcQgOgNAAgZIAAg7IgUAAIAAgJIA6hBIAGAAIAAAsIAyAAIAAAeIgyAAIAAA4QgBAKAGAGQAFAGAKAAQAOAAAQgIIAAAgQgVAIgTAAQgaAAgOgNgAofBWIAAgsQAUANAQAHQAQAFASABQAeAAAAgUQAAgFgGgHQgGgFgXgIQgXgJgOgGQgMgIgKgLQgKgNAAgVQAAgbAVgQQAVgQAkAAQAgAAAlAQIAAAoQgogSgYAAQgOAAgJAEQgHAFAAAHQgBAGAGAGQAGAFAWAIQAYAJANAHQANAHAKAMQALANgBAUQABAcgWASQgWAQgjAAQgmAAgkgTgAFxBmIAAhUQAAgagWAAQgPgBgPAXIAABYIgsAAIAAiJIAsAAIAAAUQATgXAaABQAWAAAOANQAOAOAAAZIAABXg',
      );
    this.shape_1.setTransform(0.55, 3.65);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#333333')
      .s()
      .p(
        'AFCBZQgWAQgXAAQgQAAgMgKQgLgKAAgNQAAgTAMgLQAMgLA6gRQACgXgaABQgbgBgYAXIAAgjQAcgQAgAAQA7gBAAApIAAA/QAAAKAHAAQAFAAALgHIAAAXQgVANgTAAQgVAAgEgQgAEjAxQgJAGAAAJQAAAHAEAEQAFAEAFABQANAAALgLIAAgiQgVAIgIAGgAABBVQgVgUAAggQAAggAWgTQAWgTAiAAQAggBAXAUQAWASAAAiQAAAhgXAUQgXASgfAAQgjAAgWgUgAAiAAQgIALAAAWQAAAvAgAAQAfAAAAgwQAAgsgfAAQgPAAgJAMgAlCBWQgWgUAAggQAAggAWgTQAWgVAiABQAWgBAZAKIAAAeQgSgHgRgBQgUAAgMALQgLAKAAATQAAASALALQAMALASAAQAOAAAZgKIAAAgQgZAJgWAAQgkAAgWgTgAoGBWIAAgsQAUANAQAHQAQAFASABQAeAAAAgUQAAgFgGgHQgGgFgXgIQgXgJgOgGQgNgIgKgLQgJgNAAgVQAAgbAVgQQAVgQAkAAQAgAAAlAQIAAAoQgpgSgYAAQgOAAgIAEQgIAFAAAHQAAAGAGAGQAGAFAWAIQAXAJAOAHQANAHAKAMQAKANAAAUQAAAcgVASQgWAQgjAAQgmAAgkgTgAGWBmIAAiJIAsAAIAAAnIABAAQASgpAaAAQAMAAAQAMIgMAlQgQgKgJAAQgPAAgLATQgKATAAADIAAA7gACmBmIAAjLIArAAIAADLgAhcBmIAAhOQAAgegWAAQgPAAgPAUIAABYIgrAAIAAjLIArAAIAABWIABAAQASgWAaAAQAWgBAOAOQAOAOAAAYIAABYg',
      );
    this.shape_2.setTransform(0.825, 3.65);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#333333')
      .s()
      .p(
        'AiJBpIhAiEIg/CEIgWAAIhajOIA2AAIAwBwIA1hwIApAAIA1BwIAvhwIA2AAIhZDOgADrBmIBIhrIhBAAIAAgeICHAAIhGBsIBGAAIAAAdgACnBmIAAiJIAsAAIAACJgABXBmIAAhOQAAgegWAAQgPAAgPAUIAABYIgqAAIAAjLIAqAAIAABWIABAAQASgWAaAAQAWgBAOAOQAOAOAAAYIAABYgACsg/QgHgHAAgKQAAgJAHgIQAHgHAKAAQAKAAAHAHQAHAIAAAJQAAAKgHAHQgHAIgKAAQgKAAgHgIg',
      );
    this.shape_3.setTransform(-0.475, 3.65);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#333333')
      .s()
      .p(
        'ACTBUQgWgTAAghQAAgfAUgUQAVgUAgAAQAgAAAUAWQAUATgBAlIhjAAQABASAMAKQAMALAUAAQAZAAAbgUIAAAbQgZATglgBQgkAAgWgTgACrAQIA8AAQgEgdgagBQgbABgDAdgAgBBUQgWgTAAghQAAggAWgSQAVgVAiAAQAWAAAZAJIAAAfQgSgIgSAAQgTAAgMAKQgMAKAAATQAAASAMAMQALAKATABQANAAAagKIAAAfQgaAKgVgBQglAAgUgTgAhbBlIgQgpIhcAAIgPApIg2AAIBSjMIA7AAIBbDMgAi6AZIBAAAIghhOg',
      );
    this.shape_4.setTransform(-2.4226, 3.8);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#333333')
      .s()
      .p(
        'AhzCJIAAjPIAsAAIAAAMQARgOAWAAQAbAAASAUQASAUAAAeQAAAggSAUQgSAUgfAAQgTAAgQgJIAABMgAhHgeIAAA+QAMAJANAAQAPAAAKgLQAJgLAAgTQAAgUgIgLQgJgLgPAAQgNAAgOAMgAGBA5QgOgNABgZIAAg7IgUAAIAAgIIA5hBIAGAAIAAArIAyAAIAAAeIgyAAIAAA4QAAAKAFAGQAGAGAKAAQAOAAAPgIIAAAgQgUAIgUAAQgaAAgOgNgABLAzQgWgUAAgfQAAggAVgUQAUgUAgAAQAgAAAUAVQAVAVgBAjIhkAAQABATAMAKQAMALAVAAQAYAAAbgUIAAAbQgZASglAAQgkAAgWgTgABjgQIA8AAQgDgfgbAAQgbAAgDAfgADjBEIAAiKIArAAIAAAoIABAAQATgqAZAAQAMAAARAMIgNAnQgPgLgKAAQgPAAgKATQgLASAAADIAAA8gAi4BEIgggrIggArIgwAAIA4hGIg4hEIAyAAIAeAoIAdgoIAyAAIg3BEIA7BGgAnQBEIAAjMICUAAIAAAmIhhAAIAAArIBdAAIAAAlIhdAAIAAAwIBkAAIAAAmg',
      );
    this.shape_5.setTransform(1, 7.125);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#333333')
      .s()
      .p(
        'AK8BOQgTANgUAAQgOAAgKgJQgKgJABgMQgBgPALgKQAKgKAzgOQABgUgWAAQgYAAgUAUIAAgfQAYgOAcAAQAzAAgBAkIAAA3QABAHAGABQAFAAAJgHIAAAVQgTALgRAAQgRAAgEgNgAKhAqQgHAFAAAJQAAAFAEAEQADADAFAAQALABAKgKIAAgcQgTAGgHAFgAHABKQgTgRAAgcQAAgcATgQQATgSAdAAQAUAAAVAIIAAAbQgPgHgPAAQgSAAgJAJQgLAJAAAQQAAAPAKAKQAKAKAQAAQAMAAAWgIIAAAbQgWAIgSAAQghAAgSgRgAETBPQgMgLAAgWIAAgyIgRAAIAAgIIAyg4IAFAAIAAAmIArAAIAAAaIgrAAIAAAwQAAAIAEAGQAGAFAIAAQAMAAANgHIAAAcQgSAHgQAAQgXAAgMgMgAC6BOQgUANgTAAQgOAAgKgJQgKgJAAgMQAAgPALgKQAKgKAzgOQABgUgXAAQgXAAgUAUIAAgfQAXgOAcAAQAzAAAAAkIAAA3QAAAHAHABQAEAAAJgHIAAAVQgSALgRAAQgSAAgDgNgACfAqQgIAFAAAJQABAFADAEQADADAFAAQALABALgKIAAgcQgUAGgGAFgAkDBKQgTgRAAgcQAAgcASgQQASgSAbAAQAdAAARATQASASgCAeIhVAAQABARAKAIQAKAKASgBQAVAAAXgRIAAAYQgVAQggAAQggAAgTgRgAjtAOIA0AAQgEgZgWAAQgYAAgCAZgAoABPQgMgLAAgWIAAgyIgRAAIAAgIIAzg4IAEAAIAAAmIArAAIAAAaIgrAAIAAAwQAAAIAFAGQAFAFAIAAQAMAAANgHIAAAcQgRAHgRAAQgXAAgMgMgApZBOQgTANgUAAQgOAAgKgJQgJgJgBgMQAAgPALgKQAKgKAzgOQABgUgWAAQgYAAgUAUIAAgfQAXgOAdAAQAyAAAAAkIAAA3QAAAHAHABQAFAAAJgHIAAAVQgTALgQAAQgSAAgEgNgAp0AqQgHAFAAAJQAAAFADAEQAEADAFAAQAKABALgKIAAgcQgTAGgHAFgANXBYIAAhJQABgXgUAAQgNABgNASIAABNIgmAAIAAh2IAmAAIAAARQARgUAXAAQASAAAMAMQANAMAAAVIAABMgAI1BYIAAh2IAlAAIAAB2gAFtBYIAAh2IAlAAIAAB2gAAzBYIAAhGQAAgMgGgHQgGgGgKgBQgRAAgMAUIAABMIgmAAIAAhHQAAgMgGgGQgGgHgLAAQgPABgOAPIAABQIglAAIAAh2IAlAAIAAAPQAUgSAWAAQAfAAANAZQAUgZAaAAQAUAAAOAMQANANgBAUIAABMgAlUBYIAAhEQAAgZgUAAQgMAAgNARIAABMIgmAAIAAiwIAmAAIAABLIABAAQAQgUAWAAQATAAAMAMQANANAAAUIAABMgArqBYIAAhtIgwA2IgGAAIgwg2IAABtIgsAAIAAiwIAmAAIA6BCIA4hCIAmAAIAACwgAI5g3QgGgGAAgIQAAgJAGgGQAGgGAIAAQAJAAAHAGQAFAGAAAJQAAAIgFAGQgHAHgJAAQgIAAgGgHgAFwg3QgFgGAAgIQAAgJAFgGQAHgGAIAAQAJAAAGAGQAGAGAAAJQAAAIgGAGQgGAHgJAAQgIAAgHgHg',
      );
    this.shape_6.setTransform(0.7, 5.3);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#333333')
      .s()
      .p(
        'AFvBfIAAgfQAbAMASAAQAVAAABgKQgBgEgEgDQgDgEgXgJQgWgIgIgLQgIgKAAgNQgBgSARgMQAPgLAaAAQAZgBATALIAAAdQgYgOgWAAQgPAAAAALQAAACADACQADADAXAJQAVAJAKALQAJALgBAOQAAAWgOALQgPAMgbAAQgcAAgWgKgADTBbQgOgNgBgZIAAhYIAsAAIAABVQAAAaAWAAQAMAAAJgKQAJgJAAgEIAAhYIAsAAIAACJIgsAAIAAgUQgTAXgaAAQgWAAgOgOgAjSBWQgWgUABggQAAggAUgUQAUgTAhAAQAfgBAVAWQAUAUgBAkIhjAAQABATAMAKQAMALAUAAQAYgBAbgTIAAAbQgZASgkAAQgkAAgXgTgAi5ASIA7AAQgDgegbAAQgbAAgCAegAm2BLQgigdAAguQAAgtAigdQAjgeA2AAQAtAAAjARIAAAsQgmgSgmAAQgkAAgTASQgUASAAAbQAAAbAUARQATAQAgAAQAQABARgIIAAgXIgdAAIAAglIBRAAIAABTQgMAMgZAIQgZAHgZAAQg0AAgjgegAB0BmIAAiJIArAAIAACJgAAjBmIAAhUQAAgagVAAQgOgBgPAXIAABYIgsAAIAAiJIAsAAIAAAUQASgXAaABQAVAAAPANQAOAOAAAZIAABXgAB5g/QgIgHAAgKQAAgJAIgIQAGgHALAAQAJAAAIAHQAGAIAAAJQAAAKgGAHQgIAIgJAAQgLAAgGgIg',
      );
    this.shape_7.setTransform(0.8, 3.65);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#333333')
      .s()
      .p(
        'AK6BUQgSgUgBgfQAAggATgTQATgTAeAAQASAAASAIIAAhIIArAAIAADLIgrAAIAAgLQgRAOgVAAQgdAAgSgVgALdACQgKAMAAAUQABATAIALQAKAMAPAAQANAAANgMIAAhAQgMgJgNABQgQAAgJAKgAiNBWQgWgUAAggQAAggAVgUQAUgTAgAAQAggBAVAWQATAUAAAkIhkAAQABATAMAKQAMALAVAAQAYgBAbgTIAAAbQgZASgkAAQglAAgWgTgAh1ASIA8AAQgDgegbAAQgbAAgDAegAkCBcQgOgNAAgZIAAg7IgUAAIAAgJIA6hBIAFAAIAAAsIAzAAIAAAeIgzAAIAAA4QAAAKAGAGQAGAGAKAAQANAAAQgIIAAAgQgVAIgUAAQgZAAgOgNgAmaBfIAAgfQAbAMASAAQAVAAABgKQgBgEgEgDQgDgEgXgJQgWgIgIgLQgIgKAAgNQgBgSARgMQAPgLAaAAQAZgBATALIAAAdQgYgOgWAAQgPAAAAALQAAACADACQADADAXAJQAVAJAJALQAKALgBAOQAAAWgOALQgPAMgbAAQgcAAgWgKgAnpBZQgWAQgXAAQgQAAgMgKQgKgKgBgNQAAgTAMgLQAMgLA6gRQACgXgZABQgcgBgXAXIAAgjQAbgQAhAAQA6gBAAApIAAA/QAAAKAIAAQAEAAAMgHIAAAXQgWANgTAAQgUAAgFgQgAoIAxQgIAGgBAJQAAAHAEAEQAFAEAGABQAMAAALgLIAAgiQgVAIgIAGgAJfBmIAAhUQAAgagVAAQgPgBgPAXIAABYIgsAAIAAiJIAsAAIAAAUQATgXAaABQAVAAAPANQAOAOAAAZIAABXgAGwBmIAAiJIArAAIAACJgAFfBmIAAhRQAAgPgIgGQgGgJgMABQgTgBgQAXIAABYIgrAAIAAhSQAAgOgHgHQgIgHgMAAQgQAAgQARIAABdIgsAAIAAiJIAsAAIAAASQAVgVAaABQAkAAAPAdQAYgdAeAAQAYAAAPAOQAPAOAAAXIAABYgAAKBmIAAiJIArAAIAAAnIABAAQATgpAZAAQAMAAARAMIgMAlQgRgKgJAAQgPAAgKATQgLATAAADIAAA7gAqQBmIAAh+Ig3A/IgIAAIg3g/IAAB+IgzAAIAAjLIAsAAIBCBLIBChLIAsAAIAADLgAG0g/QgHgHAAgKQAAgJAHgIQAHgHAKAAQAKAAAHAHQAHAIAAAJQAAAKgHAHQgHAIgKAAQgKAAgHgIg',
      );
    this.shape_8.setTransform(0.75, 3.65);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#333333')
      .s()
      .p(
        'ACNCKIAAjOIArAAIAAAMQARgPAXAAQAaAAAUAUQASAVAAAdQAAAhgSAUQgUAUgfAAQgSAAgRgKIAABMgAC4gdIAAA/QAMAJANAAQAQAAAJgMQAKgLAAgTQAAgTgJgLQgJgLgPAAQgNAAgOALgAGdA0QgWgUAAggQAAggAXgTQAWgUAhAAQAhAAAWATQAXATAAAhQAAAigXATQgXATggAAQgiAAgWgUgAG+ghQgJAMABAVQAAAuAfAAQAfAAABguQgBgtgfAAQgOAAgJAMgAjkA4QgXAQgXAAQgPAAgMgKQgLgKAAgOQAAgSALgLQAMgKA7gSQACgXgaAAQgcAAgXAXIAAgjQAbgRAhAAQA6AAAAAqIAAA+QABAKAHAAQAFAAALgIIAAAYQgVANgUAAQgUAAgEgQgAkEAQQgIAGAAAJQAAAGAEAFQAEAEAGAAQAMAAAMgKIAAgiQgVAIgJAGgAqqAqQghgeAAgrQABgtAhgeQAjgfA2AAQAsAAAeASIAAAuQgkgVghAAQghAAgVARQgVASAAAbQAAAbAVARQAUARAgAAQAQAAAPgEQAOgEAdgOIAAAtQgnAUgpAAQg3AAgggegAKgBFIAAhTQAAgcgWAAQgPAAgPAXIAABYIgsAAIAAiJIAsAAIAAAUQATgXAaAAQAWAAAOAOQAOAOAAAZIAABXgAE9BFIAAiJIAsAAIAACJgAA+BFIAAhQQAAgPgIgIQgGgIgMAAQgTAAgQAYIAABXIgqAAIAAhRQAAgOgHgIQgIgIgMAAQgQAAgQATIAABcIgsAAIAAiJIAsAAIAAASQAVgVAaAAQAkAAAPAdQAXgdAeAAQAYAAAPAPQAPAOAAAXIAABYgAmABFIAAhOQAAgegVAAQgPAAgPAVIAABXIgrAAIAAjLIArAAIAABWIABAAQASgXAZAAQAXAAAOAOQAOAOAAAZIAABXgAFChgQgHgHAAgKQAAgKAHgHQAHgHAKAAQAKAAAHAHQAHAHAAAKQAAAKgHAHQgHAHgKAAQgKAAgHgHg',
      );
    this.shape_9.setTransform(4.45, 6.975);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#333333')
      .s()
      .p(
        'AJyCKIAAjOIAsAAIAAAMQARgPAWAAQAbAAATAUQASAVAAAdQAAAhgSAUQgTAUgfAAQgTAAgQgKIAABMgAKegdIAAA/QAMAJANAAQAPAAAKgMQAKgLAAgTQAAgTgJgLQgJgLgPAAQgNAAgOALgAOCA0QgVgUAAggQgBggAXgTQAXgUAhAAQAhAAAWATQAXATgBAhQAAAigWATQgYATgfAAQgiAAgXgUgAOjghQgIAMAAAVQAAAuAgAAQAfAAAAguQAAgtgfAAQgPAAgJAMgAEAA4QgWAQgXAAQgQAAgLgKQgLgKAAgOQAAgSALgLQAMgKA7gSQABgXgaAAQgbAAgYAXIAAgjQAcgRAgAAQA7AAAAAqIAAA+QAAAKAHAAQAFAAALgIIAAAYQgVANgTAAQgUAAgFgQgADhAQQgJAGABAJQAAAGADAFQAFAEAFAAQANAAAMgKIAAgiQgWAIgIAGgAjEAqQghgeAAgrQAAgtAigeQAigfA3AAQAsAAAeASIAAAuQglgVghAAQghAAgVARQgUASAAAbQgBAbAVARQAVARAgAAQAQAAAOgEQAPgEAcgOIAAAtQgmAUgqAAQg2AAgggegAnYAzQgTgUAAgfQAAgfATgUQATgUAdAAQASAAASAJIAAhIIArAAIAADLIgrAAIAAgLQgQAOgWAAQgcAAgSgVgAm1geQgKALAAAUQAAATAJALQAJAMAPAAQANAAANgMIAAhBQgMgIgMAAQgRAAgIAMgArmA4QgWAQgXAAQgQAAgLgKQgLgKAAgOQAAgSALgLQAMgKA7gSQABgXgaAAQgbAAgYAXIAAgjQAcgRAgAAQA7AAAAAqIAAA+QAAAKAHAAQAFAAALgIIAAAYQgVANgTAAQgUAAgFgQgAsFAQQgJAGABAJQAAAGADAFQAFAEAFAAQANAAAMgKIAAgiQgWAIgIAGgAyNAqQgjgdAAgtQAAguAjgeQAigdA3AAQAtAAAjARIAAAsQgngSgmAAQgjAAgUASQgUASABAcQgBAbAUAQQATAQAhAAQAQAAARgHIAAgXIgeAAIAAglIBRAAIAABSQgMANgZAHQgZAIgYAAQg1AAgigegASFBFIAAhTQABgcgWAAQgQAAgPAXIAABYIgrAAIAAiJIArAAIAAAUQAUgXAZAAQAWAAAOAOQAPAOAAAZIAABXgAMjBFIAAiJIAsAAIAACJgAIjBFIAAhQQAAgPgHgIQgGgIgNAAQgTAAgPAYIAABXIgrAAIAAhRQAAgOgIgIQgHgIgMAAQgRAAgQATIAABcIgsAAIAAiJIAsAAIAAASQAWgVAaAAQAjAAAPAdQAZgdAdAAQAYAAAPAPQAQAOgBAXIAABYgABlBFIAAhOQAAgegWAAQgPAAgPAVIAABXIgrAAIAAjLIArAAIAABWIABAAQATgXAZAAQAWAAAOAOQAPAOAAAZIAABXgAozBFIAAhTQAAgcgWAAQgPAAgPAXIAABYIgsAAIAAiJIAsAAIAAAUQATgXAaAAQAVAAAPAOQAPAOAAAZIAABXgAu3BFIAAiJIAsAAIAAAoIABAAQASgrAaAAQALAAARANIgMAmQgQgKgJAAQgQAAgKATQgLARABADIAAA8gAMnhgQgGgHgBgKQABgKAGgHQAHgHAKAAQAKAAAHAHQAIAHAAAKQAAAKgIAHQgHAHgKAAQgKAAgHgHg',
      );
    this.shape_10.setTransform(5.4, 6.975);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_4 }] }, 1)
        .to({ state: [{ t: this.shape_5 }] }, 1)
        .to({ state: [{ t: this.shape_6 }] }, 1)
        .to({ state: [{ t: this.shape_7 }] }, 1)
        .to({ state: [{ t: this.shape_8 }] }, 1)
        .to({ state: [{ t: this.shape_9 }] }, 1)
        .to({ state: [{ t: this.shape_10 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-114.7, -6.8, 240.2, 27.6);

  (lib.shineSquare = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .lf(['rgba(0,0,0,0.2)', 'rgba(255,255,255,0.2)'], [0, 1], 0, -74.9, 0, 75)
      .s()
      .p(
        'AnLLuQh4AAhVhVQhVhVAAh4IAAuXQAAh3BVhWQBVhVB4AAIOXAAQB4AABVBVQBVBWAAB3IAAOXQAAB4hVBVQhVBVh4AAgApbpcQhOBOABBtIAANDQgBBtBOBOQBNBMBtAAINDAAQBtAABNhMQBOhOgBhtIAAtDQABhthOhOQhNhMhtAAItDAAQhtAAhNBMg',
      );

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-75, -75, 150, 150);

  (lib.shinePentagon = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 4
    this.shape = new cjs.Shape();
    this.shape.graphics
      .lf(
        ['rgba(255,255,255,0.49)', 'rgba(255,255,255,0)'],
        [0, 1],
        3.2,
        -18.2,
        3.2,
        7.8,
      )
      .s()
      .p('AAcjJIH1FsQoFlCocFqg');
    this.shape.setTransform(-2.5125, -43.75);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .lf(
        ['rgba(255,255,255,0.502)', 'rgba(255,255,255,0)'],
        [0, 1],
        3.5,
        12.9,
        3.3,
        -9.1,
      )
      .s()
      .p('AmeBQIg0ifQHSDXHTjXIgzCfg');
    this.shape_1.setTransform(0.2375, 56);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    // Layer 3
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .lf(
        ['rgba(255,255,255,0.302)', 'rgba(255,255,255,0)'],
        [0, 1],
        0,
        35.8,
        0.4,
        -38.2,
      )
      .s()
      .p('Ap4D4Ignh5IKgnoIKfHoIgnB5Qk0Byk8AAQk8AAlFhyg');
    this.shape_2.setTransform(0.2, -27.76);

    this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-67, -64, 134.4, 128);

  (lib.LevelIcon = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      /* stop();*/
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(100));

    // Layer 5
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p('AAAAnIguAhIAQg3IgughIA6gCIASg1IATA1IA6ACIgtAhIAQA3g');
    this.shape.setTransform(0.025, -52.275);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AhtAUIgygaIA4gMIAKg4IAcAyIA5gJIgnAqIAaA0Ig1gZIgpApgABNAjIgzAbIAXg1IgpgoIA6AGIAZgzIAMA4IA5AJIgxAcIAJA4g',
      );
    this.shape_1.setTransform(-1.025, -51.875);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Ai8AiIg3gSIA2gUIABg4IAjAtIA3gRIgfAtIAiAuIg4gPIgiAvgACbAuIg4ARIAggwIgigtIA4AQIAiguIADA4IA2ARIg1AUIAAA6gAAEAVIguAgIAQg2IgvgiIA7gCIASg1IATA1IA6ACIgtAiIAQA2g',
      );
    this.shape_2.setTransform(-0.35, -50.4);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AkDAzIg5gIIAxgdIgIg4IAqAmIAzgaIgWAzIApAoIg6gFIgZA0gADgA4Ig5AKIAlgsIgbgxIA1AVIAogpIgEA5IAzAZIg3ANIgIA6gAhqgKIgzgbIA4gMIAKg4IAdAyIA5gJIgoArIAaAzIg0gZIgqApgABPAEIgzAbIAXg0IgpgpIA6AGIAZgzIAMA4IA5AJIgxAdIAJA3g',
      );
    this.shape_3.setTransform(-1.25, -48.775);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AEfBPIg5AAIAsgkIgSg0IAxAdIAughIgOA2IAuAiIg5ADIgRA2gAlFBGIg5gDIAvghIgPg3IAuAhIAygdIgSA1IAsAkIg7AAIgUA1gAi9gGIg3gSIA2gVIABg5IAjAtIA3gRIgeAvIAhAtIg4gPIgiAugACaAEIg4ARIAhguIgiguIA3APIAjguIACA5IA2ASIg1AUIAAA4gAAEgUIgvAgIAQg2IgugjIA6gBIATg1IATA1IA5ABIgtAjIARA2g',
      );
    this.shape_4.setTransform(-0.3, -46.25);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AmBBpIg5AGIApgpIgZg0IA0AaIArgnIgIA5IAxAcIg5AJIgLA5gAFcBhIg5gJIAxgdIgJg5IArAmIA0gaIgYA0IApAqIg6gGIgZA0gAkJADIg5gHIAxgdIgJg5IArAmIAzgaIgWA0IApAnIg6gFIgZA0gADaAIIg5AKIAlgrIgbgyIA1AVIAngpIgDA6IAzAZIg4AMIgHA6gAhxg6IgygbIA4gMIAKg4IAcAyIA5gJIgnArIAaA0Ig1gZIgpApgABJgrIgzAbIAXg1IgpgpIA6AGIAZgzIAMA4IA5AJIgxAdIAJA4g',
      );
    this.shape_5.setTransform(-0.625, -43.975);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AGRCDIg3gSIA2gUIABg5IAkAtIA3gQIghAvIAiAuIg4gPIgiAugAm0CHIg4APIAiguIghgvIA4ARIAkgtIABA5IA2ATIg3ASIgDA7gAEfAXIg5AAIAsgjIgSg2IAxAeIAughIgOA3IAuAgIg5AEIgRA2gAlFAOIg5gDIAvggIgPg4IAuAhIAygeIgSA2IAsAjIg7AAIgUA1gAi9g/Ig3gSIA2gVIABg4IAjAtIA3gRIgeAuIAhAuIg4gPIgiAvgACagzIg4ARIAhgwIgiguIA3AQIAjguIACA4IA2ASIg1AUIAAA6gAAEhMIgvAgIAQg3IgugiIA6gCIATg1IATA1IA5ACIgtAiIARA3g',
      );
    this.shape_6.setTransform(-0.3, -40.6);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AnWC1Ig0AZIAYg1IgogoIA5AGIAcgyIALA4IA4AKIgzAcIAJA6gAG6CZIg1gZIA4gNIAIg5IAeAyIA4gMIgkAsIAaAzIg1gWIgnAqgAl/AoIg5AHIApgqIgZgzIA0AaIArgnIgIA5IAxAbIg5AKIgLA5gAFeAgIg5gJIAxgcIgJg4IArAmIA0gbIgYA0IApApIg6gGIgZA0gAkHg8Ig5gIIAxgdIgJg6IArAnIAzgaIgWA0IApAoIg6gGIgZA1gADcg4Ig5ALIAlgsIgbgyIA1AVIAngqIgDA6IAzAZIg4ANIgHA6gAhvh6IgygcIA4gLIAKg5IAcAyIA5gIIgnAqIAaA0Ig1gYIgpApgABLhrIgzAbIAXg2IgpgoIA6AGIAZg0IAMA4IA5AJIgxAeIAJA4g',
      );
    this.shape_7.setTransform(-0.825, -37.525);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AHWDHIgvghIA6gEIARg2IAVA2IA6gBIgtAkIASA1IgwgeIgvAjgAn1DVIgwAeIARg2IgsgkIA6ABIAVg1IARA2IA6ADIgvAhIAOA4gAGRBBIg3gSIA1gUIABg3IAkAsIA4gQIghAuIAhAuIg3gPIgiAugAm0BGIg4APIAigvIghguIA3AQIAkgsIABA4IA2AUIg3ASIgCA6gAEfgqIg6AAIAsgkIgSg1IAyAeIAugiIgPA3IAvAhIg5AEIgRA1gAlFgzIg5gDIAughIgOg4IAuAiIAxgeIgSA1IAtAkIg7AAIgVA1gAi9iBIg3gSIA2gUIABg5IAjAtIA3gRIgfAvIAiAuIg4gPIgiAugACah1Ig4ARIAggvIgigvIA4AQIAjguIACA5IA2ASIg1AUIAAA5gAADiOIguAhIAQg3IgugjIA6gBIASg2IATA2IA6ABIgtAjIAQA3g',
      );
    this.shape_8.setTransform(-0.275, -34.025);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AokDwIgxgcIA5gIIALg6IAaAyIA6gGIgpAqIAZA1Ig0gbIgqAngAICD0IgzAaIAYgzIgpgqIA5AGIAbgzIAMA5IA4AJIgyAcIAJA6gAnaBpIg0AZIAYg1IgogpIA5AHIAcgyIALA4IA4AKIgzAcIAJA5gAG2BNIg1gZIA4gNIAIg4IAeAxIA4gMIgkArIAaAzIg1gVIgnApgAmDgjIg5AGIApgpIgZg0IA0AaIArgnIgIA5IAxAcIg5AKIgLA3gAFagrIg5gJIAxgdIgJg4IArAlIA0gaIgYA0IApAqIg6gGIgZAzgAkLiJIg5gIIAxgcIgJg6IArAnIAzgaIgWA0IApAnIg6gFIgZA0gADYiEIg5ALIAlgsIgbgzIA1AWIAngqIgDA6IAzAZIg4ANIgHA6gAhzjHIgygbIA4gLIAKg5IAcAyIA5gJIgnArIAaA0Ig1gYIgpAogABHi3IgzAbIAXg2IgpgpIA6AGIAZgzIAMA4IA5AJIgxAeIAJA3g',
      );
    this.shape_9.setTransform(-0.425, -29.9);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AICElIg4AQIAhgvIghgvIA4AQIAjgtIACA5IA2ATIg2ATIgCA4gAolESIg3gTIA3gSIACg5IAjAsIA3gQIghAvIAhAvIg3gQIgjAtgAHTB0IgvghIA6gDIARg2IAVA1IA6gBIgtAkIASA2IgwgeIgvAigAn4CCIgwAeIARg1IgsgkIA6ABIAVg2IARA2IA6ADIgvAiIAOA4gAGOgQIg3gSIA1gUIABg5IAkAtIA4gRIghAvIAhAuIg3gOIgiAtgAm3gMIg4AOIAigtIghgvIA3ARIAkgtIABA4IA2AUIg3ASIgCA5gAEch8Ig6AAIAsgkIgSg2IAyAeIAugiIgPA4IAvAhIg5ADIgRA3gAlIiGIg5gDIAughIgOg3IAuAhIAxgeIgSA2IAtAkIg7AAIgVA1gAjAjTIg3gSIA2gVIABg4IAjAsIA3gRIgfAvIAiAuIg4gPIgiAvgACXjIIg4ASIAggwIgiguIA4APIAjgtIACA4IA2ASIg1AUIAAA5gAAAjhIguAhIAQg3IgugiIA6gCIASg1IATA1IA6ACIgtAiIAQA3g',
      );
    this.shape_10.setTransform(0.025, -25.775);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AoYFFIg5gJIAygcIgJg6IArAoIA0gaIgYA0IAoApIg5gGIgbAzgAH8E1Ig6AHIApgpIgZg2IA0AbIAqgnIgHA5IAxAcIg5AJIgKA5gAooCcIgxgdIA5gIIAKg6IAbAzIA5gGIgoApIAZA1Ig0gaIgqAmgAH9CgIgzAaIAYg0IgogqIA5AGIAbgyIALA4IA4AJIgxAcIAJA6gAnfAUIgzAZIAXg0IgngoIA4AGIAcgyIALA4IA5AKIgzAbIAJA6gAGygHIg1gZIA4gNIAIg5IAeAyIA4gMIglAsIAaAyIg0gWIgoAqgAmHh4Ig5AHIAogqIgYg0IAzAaIAsgnIgJA5IAyAcIg5AKIgLA5gAFWiAIg6gJIAygdIgJg4IArAmIAzgbIgXA1IAoApIg5gGIgZA0gAkQjdIg4gIIAwgdIgIg6IAqAnIA0gaIgXA0IAqAoIg6gGIgZA1gADTjZIg4ALIAlgsIgbgyIA1AVIAngqIgDA6IAyAZIg3ANIgIA6gAh3kbIgygcIA4gLIAKg5IAcAyIA5gIIgoAqIAbA0Ig1gYIgpApgABDkMIg0AbIAYg2IgpgoIA6AGIAYg0IANA4IA4AJIgwAeIAJA4g',
      );
    this.shape_11.setTransform(0, -21.425);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AoBFtIg6ABIAsgkIgRg2IAvAfIAvgjIgPA3IAwAiIg6ADIgSA2gAHmFlIg7gEIAwghIgPg4IAvAjIAvgeIgRA2IAsAkIg5gCIgVA1gAICDUIg4AQIAhgvIghgvIA4AQIAjgtIACA6IA2ASIg2ATIgCA4gAolDBIg3gTIA3gSIACg5IAjAtIA3gRIghAvIAhAvIg3gPIgjAtgAHTAkIgvgiIA6gCIARg2IAVA2IA6gBIgtAjIASA1IgwgeIgvAigAn4AxIgwAfIARg2IgsgjIA6ABIAVg1IARA2IA6ACIgvAhIAOA4gAGOhhIg3gSIA1gUIABg5IAkAtIA4gQIghAvIAhAuIg3gPIgiAugAm3hdIg4APIAiguIghgvIA3ARIAkgtIABA5IA2ATIg3ASIgCA7gAEcjNIg6AAIAsgkIgSg2IAyAeIAughIgPA3IAvAhIg5AEIgRA2gAlIjWIg5gDIAughIgOg4IAuAhIAxgeIgSA2IAtAkIg7AAIgVA1gAjAkkIg3gSIA2gVIABg4IAjAtIA3gRIgfAuIAiAuIg4gPIgiAvgACXkYIg4ARIAggwIgiguIA4AQIAjguIACA4IA2ASIg1AUIAAA6gAAAkxIguAgIAQg3IgugiIA6gCIASg1IATA1IA6ACIgtAiIAQA3g',
      );
    this.shape_12.setTransform(0.025, -17.7);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AnXGaIg4ALIAkgqIgagzIA0AVIAogqIgFA6IA1AaIg6ANIgGA5gAHEF7Ig5gMIAzgbIgIg5IAqAnIAzgYIgYA0IAoApIg5gHIgbAzgAoYD2Ig5gJIAygcIgJg6IArAoIA0gaIgYA0IAoApIg5gGIgbAygAH8DmIg6AHIApgqIgZg1IA0AaIAqgmIgHA4IAxAcIg5AJIgKA6gAooBMIgxgcIA5gIIAKg5IAbAxIA5gGIgoAqIAZA1Ig0gbIgqAngAH9BQIgzAaIAYgzIgogqIA5AGIAbgyIALA4IA4AJIgxAcIAJA6gAnfg6IgzAZIAXg1IgngpIA4AHIAcgzIALA5IA5AKIgzAcIAJA5gAGyhWIg1gZIA4gNIAIg5IAeAyIA4gMIglArIAaAzIg0gVIgoApgAmHjHIg5AGIAogpIgYg0IAzAaIAsgnIgJA5IAyAcIg5AKIgLA4gAFWjPIg6gJIAygdIgJg4IArAlIAzgaIgXA0IAoAqIg5gGIgZA0gAkQktIg4gIIAwgcIgIg6IAqAnIA0gaIgXA0IAqAnIg6gFIgZA0gADTkoIg4ALIAlgsIgbgzIA1AWIAngqIgDA6IAyAZIg3ANIgIA6gAh3lrIgygbIA4gLIAKg5IAcAyIA5gJIgoArIAbA0Ig1gYIgpAogABDlbIg0AbIAYg2IgpgpIA6AGIAYgzIANA4IA4AJIgwAeIAJA3g',
      );
    this.shape_13.setTransform(0, -13.5);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AmvG6Ig4ARIAhgvIghgvIA4AQIAiguIACA5IA3ASIg2AUIgBA5gAGUGnIg2gVIA3gSIACg5IAjAuIA3gQIghAvIAhAvIg4gRIgkAugAoBEoIg6ABIAsgkIgRg2IAvAfIAvgjIgPA3IAwAiIg6ADIgSA2gAHmEgIg7gEIAwghIgPg4IAvAjIAvgeIgRA2IAsAkIg5gCIgVA1gAICCPIg4AQIAhgvIghgvIA4AQIAjgtIACA6IA2ASIg2ATIgCA4gAolB8Ig3gTIA3gSIACg5IAjAtIA3gRIghAvIAhAvIg3gPIgjAtgAHTggIgvgiIA6gDIARg2IAVA2IA6gBIgtAkIASA0IgwgdIgvAhgAn4gTIgwAeIARg1IgsgkIA6ABIAVg1IARA2IA6ACIgvAiIAOA3gAGOimIg3gSIA1gUIABg5IAkAtIA4gQIghAvIAhAuIg3gPIgiAugAm3iiIg4APIAiguIghgvIA3ARIAkgtIABA5IA2ATIg3ASIgCA7gAEckSIg6AAIAsgkIgSg2IAyAeIAughIgPA3IAvAhIg5AEIgRA2gAlIkbIg5gDIAughIgOg4IAuAhIAxgeIgSA2IAtAkIg7AAIgVA1gAjAlpIg3gSIA2gVIABg4IAjAtIA3gRIgfAuIAiAuIg4gPIgiAvgACXldIg4ARIAggwIgiguIA4AQIAjguIACA4IA2ASIg1AUIAAA6gAAAl2IguAgIAQg3IgugiIA6gCIASg1IATA1IA6ACIgtAiIAQA3g',
      );
    this.shape_14.setTransform(0.025, -10.8);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AlsHiIg0AbIAYg1IgqgpIA7AGIAZg0IALA5IA6AJIgxAdIAJA5gAFaG+IgygcIA6gKIALg5IAbA0IA4gHIgnApIAYA1IgzgaIgsAmgAnXFeIg4ALIAkgrIgagyIA0AVIAogrIgFA7IA1AZIg6AOIgGA5gAHEE/Ig5gMIAzgbIgIg6IAqAoIAzgYIgYA0IAoApIg5gHIgbAzgAoYC5Ig5gIIAygcIgJg6IArAnIA0gaIgYA0IAoAqIg5gGIgbAygAH8CqIg6AHIApgqIgZg1IA0AaIAqgmIgHA4IAxAcIg5AJIgKA5gAooAQIgxgbIA5gJIAKg5IAbAyIA5gGIgoApIAZA0Ig0gaIgqAngAH9AUIgzAaIAYgzIgogqIA5AHIAbgzIALA5IA4AJIgxAbIAJA6gAnfh2IgzAZIAXg1IgngpIA4AHIAcgzIALA4IA5ALIgzAbIAJA6gAGyiTIg1gYIA4gOIAIg4IAeAxIA4gLIglArIAaAzIg0gWIgoAqgAmHkDIg5AGIAogpIgYg0IAzAaIAsgnIgJA5IAyAcIg5AJIgLA5gAFWkLIg6gJIAygdIgJg5IArAmIAzgaIgXA0IAoAqIg5gGIgZA0gAkQlpIg4gIIAwgdIgIg5IAqAmIA0gaIgXA0IAqAoIg6gFIgZA0gADTlkIg4AKIAlgsIgbgyIA1AVIAngpIgDA6IAyAZIg3ANIgIA6gAh3mnIgygbIA4gMIAKg4IAcAyIA5gJIgoArIAbA0Ig1gZIgpApgABDmYIg0AbIAYg1IgpgpIA6AGIAYgzIANA4IA4AJIgwAdIAJA4g',
      );
    this.shape_15.setTransform(0, -7.475);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AlLHlIgughIA5gDIARg3IAVA1IA6AAIgsAkIASA2IgxgfIguAigAE1HzIgxAeIASg1IgsgkIA6AAIAVg1IASA2IA5ADIgvAhIAPA3gAmvGEIg4ARIAhguIghgvIA4APIAiguIACA6IA3ASIg2AUIgBA4gAGUFyIg2gVIA3gSIACg6IAjAuIA3gPIghAvIAhAuIg4gRIgkAugAoBDzIg6AAIAsgjIgRg3IAvAfIAvgiIgPA3IAwAhIg6AEIgSA2gAHmDrIg7gEIAwghIgPg4IAvAjIAvgfIgRA2IAsAkIg5gBIgVA1gAICBaIg4AQIAhgvIghgwIA4AQIAjgsIACA5IA2ATIg2ATIgCA4gAolBHIg3gTIA3gSIACg5IAjAsIA3gQIghAvIAhAvIg3gQIgjAtgAHThWIgvghIA6gEIARg2IAVA2IA6gBIgtAkIASA1IgwgdIgvAigAn4hIIgwAeIARg2IgsgkIA6ABIAVg1IARA2IA6ADIgvAhIAOA5gAGOjcIg3gSIA1gUIABg4IAkAtIA4gRIghAvIAhAuIg3gOIgiAugAm3jXIg4APIAigvIghgvIA3ARIAkgtIABA5IA2AUIg3ASIgCA6gAEclIIg6AAIAsgkIgSg1IAyAeIAugiIgPA3IAvAiIg5ADIgRA2gAlIlRIg5gDIAughIgOg4IAuAiIAxgeIgSA2IAtAkIg7AAIgVA1gAjAmeIg3gSIA2gVIABg5IAjAtIA3gRIgfAvIAiAuIg4gPIgiAugACXmTIg4ARIAggvIgiguIA4APIAjguIACA5IA2ASIg1AUIAAA5gAAAmsIguAhIAQg3IgugjIA6gBIASg1IATA1IA6ABIgtAjIAQA3g',
      );
    this.shape_16.setTransform(0.025, -5.45);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Aj5IAIg0gYIA3gOIAIg5IAeAxIA6gKIgnArIAcAzIg1gWIgpAqgAD2IGIg0AZIAYg0IgogqIA6AIIAbgzIALA5IA4ALIgyAbIAHA5gAlsGxIg0AcIAYg2IgqgpIA7AGIAZg0IALA5IA6AJIgxAeIAJA4gAFaGOIgygdIA6gKIALg5IAbA0IA4gHIgnAqIAYA0IgzgZIgsAmgAnXEtIg4ALIAkgqIgagzIA0AVIAogqIgFA6IA1AaIg6ANIgGA5gAHEEOIg5gMIAzgbIgIg5IAqAnIAzgYIgYA0IAoApIg5gHIgbAzgAoYCJIg5gJIAygcIgJg6IArAoIA0gaIgYA0IAoApIg5gGIgbAygAH8B5Ig6AHIApgqIgZg1IA0AaIAqgmIgHA4IAxAcIg5AJIgKA6gAooggIgxgcIA5gIIAKg6IAbAyIA5gGIgoAqIAZA0Ig0gaIgqAmgAH9gcIgzAaIAYgzIgogqIA5AGIAbgzIALA5IA4AJIgxAcIAJA5gAnfinIgzAZIAXg1IgngpIA4AHIAcgzIALA5IA5AKIgzAcIAJA5gAGyjDIg1gZIA4gNIAIg5IAeAyIA4gMIglArIAaAzIg0gVIgoApgAmHk0Ig5AGIAogpIgYg0IAzAaIAsgnIgJA5IAyAcIg5AKIgLA4gAFWk8Ig6gJIAygdIgJg4IArAlIAzgaIgXA0IAoAqIg5gGIgZA0gAkQmaIg4gIIAwgcIgIg6IAqAnIA0gaIgXA0IAqAnIg6gFIgZA0gADTmVIg4ALIAlgsIgbgzIA1AWIAngqIgDA6IAyAZIg3ANIgIA6gAh3nYIgygbIA4gLIAKg5IAcAyIA5gJIgoArIAbA0Ig1gYIgpAogABDnIIg0AbIAYg2IgpgpIA6AGIAYgzIANA4IA4AJIgwAeIAJA3g',
      );
    this.shape_17.setTransform(0, -2.6);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'ACdIXIg4APIAiguIgggvIA3ARIAlgtIAAA5IA1AUIg2ASIgDA5gAi5IMIg2gUIA3gSIACg5IAjAuIA4gPIgiAuIAfAvIg3gRIgjAtgAlLG8IguggIA5gEIARg3IAVA1IA6AAIgsAkIASA2IgxgeIguAigAE1HLIgxAdIASg1IgsgkIA6AAIAVg1IASA2IA5AEIgvAhIAPA3gAmvFcIg4ARIAhgvIghgvIA4AQIAiguIACA5IA3ASIg2AUIgBA5gAGUFJIg2gVIA3gSIACg5IAjAuIA3gQIghAvIAhAvIg4gRIgkAugAoBDKIg6ABIAsgkIgRg2IAvAfIAvgjIgPA3IAwAiIg6ADIgSA2gAHmDCIg7gEIAwghIgPg4IAvAjIAvgeIgRA2IAsAkIg5gCIgVA1gAICAxIg4AQIAhgvIghguIA4AQIAjgtIACA5IA2ASIg2ATIgCA4gAolAeIg3gTIA3gRIACg5IAjAtIA3gRIghAuIAhAvIg3gPIgjAtgAHTh+IgvgiIA6gDIARg2IAVA2IA6gBIgtAkIASA1IgwgeIgvAigAn4hxIgwAfIARg2IgsgkIA6ABIAVg1IARA2IA6ACIgvAiIAOA4gAGOkEIg3gSIA1gUIABg5IAkAtIA4gQIghAvIAhAuIg3gPIgiAugAm3kAIg4APIAiguIghgvIA3ARIAkgtIABA5IA2ATIg3ASIgCA7gAEclwIg6AAIAsgkIgSg2IAyAeIAughIgPA3IAvAhIg5AEIgRA2gAlIl5Ig5gDIAughIgOg4IAuAhIAxgeIgSA2IAtAkIg7AAIgVA1gAjAnHIg3gSIA2gVIABg4IAjAtIA3gRIgfAuIAiAuIg4gPIgiAvgACXm7Ig4ARIAggwIgiguIA4AQIAjguIACA4IA2ASIg1AUIAAA6gAAAnUIguAgIAQg3IgugiIA6gCIASg1IATA1IA6ACIgtAiIAQA3g',
      );
    this.shape_18.setTransform(0.025, -1.4);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AhdIcIg4gLIAygcIgGg5IApAoIA0gYIgYA0IAlApIg4gHIgaAzgABUIfIg6AIIAogqIgag0IA1AYIApgpIgHA5IAzAcIg5ALIgJA5gAj5HlIg0gYIA3gOIAIg5IAeAxIA6gJIgnArIAcAyIg1gVIgpApgAD2HsIg0AYIAYgzIgogrIA6AIIAbgzIALA5IA4ALIgyAbIAHA5gAlsGWIg0AcIAYg2IgqgoIA7AFIAZgzIALA4IA6AJIgxAeIAJA5gAFaFzIgygdIA6gKIALg4IAbAzIA4gHIgnAqIAYA0IgzgZIgsAmgAnXETIg4ALIAkgrIgagzIA0AWIAogrIgFA6IA1AaIg6ANIgGA5gAHEDzIg5gLIAzgbIgIg6IAqAoIAzgZIgYA0IAoApIg5gHIgbAzgAoYBuIg5gJIAygcIgJg6IArAoIA0gaIgYA0IAoApIg5gGIgbAzgAH8BeIg6AHIApgpIgZg2IA0AbIAqgmIgHA4IAxAcIg5AJIgKA5gAoog6IgxgdIA5gIIAKg6IAbAzIA5gGIgoApIAZA1Ig0gaIgqAmgAH9g2IgzAaIAYg0IgogqIA5AGIAbgyIALA4IA4AJIgxAcIAJA6gAnfjCIgzAZIAXg1IgngoIA4AGIAcgyIALA4IA5AKIgzAcIAJA6gAGyjeIg1gZIA4gNIAIg5IAeAyIA4gMIglAsIAaAzIg0gWIgoAqgAmHlPIg5AHIAogqIgYg0IAzAaIAsgnIgJA5IAyAcIg5AKIgLA5gAFWlXIg6gJIAygdIgJg4IArAmIAzgbIgXA1IAoApIg5gGIgZA0gAkQm0Ig4gIIAwgdIgIg6IAqAnIA0gaIgXA0IAqAoIg6gGIgZA1gADTmwIg4ALIAlgsIgbgyIA1AVIAngqIgDA6IAyAZIg3ANIgIA6gAh3nyIgygcIA4gLIAKg5IAcAyIA5gIIgoAqIAbA0Ig1gYIgpApgABDnjIg0AbIAYg2IgpgoIA6AGIAYg0IANA4IA4AJIgwAeIAJA4g',
      );
    this.shape_19.setTransform(0, 0.075);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [] })
        .to({ state: [{ t: this.shape }] }, 31)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_4 }] }, 1)
        .to({ state: [{ t: this.shape_5 }] }, 1)
        .to({ state: [{ t: this.shape_6 }] }, 1)
        .to({ state: [{ t: this.shape_7 }] }, 1)
        .to({ state: [{ t: this.shape_8 }] }, 1)
        .to({ state: [{ t: this.shape_9 }] }, 1)
        .to({ state: [{ t: this.shape_10 }] }, 1)
        .to({ state: [{ t: this.shape_11 }] }, 1)
        .to({ state: [{ t: this.shape_12 }] }, 1)
        .to({ state: [{ t: this.shape_13 }] }, 1)
        .to({ state: [{ t: this.shape_14 }] }, 1)
        .to({ state: [{ t: this.shape_15 }] }, 1)
        .to({ state: [{ t: this.shape_16 }] }, 1)
        .to({ state: [{ t: this.shape_17 }] }, 1)
        .to({ state: [{ t: this.shape_18 }] }, 1)
        .to({ state: [{ t: this.shape_19 }] }, 1)
        .wait(50),
    );

    // Layer 3
    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#FFFFFF')
      .s()
      .p('AABA0Ig9ArIAUhIIg7gsIBMgDIAYhGIAYBGIBLADIg7AsIAVBIg');
    this.shape_20.setTransform(0, -68.975);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'ABgAvIhFAeIAhhCIgyg3IBLALIAlhAIAMBJIBJAQIhCAhIAIBLgAiOAWIhAglIBKgLIARhJIAhBEIBLgGIg2AyIAdBFIhCgjIg5Axg',
      );
    this.shape_21.setTransform(0.525, -68.475);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Aj1AtIhHgYIBGgaIABhKIAuA6IBIgWIgpA9IAsA9IhIgUIgtA9gADIA8IhIAYIAqg/Igsg9IBJAVIAsg8IADBKIBHAXIhFAbIgBBLgAAFAcIg9AqIAVhHIg7gtIBLgDIAYhGIAZBGIBLADIg7AtIAVBHg',
      );
    this.shape_22.setTransform(-0.475, -66.5);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AlSBDIhKgKIBBgnIgMhJIA3AyIBDgiIgdBDIA2A0IhLgHIgiBEgAEkBJIhLANIAxg5IgkhAIBGAcIAzg2IgFBKIBDAgIhJARIgJBLgAiLgNIhCgjIBKgQIAMhKIAlBCIBKgLIgzA3IAiBDIhEggIg2A1gABoAGIhDAjIAehFIg2g0IBLAHIAhhDIAQBJIBKALIhAAnIANBIg',
      );
    this.shape_23.setTransform(-1.625, -63.525);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AF1BpIhMAAIA6gwIgXhFIA/AmIA9grIgTBIIA8ArIhKAFIgWBIgAmmBdIhKgFIA9grIgUhIIA8ArIBAgmIgXBFIA5AwIhLAAIgbBGgAj1gJIhHgXIBGgbIABhLIAuA7IBHgXIgpA+IAsA8IhIgUIgtA9gADHAGIhIAXIAqg+Igsg9IBJAUIAtg8IACBKIBHAYIhFAbIgBBKgAAFgaIg9AqIAUhHIg7guIBMgCIAYhHIAYBHIBLACIg7AuIAVBHg',
      );
    this.shape_24.setTransform(-0.4, -61.025);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'An1CJIhKAIIA0g1IgfhFIBCAiIA5gzIgLBKIBBAkIhLAOIgPBJgAHFB+IhLgMIBBgmIgMhJIA5AyIBCgjIgeBEIA0A2IhKgIIghBEgAlaAFIhKgKIBBgnIgMhKIA3AzIBDgjIgdBEIA2AzIhLgGIgiBDgAEcALIhLAMIAxg3IgkhCIBGAcIAzg2IgFBMIBDAfIhJARIgJBLgAiThMIhCgjIBKgQIAMhKIAlBCIBKgLIgzA3IAiBEIhEggIg2A1gABgg4IhDAjIAehGIg2g0IBLAHIAhhCIAQBJIBKAKIhAAnIANBKg',
      );
    this.shape_25.setTransform(-0.825, -57.25);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AIICtIhHgYIBGgaIABhLIAvA8IBIgXIgrA+IArA+IhIgUIgtA8gAo2CzIhIAUIArg+Igrg+IBIAXIAvg8IABBLIBGAaIhHAYIgDBMgAF1AeIhMAAIA6guIgXhHIA/AoIA9gtIgTBJIA8ArIhKAEIgWBIgAmmASIhKgEIA9grIgUhJIA8AtIBAgoIgXBHIA5AuIhLAAIgbBGgAj1hTIhHgYIBGgbIABhLIAuA7IBHgWIgpA+IAsA9IhIgUIgtA9gADHhEIhIAXIAqg/Igsg9IBJAVIAtg9IACBLIBHAYIhFAaIgBBLgAAFhlIg9ArIAUhIIg7gtIBMgDIAYhGIAYBGIBLADIg7AtIAVBIg',
      );
    this.shape_26.setTransform(-0.4, -53.575);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AplDsIhDAgIAfhEIg0g2IBLAJIAkhCIAOBKIBJANIhCAkIALBMgAI/DHIhEggIBJgSIAKhKIAnBBIBJgOIgwA4IAiBCIhEgcIgzA3gAnzA1IhKAIIA0g1IgfhEIBDAiIA4gzIgLBKIBBAjIhKAOIgPBJgAHIAqIhLgMIBAglIgMhJIA5AyIBDgjIgfBDIA1A2IhKgIIgiBEgAlXhOIhKgLIBAgnIgMhKIA4AzIBDgjIgeBEIA2A0IhLgGIgiBDgAEehIIhKAMIAwg4IgjhCIBGAcIAzg2IgGBMIBDAfIhIARIgKBMgAiQigIhCgjIBJgQIANhKIAkBCIBLgLIgzA3IAiBEIhFggIg1A1gABiiMIhDAjIAehGIg2g0IBMAHIAhhCIAQBJIBJAKIg/AnIAMBKg',
      );
    this.shape_27.setTransform(-1.075, -48.85);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AJiEHIg9gsIBLgFIAXhHIAbBGIBKgBIg5AvIAWBHIg+gnIg8AtgAqKEZIg+AnIAWhHIg5gvIBKABIAbhGIAXBHIBLAFIg9AsIATBJgAIIBWIhHgXIBGgbIABhKIAvA7IBIgWIgrA9IArA+IhIgUIgtA9gAo2BcIhIAUIArg+Igrg9IBIAWIAvg7IABBKIBGAaIhHAYIgDBNgAF1g4IhMAAIA6gvIgXhHIA/AoIA9gsIgTBJIA8ArIhKAEIgWBHgAmmhEIhKgEIA9grIgUhJIA8AsIBAgoIgXBHIA5AvIhLAAIgbBFgAj1iqIhHgYIBGgbIABhKIAuA6IBHgWIgpA+IAsA9IhIgUIgtA9gADHibIhIAYIAqg/Igsg+IBJAVIAtg8IACBKIBHAYIhFAbIgBBLgAAFi7Ig9AqIAUhIIg7gtIBMgDIAYhGIAYBGIBLADIg7AtIAVBIg',
      );
    this.shape_28.setTransform(-0.4, -44.9);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'ArJE5IhBglIBKgLIAOhLIAjBCIBLgIIg1A2IAgBFIhEgiIg2AygAKdE+IhDAiIAfhEIg0g2IBKAIIAjhCIAPBKIBKAMIhBAlIAKBKgApqCJIhEAgIAghEIg1g2IBLAJIAkhBIAOBIIBJAOIhCAkIALBLgAI5BkIhEggIBKgSIAJhJIAnBAIBKgPIgwA5IAiBCIhEgcIg0A3gAn4guIhKAJIA0g2IgfhEIBCAhIA5gyIgLBKIBBAkIhLANIgPBJgAHCg4IhLgMIBBgmIgMhKIA5AzIBCgjIgeBEIA0A2IhKgIIghBDgAldiyIhKgKIBBgnIgMhKIA3AyIBDgiIgdBEIA2A0IhLgHIgiBEgAEZisIhLANIAxg5IgkhBIBGAcIAzg2IgFBLIBDAgIhJARIgJBLgAiWkDIhCgjIBKgQIAMhKIAlBCIBKgLIgzA3IAiBEIhEggIg2A1gABdjvIhDAjIAehGIg2g0IBLAHIAhhDIAQBJIBKALIhAAnIANBJg',
      );
    this.shape_29.setTransform(-0.525, -38.925);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AKaGCIhIAWIArg/Igrg+IBIAWIAug8IACBLIBHAZIhHAZIgCBLgArJFqIhHgaIBHgYIAChLIAuA7IBIgWIgrA+IArA+IhIgUIguA7gAJeCaIg+gsIBMgFIAWhHIAbBGIBLgBIg5AvIAWBHIg+gnIg8AtgAqPCsIg+AnIAXhHIg6gvIBLABIAbhGIAXBHIBLAFIg9AsIATBJgAIEgWIhIgXIBGgbIABhLIAvA8IBIgXIgqA+IArA9IhIgTIgtA8gAo6gQIhIATIArg9Igrg+IBIAXIAvg8IABBLIBGAaIhHAYIgDBMgAFxilIhMAAIA6gvIgYhHIBAAoIA8gsIgTBJIA9ArIhKAEIgXBIgAmqixIhKgEIA8grIgThJIA8AsIBAgoIgXBHIA5AvIhLAAIgcBGgAj6kXIhHgYIBGgbIABhKIAuA6IBIgWIgpA+IAsA9IhIgUIgtA9gADDkIIhIAYIAqg/Igsg+IBJAVIAsg8IADBKIBHAYIhFAbIgBBLgAAAkoIg9AqIAVhIIg7gtIBLgDIAYhGIAZBGIBLADIg7AtIAVBIg',
      );
    this.shape_30.setTransform(0.025, -34);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Aq7GnIhKgMIBCgkIgLhLIA3AzIBDgiIgfBEIA1A2IhLgIIgjBCgAKWGTIhMAIIA1g2IgfhFIBDAiIA2gyIgKBKIBBAlIhKALIgOBKgArODLIhBglIBKgMIAOhKIAiBCIBLgJIg1A2IAgBFIhDgiIg3AygAKXDQIhCAiIAfhFIg1g2IBLAJIAjhCIAPBJIBJANIhBAkIALBLgApwAaIhDAgIAfhDIg0g2IBLAKIAkhDIAOBKIBJANIhCAjIALBMgAI0gKIhEggIBKgSIAJhJIAnBAIBJgOIgwA4IAjBBIhFgcIgzA3gAn9icIhKAIIAzg1IgehFIBCAiIA5gyIgMBJIBCAlIhLANIgPBKgAG9inIhLgMIBBgmIgNhJIA6AyIBCgjIgeBFIA0A1IhKgHIghBDgAlikgIhKgLIBAgmIgLhLIA3AzIBDgjIgeBEIA2A0IhKgGIgiBDgAETkaIhKANIAwg5IgjhBIBGAbIAzg2IgGBMIBEAgIhJARIgKBLgAiblyIhCgjIBJgPIANhKIAkBBIBLgKIgzA3IAiBDIhFggIg1A2gABXleIhCAjIAdhFIg1g0IBLAHIAhhDIAQBJIBJALIg/AmIAMBKg',
      );
    this.shape_31.setTransform(0, -27.875);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AqbHhIhLACIA6gwIgXhHIA+AoIA9gtIgTBJIA9AsIhLAEIgXBHgAJ2HWIhMgEIA+gsIgThJIA8AtIA+goIgWBHIA5AwIhLgCIgbBGgAKaEXIhIAWIArg+Igrg+IBIAVIAug8IACBMIBHAZIhHAYIgCBMgArJD/IhHgZIBHgYIAChLIAuA6IBIgVIgrA+IArA+IhIgVIguA8gAJeAvIg+gsIBMgDIAWhIIAbBHIBLgBIg5AuIAWBHIg+goIg8AtgAqPBBIg+AoIAXhHIg6guIBLABIAbhGIAXBHIBLAEIg9ArIATBJgAIEiAIhIgYIBGgbIABhKIAvA7IBIgWIgqA+IArA+IhIgVIgtA9gAo6h7IhIAVIArg+Igrg+IBIAWIAvg7IABBKIBGAbIhHAYIgDBMgAFxkPIhMAAIA6gvIgYhHIBAAnIA8gsIgTBJIA9ArIhKAFIgXBIgAmqkbIhKgFIA8grIgThJIA8AsIBAgnIgXBGIA5AwIhLAAIgcBGgAj6mCIhHgXIBGgbIABhLIAuA7IBIgXIgpA+IAsA+IhIgUIgtA8gADDlyIhIAXIAqg/Igsg9IBJAVIAsg9IADBKIBHAYIhFAbIgBBLgAAAmTIg9ArIAVhIIg7gtIBLgDIAYhGIAZBGIBLADIg7AtIAVBIg',
      );
    this.shape_32.setTransform(0.025, -23.35);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'ApmIXIhKAOIAwg4IghhCIBDAdIA0g4IgGBMIBFAgIhKASIgKBKgAJMHuIhJgPIBCgkIgKhLIA2A0IBDggIggBEIA1A2IhLgKIgkBDgAq7FBIhKgNIBCgkIgLhKIA3AyIBDghIgfBDIA1A2IhLgIIgjBDgAKWEsIhMAIIA1g2IgfhFIBDAiIA2gxIgKBJIBBAlIhKALIgOBLgArOBkIhBglIBKgLIAOhKIAiBBIBLgIIg1A2IAgBEIhDghIg3AxgAKXBpIhCAiIAfhEIg1g2IBLAIIAjhBIAPBJIBJAMIhBAkIALBLgApwhMIhDAgIAfhEIg0g2IBLAKIAkhDIAOBKIBJAOIhCAkIALBLgAI0hxIhEgfIBKgSIAJhKIAnBBIBJgPIgwA4IAjBDIhFgcIgzA3gAn9kDIhKAIIAzg1IgehFIBCAiIA5gyIgMBKIBCAkIhLANIgPBKgAG9kNIhLgMIBBgnIgNhJIA6AzIBCgjIgeBEIA0A1IhKgHIghBDgAlimHIhKgLIBAgmIgLhKIA3AyIBDgjIgeBEIA2A1IhKgHIgiBEgAETmBIhKANIAwg5IgjhBIBGAbIAzg2IgGBMIBEAgIhJARIgKBLgAibnZIhCgjIBJgPIANhKIAkBCIBLgLIgzA3IAiBDIhFgfIg1A1gABXnEIhCAiIAdhFIg1g0IBLAHIAhhDIAQBJIBJALIg/AnIAMBJg',
      );
    this.shape_33.setTransform(0, -17.6);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AowJHIhIAWIArg+Igrg9IBIAUIAsg9IADBMIBHAYIhGAbIgBBKgAIMIuIhGgbIBIgYIAChMIAtA9IBIgUIgrA9IAqA+IhIgWIgvA7gAqbGGIhLACIA6gwIgXhHIA+AoIA9gtIgTBJIA9AsIhLAFIgXBHgAJ2F8IhMgFIA+gsIgThJIA8AtIA+goIgWBHIA5AwIhLgCIgbBHgAKaC9IhIAVIArg+Igrg+IBIAVIAug7IACBLIBHAZIhHAZIgCBLgArJCkIhHgZIBHgYIAChLIAuA7IBIgWIgrA+IArA+IhIgVIguA8gAJegrIg+gsIBMgEIAWhHIAbBGIBLgBIg5AvIAWBGIg+gnIg8AtgAqPgZIg+AnIAXhGIg6gvIBLABIAbhGIAXBHIBLAEIg9AsIATBJgAIEjbIhIgYIBGgaIABhLIAvA8IBIgXIgqA+IArA+IhIgUIgtA8gAo6jVIhIAUIArg+Igrg+IBIAXIAvg8IABBLIBGAaIhHAYIgDBMgAFxlqIhMAAIA6gvIgYhHIBAAoIA8gtIgTBJIA9AsIhKAEIgXBIgAmql2IhKgEIA8gsIgThJIA8AtIBAgoIgXBHIA5AvIhLAAIgcBGgAj6ncIhHgYIBGgbIABhLIAuA7IBIgWIgpA+IAsA9IhIgUIgtA9gADDnNIhIAXIAqg/Igsg9IBJAVIAsg9IADBLIBHAYIhFAaIgBBLgAAAnuIg9ArIAVhIIg7gtIBLgDIAYhGIAZBGIBLADIg7AtIAVBIg',
      );
    this.shape_34.setTransform(0.025, -14.275);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AnbJ0IhDAjIAfhFIg1g2IBKAIIAihDIAPBKIBLALIhAAmIAMBLgAHEJFIhCglIBLgNIAOhJIAjBCIBKgIIg0A1IAfBFIhCgiIg5AzgApmHJIhKAOIAwg5IghhBIBDAcIA0g3IgGBLIBFAhIhKASIgKBJgAJMGfIhJgOIBCgkIgKhMIA2A0IBDgfIggBDIA1A2IhLgKIgkBDgAq7DyIhKgMIBCgkIgLhLIA3AyIBDghIgfBEIA1A2IhLgIIgjBCgAKWDeIhMAIIA1g2IgfhGIBDAjIA2gyIgKBKIBBAlIhKALIgOBKgArOAWIhBglIBKgLIAOhKIAiBBIBLgIIg1A1IAgBFIhDgiIg3AygAKXAaIhCAjIAfhEIg1g2IBLAIIAjhBIAPBJIBJAMIhBAkIALBLgApwiaIhDAgIAfhEIg0g2IBLAJIAkhCIAOBKIBJANIhCAkIALBMgAI0i/IhEggIBKgSIAJhKIAnBBIBJgOIgwA4IAjBCIhFgcIgzA3gAn9lRIhKAIIAzg1IgehFIBCAiIA5gzIgMBKIBCAkIhLAOIgPBJgAG9lcIhLgMIBBgmIgNhJIA6AyIBCgjIgeBEIA0A2IhKgIIghBEgAlinVIhKgLIBAgnIgLhKIA3AzIBDgjIgeBEIA2A0IhKgGIgiBDgAETnPIhKAMIAwg4IgjhCIBGAcIAzg2IgGBMIBEAfIhJARIgKBMgAibonIhCgjIBJgQIANhKIAkBCIBLgLIgzA3IAiBEIhFggIg1A1gABXoTIhCAjIAdhGIg1g0IBLAHIAhhCIAQBJIBJAKIg/AnIAMBKg',
      );
    this.shape_35.setTransform(0, -9.75);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AmuKAIg8gsIBKgEIAWhIIAcBGIBLAAIg5AvIAXBHIhAgoIg8AtgAGRKSIhAAoIAYhHIg6gvIBMAAIAbhGIAXBIIBKAEIg9AsIATBJgAowIAIhIAXIArg+Igrg+IBIAUIAsg8IADBMIBHAYIhGAaIgBBLgAIMHnIhGgaIBIgYIAChMIAtA8IBIgUIgrA+IAqA+IhIgXIgvA8gAqbFAIhLABIA6gvIgXhHIA+AoIA9guIgTBKIA9AsIhLAEIgXBHgAJ2E1IhMgEIA+gsIgThKIA8AuIA+goIgWBHIA5AvIhLgBIgbBGgAKaB2IhIAWIArg+Igrg+IBIAVIAug7IACBLIBHAZIhHAYIgCBLgArJBeIhHgZIBHgZIAChKIAuA6IBIgVIgrA+IArA+IhIgVIguA7gAJehxIg+gsIBMgFIAWhHIAbBHIBLgCIg5AwIAWBHIg+goIg8AtgAqPhfIg+AoIAXhHIg6gwIBLACIAbhHIAXBHIBLAFIg9AsIATBJgAIEkhIhIgYIBGgbIABhKIAvA7IBIgWIgqA+IArA9IhIgUIgtA9gAo6kcIhIAUIArg9Igrg+IBIAWIAvg7IABBKIBGAbIhHAYIgDBMgAFxmwIhMAAIA6gwIgYhGIBAAnIA8gsIgTBJIA9ArIhKAFIgXBIgAmqm8IhKgFIA8grIgThJIA8AsIBAgnIgXBGIA5AwIhLAAIgcBGgAj6ojIhHgXIBGgbIABhLIAuA7IBIgXIgpA+IAsA9IhIgUIgtA9gADDoTIhIAXIAqg/Igsg9IBJAUIAsg8IADBKIBHAYIhFAbIgBBLgAAAo0Ig9ArIAVhIIg7guIBLgCIAYhHIAZBHIBLACIg7AuIAVBIg',
      );
    this.shape_36.setTransform(0.025, -7.225);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AlFKbIhDggIBIgSIAKhLIAnBBIBLgNIgyA5IAkBAIhGgbIgzA2gAFAKjIhFAgIAhhDIg0g3IBLAKIAkhCIANBKIBJAOIhBAjIAKBKgAnbI0IhDAjIAfhEIg1g2IBKAIIAihEIAPBKIBLAMIhAAmIAMBKgAHEIFIhCglIBLgMIAOhKIAjBDIBKgJIg0A2IAfBFIhCgiIg5AygApmGJIhKAOIAwg4IghhCIBDAdIA0g4IgGBMIBFAgIhKASIgKBKgAJMFgIhJgPIBCgkIgKhLIA2A0IBDggIggBEIA1A2IhLgKIgkBDgAq7CzIhKgNIBCgkIgLhKIA3AyIBDghIgfBDIA1A2IhLgIIgjBDgAKWCeIhMAIIA1g2IgfhFIBDAiIA2gxIgKBJIBBAlIhKALIgOBLgArOgpIhBglIBKgLIAOhLIAiBCIBLgIIg1A2IAgBDIhDggIg3AwgAKXgkIhCAiIAfhEIg1g2IBLAIIAjhCIAPBKIBJAMIhBAkIALBKgApwjaIhDAgIAfhEIg0g2IBLAKIAkhDIAOBKIBJAOIhCAkIALBLgAI0j/IhEgfIBKgSIAJhKIAnBBIBJgPIgwA4IAjBDIhFgcIgzA3gAn9mRIhKAIIAzg1IgehFIBCAiIA5gyIgMBKIBCAkIhLANIgPBKgAG9mbIhLgMIBBgnIgNhJIA6AzIBCgjIgeBEIA0A1IhKgHIghBDgAlioVIhKgLIBAgmIgLhKIA3AyIBDgjIgeBEIA2A1IhKgHIgiBEgAEToPIhKANIAwg5IgjhBIBGAbIAzg2IgGBMIBEAgIhJARIgKBLgAibpnIhCgjIBJgPIANhKIAkBCIBLgLIgzA3IAiBDIhFgfIg1A1gABXpSIhCAiIAdhFIg1g0IBLAHIAhhDIAQBJIBJALIg/AnIAMBJg',
      );
    this.shape_37.setTransform(0, -3.4);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'ADMLCIhJAUIAsg9Igqg/IBIAXIAvg7IABBLIBFAbIhHAYIgDBKgAjxKzIhGgbIBHgXIAEhLIAtA9IBIgUIgsA9IApA+IhIgXIguA7gAmuJKIg8grIBKgFIAWhIIAcBGIBLAAIg5AwIAXBGIhAgnIg8AsgAGRJdIhAAnIAYhGIg6gwIBMAAIAbhGIAXBIIBKAFIg9ArIATBJgAowHLIhIAWIArg+Igrg9IBIAUIAsg9IADBMIBHAYIhGAbIgBBKgAIMGyIhGgbIBIgYIAChMIAtA9IBIgUIgrA9IAqA+IhIgWIgvA7gAqbEKIhLACIA6gwIgXhHIA+AoIA9gtIgTBJIA9AsIhLAFIgXBHgAJ2EAIhMgFIA+gsIgThJIA8AtIA+goIgWBHIA5AwIhLgCIgbBHgAKaBBIhIAVIArg+Igrg9IBIAVIAug7IACBLIBHAYIhHAZIgCBLgArJAoIhHgZIBHgXIAChLIAuA7IBIgWIgrA9IArA+IhIgVIguA8gAJeinIg+gsIBMgEIAWhHIAbBGIBLgBIg5AvIAWBHIg+goIg8AugAqPiVIg+AoIAXhHIg6gvIBLABIAbhGIAXBHIBLAEIg9AsIATBKgAIElXIhIgYIBGgaIABhLIAvA8IBIgXIgqA+IArA+IhIgUIgtA8gAo6lRIhIAUIArg+Igrg+IBIAXIAvg8IABBLIBGAaIhHAYIgDBMgAFxnmIhMAAIA6gvIgYhHIBAAoIA8gtIgTBJIA9AsIhKAEIgXBIgAmqnyIhKgEIA8gsIgThJIA8AtIBAgoIgXBHIA5AvIhLAAIgcBGgAj6pYIhHgYIBGgbIABhLIAuA7IBIgWIgpA+IAsA9IhIgUIgtA9gADDpJIhIAXIAqg/Igsg9IBJAVIAsg9IADBLIBHAYIhFAaIgBBLgAAApqIg9ArIAVhIIg7gtIBLgDIAYhGIAZBGIBLADIg7AtIAVBIg',
      );
    this.shape_38.setTransform(0.025, -1.875);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Ah5K/IhJgOIBBgkIgJhKIA3A0IBEggIghBDIAyA2IhKgJIgiBCgABuLDIhMALIA0g4IgihDIBFAgIA1g1IgIBKIBBAjIhJAPIgMBKgAlFJ4IhDggIBIgRIAKhLIAnBAIBLgNIgyA5IAkBBIhGgbIgzA1gAFAKAIhFAhIAhhEIg0g3IBLAKIAkhCIANBKIBJAOIhBAkIAKBKgAnbIRIhDAjIAfhEIg1g2IBKAIIAihDIAPBKIBLALIhAAmIAMBKgAHEHjIhCglIBLgNIAOhKIAjBDIBKgIIg0A1IAfBFIhCgiIg5AygApmFmIhKAPIAwg5IghhCIBDAdIA0g4IgGBMIBFAhIhKARIgKBKgAJME9IhJgOIBCgkIgKhMIA2A0IBDggIggBEIA1A2IhLgKIgkBDgAq7CQIhKgMIBCglIgLhKIA3AyIBDghIgfBEIA1A2IhLgIIgjBCgAKWB7IhMAJIA1g2IgfhGIBDAjIA2gxIgKBJIBBAkIhKAMIgOBKgArOhMIhBglIBKgLIAOhLIAiBCIBLgIIg1A2IAgBFIhDgiIg3AygAKXhHIhCAiIAfhEIg1g2IBLAIIAjhCIAPBKIBJAMIhBAlIALBKgApwj8IhDAgIAfhEIg0g2IBLAJIAkhCIAOBJIBJAOIhCAkIALBLgAI0khIhEggIBKgSIAJhKIAnBBIBJgPIgwA5IAjBCIhFgcIgzA3gAn9m0IhKAJIAzg2IgehEIBCAhIA5gyIgMBKIBCAkIhLANIgPBKgAG9m+IhLgMIBBgmIgNhKIA6AzIBCgjIgeBEIA0A2IhKgIIghBEgAlio4IhKgKIBAgnIgLhKIA3AyIBDgiIgeBEIA2A0IhKgHIgiBEgAEToyIhKANIAwg5IgjhBIBGAcIAzg2IgGBLIBEAgIhJARIgKBLgAibqJIhCgjIBJgQIANhKIAkBCIBLgLIgzA3IAiBEIhFggIg1A1gABXp1IhCAjIAdhGIg1g0IBLAHIAhhDIAQBJIBJALIg/AnIAMBJg',
      );
    this.shape_39.setTransform(0, 0.075);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [] })
        .to({ state: [{ t: this.shape_20 }] }, 11)
        .to({ state: [{ t: this.shape_21 }] }, 1)
        .to({ state: [{ t: this.shape_22 }] }, 1)
        .to({ state: [{ t: this.shape_23 }] }, 1)
        .to({ state: [{ t: this.shape_24 }] }, 1)
        .to({ state: [{ t: this.shape_25 }] }, 1)
        .to({ state: [{ t: this.shape_26 }] }, 1)
        .to({ state: [{ t: this.shape_27 }] }, 1)
        .to({ state: [{ t: this.shape_28 }] }, 1)
        .to({ state: [{ t: this.shape_29 }] }, 1)
        .to({ state: [{ t: this.shape_30 }] }, 1)
        .to({ state: [{ t: this.shape_31 }] }, 1)
        .to({ state: [{ t: this.shape_32 }] }, 1)
        .to({ state: [{ t: this.shape_33 }] }, 1)
        .to({ state: [{ t: this.shape_34 }] }, 1)
        .to({ state: [{ t: this.shape_35 }] }, 1)
        .to({ state: [{ t: this.shape_36 }] }, 1)
        .to({ state: [{ t: this.shape_37 }] }, 1)
        .to({ state: [{ t: this.shape_38 }] }, 1)
        .to({ state: [{ t: this.shape_39 }] }, 1)
        .wait(70),
    );

    // Layer 1
    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'ABSE1QgVALgTAFQgUAGgSAAQgRAAgUgGQgWgFgXgLIlzAcIAApHIBNgDIAgg9QAxgNAsgHQAsgGAnAAQBDAAAmASQAmARAVAqQATgpAogSQAogSBFAAQAkAAArAGQAqAHAyANIAeA5IBRAEIAAJKgAFtEDIgohPQgxgKgqgGQgqgFgiAAQiUAAAABkQAfgGARgTgAgKEDQgFg1gjgYQgjgXhLAAQgjAAgoAFQgoAFgtAKIgqBQIE0gZQANARAfAIgAl7jFIAAG1IAshRIAAmugAFQCfIAsBOIAAmtIgshOgAApkcQgfAZAAA9IAAGHQAdgfAggLQAigLA5AAQAmAAAnADQAmAFAnAJIAAnEQgvgLgngFQgngFggAAQhOAAgoAggAgKDAIAAmHQAAg7gkgdQglgdhJAAQglAAgoAFQgoAGgqALIAAHCQAxgIAmgFQAlgDAaAAQBtAAAuA0g',
      );
    this.shape_40.setTransform(0, -0.275);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AiJGXIjTkDIAAgdIAHABQAMAAAAgTQAAgFgaghIgzhAIAAgeIAQAAIACgCQACgXAAgoQAAgogDgOIgJgOQgIgKAAgCIAAgcIA6AAIAAgdIAQAAQAFgLAAgrQAAg1gFgOQAAgEgIgJQgIgKAAgBIAAgcIHYAAQAEAAB8B3QB4BzAOAQQACACAIAXQALAhAAAvQABA5gVAlIhAAAQATAqAEAhIAAAWQAAASANALQAVASAEAGQAYAjgBBIQAAA+gWAtgAhjEKIABAIIABAHIAAApQAAAWgKAbIHTACQAMgmgBgjQAAgNgCgYQgBgGgCAAInRAAgAk0COICuDWIAHghIAAhMIg0AAIh8iFQgDASgCAKgAifBpQADAUABAZQAAA2gLASIHTAAQAMghABgnQgBgrgMgWInOAAIAAADIAAAAIACARgAFRDPIALABIAEAAIALgBIgUgSQgBAEgFAOgAlshmQAEARAAALQAAAmgHAcICuDVQAJgugBg3QAAgTgGgJQhRhqhfhiQAAAJADARgAieA3IG/AAIgKgOImbgBQgEAAgFgHIiojMIgyAAgAhkhiQADATAAAbQAAAigIAfIHTAAQAJgcAAgkQAAgwgMgSInPAAIAAAEIABgBQABAAACAQgAkuj9QAAAPgGAcICuDUQAHgnAAgYQAAg4gHgJQgEgHgxg6Ih7iPQAIAjAAAug',
      );
    this.shape_41.setTransform(-0.05, 0.375);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AkgKHQiZgrg5gfIhJg6QidhyAAh0QABgmA1kPIJ9D7IKvjJQAIAXAWBEQAcB8AABPQAAAcgYAxQgXAwgYARQgJAHhEAdQgtAZhyA2QkfBxi+AAQg6AAiagrgAufKCQAAgdgEgNQgSAIgEAAQgWAAgUgiQgVghACgXIAXq+IlHi0IAAgUIUXkxIU2GYIAAAzI1IGsItRlKIAfLZQAAAUgPABQgWAAgLAYgAuCjFQAQARgEANQA1gTBggoQACgDgBgLQAAglgjAAQgCAAigA/IAGgBQANAAAQASgAmmlGQicAgh2AXIANAYQEvhLDvgDIgEghQh3ADieAdgAhllTQAAAyBoAAQAaAAAWgbIAAgYQgWgfhEAAQg+AAAAAgg',
      );
    this.shape_42.setTransform(-0.0001, 0.1235, 0.3791, 0.3787);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgeHzIgLgIQgIgBgKgDIghgVIgggQQgPgJgMgQQgIgLAAgfIgBgJIgCgJIACgKIABgKQAAgEgDgHIgCgKIACgNIABgMQAAgRgFgYIgMgUQgIgSgDgRQAAgTgDgcQgEgdgGglQgSgwgWgtIgyhhQgUgzgBg6QABiIBZhPQATgQAUgNQBMguBsAAQCLAABUBLQBbBPgBCIQAAA3gRAtQgFAOgoBNQg3BpgDA9QAAAWgDAhQgCANgLAUQgLAVAAAHQACAJgIAWIAFARQAAADgDAHQgCAFAAADIABAIIABAIQABAggEAVQgDAagaAUQgJAGgnAXIgVANIgSAEQgDAEgIAEIggABIgegBgAh6ERQAAADAGAKQAHAIgBAGQAAAEgFAEQgFADAAADQAAACAFAHQAFAHAAADQAAADgEAHQgEAGgBADQABADAEAGQAEAFAAADQAAACgDAHQgEAFAAADQAAAFAgAWQAdAVAKADIARAEQAMABAAAHIARAAIARAAQAHgIAPgBQAEAAAEgDQAzgcARgQQADgDAAgKQAAgDgEgGQgDgHAAgDQAAgDAEgGQAFgHAAgDQAAgCgFgIQgEgHAAgDIAFgJQAFgHABgDIgLgKIAAgCQgBgIAHgJQAGgJABgMIgHAAQgRAAgoADQgmADgWAAQgVAAgkgDQgpgDgTAAIgFAAgAhunAIgNAGIgJADQghAPgbAXQhPBEAAB2QAAAzASArQAFAMAoBJQAeAzAPAuQANAgACA/IABAhQAAAIAGAOQAIARAGADQAUAMBrAAQBoAAAZgMQAUgKAAhPQAAAFADgcQAFg/A8hoQA3hjAAhEQAAh2hOhEQhJg/h5AAQg8AAgyAQgAhLC5IgZgSQgVgaAGgmQALg/ghgcIg5heQglhDABhUQABhTCFhUQg9BHAVBtQAWBtA3A5QA4A5ghgIQghgIAXBjQAXBjg0AAIAAAAg',
      );
    this.shape_43.setTransform(0.7, 7.95);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AkaEbQh1h2AAilQAAilB1h2QB1h0ClAAQCmAAB1B0QB1B2AAClQAAClh1B2Qh1B1imAAQilAAh1h1gAj3j3QhmBnAACQQAACRBmBmQBmBnCRAAQCRAABmhnQBnhmAAiRQAAiQhnhnQhmhmiRAAQiRAAhmBmgAibCcQhAhBAAhbQAAhbBAhAQBAhABbAAQBbAABBBAQBABAAABbQAABbhABBQhBBAhbAAQhbAAhAhAgAh7h8Qg0A0AABIQAABIA0A0QAzA0BIAAQBJAAAzg0QA0g0AAhIQAAhIg0g0QgzgzhJAAQhIAAgzAzgAgtAyQgWgWAAgeQAAgfAWgWQAWgWAeAAQAfAAAWAWQAWAWAAAfQAAAegWAWQgWAWgfAAQgeAAgWgWg',
      );

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgvGgIgOhnQglgHgkgQIhEBJQgqgagkgjIAuhVQgZgcgTghIhbARQgTgvgKgyIBSgmQgDgVABgRQgBgRADgUIhSgmQAKgzATguIBbARQATghAZgcIguhVQAkgjAqgaIBEBJQAjgQAmgHIAOhnIAYgDIAXAAQAYAAAYADIAOBnQAmAHAiAQIBFhJQAqAaAkAjIgvBWQAaAbASAhIBbgRQAUAuAKAzIhSAmQACATAAASQAAASgCAUIBSAmQgKAygUAvIhbgRQgSAggaAdIAvBVQgkAjgqAaIhFhJQgkAQgkAHIgOBnQgYADgYAAQgXAAgYgDgAiqiqQhHBHAABjQAABkBHBHQBHBHBjAAQBkAABHhHQBHhHAAhkQAAhjhHhHQhRhBhagGQhjAAhHBHgAg7A8QgZgZAAgjQAAgjAZgYQAZgaAiAAQAjAAAZAaQAWAUADAnQAAAjgZAZQgZAZgjAAQgiAAgZgZg',
      );
    this.shape_45.setTransform(15.8945, -23.9382, 0.6182, 0.6182);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgvGgIgOhnQglgHgkgQIhEBJQgqgagkgjIAuhVQgZgcgTghIhbARQgTgvgKgyIBSgmQgDgVABgRQgBgRADgUIhSgmQAKgzATguIBbARQATghAZgcIguhVQAkgjAqgaIBEBJQAjgQAmgHIAOhnIAYgDIAXAAQAYAAAYADIAOBnQAmAHAiAQIBFhJQAqAaAkAjIgvBWQAaAbASAhIBbgRQAUAuAKAzIhSAmQACATAAASQAAASgCAUIBSAmQgKAygUAvIhbgRQgSAggaAdIAvBVQgkAjgqAaIhFhJQgkAQgkAHIgOBnQgYADgYAAQgXAAgYgDgAiqiqQhHBHAABjQAABkBHBHQBHBHBjAAQBkAABHhHQBHhHAAhkQAAhjhHhHQhRhBhagGQhjAAhHBHgAg7A8QgZgZAAgjQAAgjAZgYQAZgaAiAAQAjAAAZAaQAWAUADAnQAAAjgZAZQgZAZgjAAQgiAAgZgZg',
      );
    this.shape_46.setTransform(-8.2208, 22.1224, 0.724, 0.724);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AitGiQhIhJAAhmQAAhQAtg+QAuhABIgaQgZgdAAgrQg7gPghg1Qggg1AAhRIAAjiIHOAAIAADiQAACuh/AaIAAACQgDArgYAbQBLAZAuA/QAwBCAABQQAABmhJBJQhIBIhlAAQhmAAhHhIgAgCHRIAfg2IA0AmIAKg+IA9AOIgOg8IA9gLIgkgxIA1giIg0giIAjgyIg9gKIAOg9Ig+AOIgJg9IgzAkIggg1IghA2IgzglIgIA+Ig+gPIAQA+IhAAJIAnAzIg4AhIA4AgIgnAzIBAAJIgQA+IA9gQIAJBAIAzgngAg5AEQAdgFAcAAQAaAAAZAFQAZgWAEgqQgSABgUABIhsAAIgRgBQACAsAYATgAg9hWIB6AAIAAmEIh6AAgAAXFRQgLgMAAgVQAAgOAFguIAFg8IgrAAQgEBLgGAiQgGAigHALQgHAKgNgBQgJAAgHgFQgGgFAAgJQAAgJALgPQAQgWAIgXQAIgXAEg0IgOAAQgRABgIAHQgKAIgIAOIgGAAQAGgWAJgOQAJgOAKgFQAKgDAZAAICCAAIAAAcIgvAAIgEA/IgBAbQAAAdAGAGQAHAGAKAAQATAAAEgYIAGAAQgHA4gmAAQgSABgLgLg',
      );
    this.shape_47.setTransform(0.625, 0);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Ah+UeQhUgyhQh8QhRh8hAjCQiIAfhwAAQiLAAhjgfQhkgfhIhKQhJhKAAhpQAAhgBDiUQBEiVCHiNQiHiLhEiWQhDiVAAhgQAAhoBJhKQBIhKBkggQBjgfCLAAQBwAACIAfQBAjBBRh8QBRh9BTgyQBTgyArAAQArAABTAyQBUAyBRB9QBQB8BBDBQCIgfBvAAQCMAABkAfQBjAgBIBKQBJBKAABoQAABghECVQhDCWiHCLQCHCNBDCVQBECUAABgQAABphJBKQhIBKhjAfQhkAfiMAAQhvAAiIgfQhADChRB8QhRB8hUAyQhTAzgrAAQgpAAhVgzgAj/MCQAUBbAtBqQAsBrAyBHQAxBGAvAAQAwAAAxhGQAxhFAthtQAuhsAThZQh+gmiCg/QiBA/h+AmgAIXFXQggD+giB4QCCAUBMAAQB+AAA8gfQA6gfAggwQAegwAAgtQABhrgqhyQgshyhThiQiLCDiLBvgAuqE5QgqBygBBrQAAAuAgAvQAfAwA7AfQA6AfB/AAQBMAACBgUQgih9gej5QiHhriQiHQhUBjgqBxgAB8JaQBAAgBYAeQARhCAIhkgAkSKYQBVgdBCghIixhoQAIBkASBCgAk3k1QgMCcAACZQAACaAMCbQCnB8CQBaQCRhaCnh8QALibAAiaQAAiZgLicQihh3iXheQiXBeigB3gAIfCmIBOhHIBghfIhghfIhOhGgApthfIhfBfIBfBfIBPBHIAAlLgAHVrMQAiB3AgD/QCMBwCKCCQBUhjArhyQAqhygBhrQAAgsgegwQgfgvg7ggQg8gfh+AAQhJAAiFAUgAtbrBQg8AggeAvQggAvAAAtQABBrAqByQApBwBVBlQCOiGCJhsQAej6Aih8QiFgUhIAAQh/AAg6AfgAB8pZICxBoQgJhlgQhBQhWAdhCAhgAksnxICxhoQhDgihUgcQgSBBgIBlgAhgx4QgyBHgsBqQgtBsgUBZQB+AmCBA/QCCg/B+gmQgThXguhuQgthsgxhFQgxhGgwAAQgvAAgxBGgAhZCUQglgWgUgkQgWglAAg1QAAg1AWgkQAUglAlgVQAlgVA0AAQA2AAAkAVQAkAVAWAlQAUAlABA0QgBA1gUAlQgVAkglAWQgkAVg2AAQg0AAglgVg',
      );
    this.shape_48.setTransform(-22.0119, -28.5763, 0.1666, 0.1666);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Aq5QFIAAiXQAZghAYAAIEPAAQAAgMgFgUQgEgUABgPQgBgfAUgiQAWgnAeAAIGXAAQBFAABVg2QA3gjAjhvQAdhbAAhVQgBiIhWhsQhXhqiHgYQg5BYg0BnQgZgOgdAAQgjAAgaApIgjBGIhlg2QA8hhAAgQQAAgWg0gjQBzjPDZmBQAzhgB5i4QAGgFBMgYQA3gRAAhFIgCgdQALAFAzAmQAlAcAigBQAKAHAMAAQhDAcAAA+QgBAQAHAfQAFAhAAAOQAAA5j8GaQgdAugjBAIAFAIQGNBvAAGhQAADKhPBtQhOBtjBBLIIPAAIAAC8gArBDoQARgYAfg+IJmFQQgHAcghBDg',
      );
    this.shape_49.setTransform(5.9979, -2.5328, 0.4554, 0.4554);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Ar3PIQkMkcAAnvQAAmUEMkGQEKkBGXAAQE6AADJDrQC9DggBE/QABD3jDCuQi7Coj5AAQjNAAiDh7QiFh8AAjLQABiyBwh0QBwh1CzAAQBnAABMA9QBRBAABBnQgBBhhSBgQALgnAAgjQAAihi0AAQjLAAAADRQAADVELAAQFvAAABlQQAAjXhviRQh7ifjRAAQi6AAiYB1QiKBqhRC0QgvBmAAClQAAFNDAC1QC7CyFNAAQGIAADcjfQDbjfAAmKQAAnNjxkZQj/krnEAAQm8AAlJFbQk0FGg5HGQgTiJgBheQABn+FKlFQFLlFH+AAQJbAAFoFgQFnFhAAJbQAAIgldFPQlWFKojAAQnrAAkVkjg',
      );
    this.shape_50.setTransform(
      30.7619,
      -9.1924,
      0.1999,
      0.062,
      0,
      -6.4818,
      11.5553,
    );

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Ag1B2IgKgFIgNgKQAogEAugMQAugKAngOIgIAPQgXAngtAJQgOAEgMAAQgYAAgWgMgAkDBBQgGgaBIglIAxgUQADAIAFAHQAOAUAdAMQAtASA1gNQA2gMAggkQAZgdAAgeIgBgHQAfgDAbAAQBRABAGAaQAGAahIAkQgiARgpAOQgvARg5AOQg4AMgxAHQgsAFgmAAQhRAAgGgbgAhNAOQgYgKgLgPQgEgjATgfQAYgmArgLQArgKAmAYIAJAGQAVAPALAXQAAAZgUAXQgbAdgrAKQgRAEgRAAQgYAAgVgJg',
      );
    this.shape_51.setTransform(1.925, -41.1685);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AHhSkImbwQIl2QQIigAAIGgyGQBwBnDsDvIFVMwgAP8NIQgJgLAAgMQAAgPARgRQARgRAOAAQAHABANAFQAPAEAGAAQgbAagtA1QAAgFgIgMgAGsEsIBxiBIIYIWIh5B7gAjkjCIEUkcIIWIOIkcEdgAqfpfIEykzIGCF1IkwE6gAu4o2QgGAAgVAUQAAgFADgJQACgHAAgIQAAgUgdgOIALACQAjAAAKgpQAAA6AzgTQgbAOAAAdQAAANAHAHQgVgUgPAAgAsfuLQgQAKgZAUQANgQAAgVQAAgdgjgNQAKADAJAAQA3AAgOg4IAVAmQAMATATAAQAKAAAIgEIgjAmIANApQgQgMgdgSgAnQw/IglggIALACQAvgBAEg9QAABJBCgLQgfAMAAAnQAAAMAGAGQglgUgHgBQgPAAgdAcgAgjwYQgKgHgKABQgJgBgKAHQgMAGgCAAIAOgZQACgOgfgQQAGACAHAAQAcAAAIgwQAAAWAOAPQAOAPAUgDQgYAHAAAXQAAAMAJAKQgCAAgMgGgAwmxOIglgfQAIAEAGAAQATAAAPgTQAQgUgCgTQANA6AiAAQAJAAAKgEQgfAVAAAYQAAARANAPIgugcQgMAHgdAXQADgTALgdg',
      );
    this.shape_52.setTransform(-7.0024, 13.4811, 0.3687, 0.3687);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f('#FFFFFF')
      .s()
      .p(
        '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',
      );
    this.shape_53.setTransform(0.3494, 1.0004, 0.3424, 0.3424);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_40 }] })
        .to({ state: [{ t: this.shape_41 }] }, 1)
        .to({ state: [{ t: this.shape_42 }] }, 1)
        .to({ state: [{ t: this.shape_43 }] }, 1)
        .to({ state: [{ t: this.shape_44 }] }, 1)
        .to({ state: [{ t: this.shape_46 }, { t: this.shape_45 }] }, 1)
        .to({ state: [{ t: this.shape_47 }] }, 1)
        .to({ state: [{ t: this.shape_49 }, { t: this.shape_48 }] }, 1)
        .to(
          {
            state: [
              { t: this.shape_52 },
              { t: this.shape_51 },
              { t: this.shape_50 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              {
                t: this.shape_53,
                p: { scaleX: 0.3424, scaleY: 0.3424, x: 0.3494, y: 1.0004 },
              },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              {
                t: this.shape_53,
                p: { scaleX: 0.2828, scaleY: 0.2828, x: 0.55, y: 0.9991 },
              },
            ],
          },
          22,
        )
        .wait(69),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-78.4, -78.5, 156.9, 156.3);

  (lib.BadgeShape = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      ///* js
      //	this.stop();
      //*/
      //stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(38));

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('rgba(0,0,0,0.004)')
      .s()
      .p(
        'Al2F3QibicAAjbQAAjaCbicQCcibDaAAQDcAACbCbQCbCcAADaQAADbibCcQibCbjcAAQjaAAicibg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p(
        'AmgGhQitisAAj1QAAjzCtitQCtitDzABQD1gBCsCtQCsCtABDzQgBD1isCsQisCsj1ABQjzgBitisgAmKERIMfAAImQqzg',
      );
    this.shape_1.setTransform(0, 0.25);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p(
        'AmgGhQitisAAj1QAAjzCtitQCtitDzABQD1gBCsCtQCsCtABDzQgBD1isCsQisCsj1ABQjzgBitisgAkVkYQh1B1AACmQAACmB1B0QB0B2CmAAQCmAAB1h2QB1h0AAimQAAimh1h1Qh1h1imAAQimAAh0B1g',
      );
    this.shape_2.setTransform(0, 0.25);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p(
        'AmgGhQitisAAj1QAAjzCtitQCtitDzABQD1gBCsCtQCsCtABDzQgBD1isCsQisCsj1ABQjzgBitisgAldFcIK7AAIAAq8Iq7AAgAjHDFIAAmOIGPAAIAAGOg',
      );
    this.shape_3.setTransform(0, 0.25);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p(
        'AmgGgQitisAAj0QAAj0CtitQCtirDzgBQD1ABCsCrQCtCtgBD0QABD0itCsQisCuj1gBQjzABitiugAmkACIGwIMIGxoMImxoKgAjIACIDUkBIDVEBIjVECg',
      );
    this.shape_4.setTransform(-0.5, -0.25);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        'AmgGgQitisAAj0QAAj0CtitQCtirDzgBQD1ABCsCrQCtCtgBD0QABD0itCsQisCuj1gBQjzABitiugAlQkLQg7A3AABUQAAA7AbA6QAbA4BJBVQB2CMAqA6QApA/AoBUQAPAgAMAAIAIAAQANAAAPggQAphXApg9QAqg7B1iKQBJhVAcg4QAag6AAg7QAAhSg8g5Qg7g1hWAAQhFAAgsAjQgsAggmBEQglhEgsggQgtgjhDAAQhYAAg7A1gAACEgQgFAAgHgPQgTgpgTgdQgTgbg4hBQgigogNgaQgMgcAAgaQAAgoAbgaQAbgZApABQAhAAAUAPQAVAPARAhQARghAWgPQAUgPAgAAQApgBAbAZQAcAbAAAnQAAAagMAcQgNAagiAoQg3BAgUAcQgTAdgTApQgHAPgGAAg',
      );
    this.shape_5.setTransform(-0.5, -0.25);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p(
        'AmgGgQitisAAj0QAAj0CtitQCtirDzgBQD1ABCsCrQCtCtgBD0QABD0itCsQisCuj1gBQjzABitiugAFFG7IhsloIEqjjIl4gLIh6lgIh7FgIl6ALIEsDjIhsFoIE1jVgAAQBoIh4BUIAqiNIh1hYICTgDIAwiKIAvCKICSADIh0BYIArCNg',
      );
    this.shape_6.setTransform(-0.5, -0.25);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics.f('#000000').s().p('AolHcIIlu3IImO3g');
    this.shape_7.setTransform(0, -7.125);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#000000')
      .s()
      .p(
        'AlhFiQiSiSAAjQQAAjQCSiRQCRiSDQAAQDQAACSCSQCSCRAADQQAADQiSCSQiSCSjQAAQjQAAiRiSg',
      );

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics.f('#000000').s().p('AmjGkIAAtHINHAAIAANHg');

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics.f('#000000').s().p('AnvAAIHvpXIHvJXInvJYg');
    this.shape_10.setTransform(0.05, 0);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#000000')
      .s()
      .p(
        'AgEIFQgRAAgSgoQgyhqgzhNQg0hKiUiuQhbhqgjhGQghhKAAhIQAAhpBJhFQBLhCBsAAQBWAAA3AqQA3ApAwBVQAuhVA4gpQA3gqBVAAQBsAABLBCQBKBHAABnQAABIgiBKQghBGhdBqQiRCsg0BKQg0BLg0BuQgSAogRAAg',
      );
    this.shape_11.setTransform(0, 2.725);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#000000')
      .s()
      .p('AADE7Il0D/ICCmwIlokRIHFgLICVmnICSGnIHDALIlmERICCGwg');
    this.shape_12.setTransform(0, -3);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics.f('#000000').s().p('AnzGwIHztfIH0Nfg');
    this.shape_13.setTransform(0, -5.45);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics.f('#000000').s().p('Am9AAIG9obIG+IbIm+Icg');
    this.shape_14.setTransform(0.05, 6);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#000000')
      .s()
      .p(
        'AgEHUQgPgBgQgkQgthfgvhHQgvhCiGidQhShhgfg+QgehDAAhCQAAhfBDg9QBCg9BjABQBNAAAyAmQAyAkArBOQAphOAzgkQAxgmBOAAQBhgBBDA9QBEA/AABdQAABCgfBDQgeA+hTBhQiECagvBDQgvBFgvBjQgQAkgPABg',
      );
    this.shape_15.setTransform(0, 14.7);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#000000')
      .s()
      .p('AADE8Il0D+ICCmwIlokQIHFgNICVmmICSGmIHDANIlmEQICCGwg');
    this.shape_16.setTransform(0, 3);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 9)
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_4 }] }, 1)
        .to({ state: [{ t: this.shape_5 }] }, 1)
        .to({ state: [{ t: this.shape_6 }] }, 1)
        .to({ state: [{ t: this.shape_6 }] }, 1)
        .to({ state: [] }, 1)
        .to({ state: [{ t: this.shape_7 }] }, 3)
        .to({ state: [{ t: this.shape_8, p: { y: 0 } }] }, 1)
        .to({ state: [{ t: this.shape_9, p: { y: 0 } }] }, 1)
        .to({ state: [{ t: this.shape_10 }] }, 1)
        .to({ state: [{ t: this.shape_11 }] }, 1)
        .to({ state: [{ t: this.shape_12 }] }, 1)
        .to({ state: [] }, 2)
        .to({ state: [{ t: this.shape_13 }] }, 3)
        .to({ state: [{ t: this.shape_8, p: { y: 9 } }] }, 1)
        .to({ state: [{ t: this.shape_9, p: { y: 10 } }] }, 1)
        .to({ state: [{ t: this.shape_14 }] }, 1)
        .to({ state: [{ t: this.shape_15 }] }, 1)
        .to({ state: [{ t: this.shape_16 }] }, 1)
        .wait(3),
    );

    // Layer 4
    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#333333')
      .s()
      .p(
        'Ao1I1QjqjpAAlMQAAlKDqjqQDrjrFKAAQFMAADpDrQDrDqAAFKQAAFMjrDpQjpDrlMAAQlKAAjrjrgAmgmeQitCtAAD0QAAD0CtCsQCtCtDzAAQD1AACsitQCsisABj0QgBj0isitQisisj1AAQjzAAitCsg',
      );

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#292929')
      .s()
      .p(
        'Ao1I1QjqjpAAlMQAAlKDqjqQDrjrFKAAQFMAADpDrQDrDqAAFKQAAFMjrDpQjpDrlMAAQlKAAjrjrgAm3m1Qi2C2gBEBQABECC2C2QC3C3EAAAQECAAC2i3QC2i2ABkCQgBkBi2i2Qi2i3kCABQkAgBi3C3g',
      );

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#1F1F1F')
      .s()
      .p(
        'Ao1I1QjqjpAAlMQAAlKDqjqQDrjrFKAAQFMAADpDrQDrDqAAFKQAAFMjrDpQjpDrlMAAQlKAAjrjrgAnPnNQi/DAAAEPQAAEQC/C+QDADBEPAAQEPAADAjBQDAi+AAkQQAAkPjAjAQjAjAkPAAQkPAAjADAg',
      );

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#141414')
      .s()
      .p(
        'Ao1I1QjqjpAAlMQAAlKDqjqQDrjrFKAAQFMAADpDrQDrDqAAFKQAAFMjrDpQjpDrlMAAQlKAAjrjrgAnmnkQjJDIAAEdQAAEdDJDKQDKDKEcgBQEeABDJjKQDJjKAAkdQAAkdjJjIQjJjKkeAAQkcAAjKDKg',
      );

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#0A0A0A')
      .s()
      .p(
        'Ao1I1QjqjpAAlMQAAlKDqjqQDrjrFKAAQFMAADpDrQDrDqAAFKQAAFMjrDpQjpDrlMAAQlKAAjrjrgAn9n8QjTDSAAErQAAErDTDSQDTDUEqAAQErAADSjUQDUjSAAkrQAAkrjUjSQjSjTkrgBQkqABjTDTg',
      );

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#000000')
      .s()
      .p(
        'Ao1I1QjqjpAAlMQAAlKDqjqQDrjrFKAAQFMAADpDrQDrDqAAFKQAAFMjrDpQjpDrlMAAQlKAAjrjrgAoUoUQjdDcAAE4QAAE5DdDcQDcDeE4gBQE5ABDcjeQDcjcAAk5QAAk4jcjcQjcjdk5AAQk4AAjcDdg',
      );

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#333333')
      .s()
      .p(
        'AnpMgQiBAAhahbQhbhaAAiBIAAvTQAAiABbhbQBahbCBAAIPTAAQCBAABaBbQBbBbAACAIAAPTQAACBhbBaQhaBbiBAAgAoeoeQhFBGgBBiIAALuQABBiBFBFQBFBFBjABILuAAQBigBBFhFQBFhFABhiIAAruQgBhihFhGQhFhFhigBIruAAQhjABhFBFg',
      );

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f('#333333')
      .s()
      .p('AoHMgIlAvbINHpkINIJkIlAPbgArZiaIEYNgIOMAAIEZtgIrfoXg');
    this.shape_24.setTransform(0.05, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [] })
        .to({ state: [{ t: this.shape_17 }] }, 9)
        .to({ state: [{ t: this.shape_18 }] }, 2)
        .to({ state: [{ t: this.shape_19 }] }, 1)
        .to({ state: [{ t: this.shape_20 }] }, 1)
        .to({ state: [{ t: this.shape_21 }] }, 1)
        .to({ state: [{ t: this.shape_22 }] }, 1)
        .to({ state: [{ t: this.shape_22 }] }, 1)
        .to({ state: [] }, 1)
        .to({ state: [{ t: this.shape_23 }] }, 2)
        .to({ state: [] }, 8)
        .to({ state: [{ t: this.shape_24 }] }, 2)
        .wait(9),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-84, -80, 168.1, 160);

  (lib.SkillLevel = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.levelText = new lib.BadgeLabel();
    this.levelText.name = 'levelText';
    this.levelText.setTransform(-3.85, 6.35, 0.6842, 0.6842);

    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#999999')
      .s()
      .p(
        'AmYAjIAAgQQAJAMANAAQAFAAAEgDQADgCAAgFQAAgIgKgGIgJgGQgJgEgDgEQgDgFgBgHQABgKAGgGQAHgGALAAQAKAAAIAGIAAANQgJgJgJAAQgGAAgEAEQgEACAAAEQAAAEADADQACADAHAEIAJAFQAOAIAAAOQABAJgHAHQgGAGgLAAQgNAAgJgHgADXApIgjhRIALAAIAZA5IAYg5IAMAAIgiBRgAFpApIAAhRIALAAIAABGIAlAAIAAALgAEZApIAAhRIAuAAIAAAKIgjAAIAAAZIAiAAIAAAKIgiAAIAAAZIAkAAIAAALgABtApIAAhRIAuAAIAAAKIgjAAIAAAZIAiAAIAAAKIgiAAIAAAZIAkAAIAAALgAAdApIAAhRIAMAAIAABGIAlAAIAAALgAhmApIAAhRIAMAAIAABGIAlAAIAAALgAi1ApIAAhRIAMAAIAABGIAlAAIAAALgAjnApIAAhRIAMAAIAABRgAkUApIgqgoIAAAoIgMAAIAAhRIAMAAIAAAlIAjglIAPAAIgkAnIAsAqg',
      );
    this.shape.setTransform(-2.5, -8.7);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }, { t: this.levelText }] })
        .wait(1),
    );

    // Layer 2
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics.f('#FFFFFF').s().p('AsfCvIAAldIY/AAIAAFdg');
    this.shape_1.setTransform(-4.975, 1.4);

    this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.SkillLevel,
    new cjs.Rectangle(-84.9, -16.1, 159.9, 35),
    null,
  );

  (lib.PlayerIcon = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };
    this.frame_3 = function () {
      this.stop();
    };
    this.frame_4 = function () {
      this.stop();
    };
    this.frame_5 = function () {
      this.stop();
    };
    this.frame_6 = function () {
      this.stop();
    };
    this.frame_7 = function () {
      this.stop();
    };
    this.frame_8 = function () {
      this.stop();
    };
    this.frame_9 = function () {
      this.stop();
    };
    this.frame_10 = function () {
      this.stop();
    };
    this.frame_11 = function () {
      this.stop();
    };
    this.frame_12 = function () {
      this.stop();
    };
    this.frame_13 = function () {
      this.stop();
    };
    this.frame_14 = function () {
      this.stop();
    };
    this.frame_15 = function () {
      this.stop();
    };
    this.frame_16 = function () {
      this.stop();
    };
    this.frame_17 = function () {
      this.stop();
    };
    this.frame_18 = function () {
      this.stop();
    };
    this.frame_19 = function () {
      this.stop();
    };
    this.frame_20 = function () {
      this.stop();
    };
    this.frame_21 = function () {
      this.stop();
    };
    this.frame_22 = function () {
      this.stop();
    };
    this.frame_23 = function () {
      this.stop();
    };
    this.frame_24 = function () {
      this.stop();
    };
    this.frame_25 = function () {
      this.stop();
    };
    this.frame_26 = function () {
      this.stop();
    };
    this.frame_27 = function () {
      this.stop();
    };
    this.frame_28 = function () {
      this.stop();
    };
    this.frame_29 = function () {
      this.stop();
    };
    this.frame_30 = function () {
      this.stop();
    };
    this.frame_31 = function () {
      this.stop();
    };
    this.frame_32 = function () {
      this.stop();
    };
    this.frame_33 = function () {
      this.stop();
    };
    this.frame_34 = function () {
      this.stop();
    };
    this.frame_35 = function () {
      this.stop();
    };
    this.frame_36 = function () {
      this.stop();
    };
    this.frame_37 = function () {
      this.stop();
    };
    this.frame_38 = function () {
      this.stop();
    };
    this.frame_39 = function () {
      this.stop();
    };
    this.frame_40 = function () {
      this.stop();
    };
    this.frame_41 = function () {
      this.stop();
    };
    this.frame_42 = function () {
      this.stop();
    };
    this.frame_43 = function () {
      this.stop();
    };
    this.frame_44 = function () {
      this.stop();
    };
    this.frame_45 = function () {
      this.stop();
    };
    this.frame_46 = function () {
      this.stop();
    };
    this.frame_47 = function () {
      this.stop();
    };
    this.frame_48 = function () {
      this.stop();
    };
    this.frame_49 = function () {
      this.stop();
    };
    this.frame_50 = function () {
      this.stop();
    };
    this.frame_51 = function () {
      this.stop();
    };
    this.frame_52 = function () {
      this.stop();
    };
    this.frame_53 = function () {
      this.stop();
    };
    this.frame_54 = function () {
      this.stop();
    };
    this.frame_55 = function () {
      this.stop();
    };
    this.frame_56 = function () {
      this.stop();
    };
    this.frame_57 = function () {
      this.stop();
    };
    this.frame_58 = function () {
      this.stop();
    };
    this.frame_59 = function () {
      this.stop();
    };
    this.frame_60 = function () {
      this.stop();
    };
    this.frame_61 = function () {
      this.stop();
    };
    this.frame_62 = function () {
      this.stop();
    };
    this.frame_63 = function () {
      this.stop();
    };
    this.frame_64 = function () {
      this.stop();
    };
    this.frame_65 = function () {
      this.stop();
    };
    this.frame_66 = function () {
      this.stop();
    };
    this.frame_67 = function () {
      this.stop();
    };
    this.frame_68 = function () {
      this.stop();
    };
    this.frame_69 = function () {
      this.stop();
    };
    this.frame_70 = function () {
      this.stop();
    };
    this.frame_71 = function () {
      this.stop();
    };
    this.frame_72 = function () {
      this.stop();
    };
    this.frame_73 = function () {
      this.stop();
    };
    this.frame_74 = function () {
      this.stop();
    };
    this.frame_75 = function () {
      this.stop();
    };
    this.frame_76 = function () {
      this.stop();
    };
    this.frame_77 = function () {
      this.stop();
    };
    this.frame_78 = function () {
      this.stop();
    };
    this.frame_79 = function () {
      this.stop();
    };
    this.frame_80 = function () {
      this.stop();
    };
    this.frame_81 = function () {
      this.stop();
    };
    this.frame_82 = function () {
      this.stop();
    };
    this.frame_83 = function () {
      this.stop();
    };
    this.frame_84 = function () {
      this.stop();
    };
    this.frame_85 = function () {
      this.stop();
    };
    this.frame_86 = function () {
      this.stop();
    };
    this.frame_87 = function () {
      this.stop();
    };
    this.frame_88 = function () {
      this.stop();
    };
    this.frame_89 = function () {
      this.stop();
    };
    this.frame_90 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1)
        .call(this.frame_3)
        .wait(1)
        .call(this.frame_4)
        .wait(1)
        .call(this.frame_5)
        .wait(1)
        .call(this.frame_6)
        .wait(1)
        .call(this.frame_7)
        .wait(1)
        .call(this.frame_8)
        .wait(1)
        .call(this.frame_9)
        .wait(1)
        .call(this.frame_10)
        .wait(1)
        .call(this.frame_11)
        .wait(1)
        .call(this.frame_12)
        .wait(1)
        .call(this.frame_13)
        .wait(1)
        .call(this.frame_14)
        .wait(1)
        .call(this.frame_15)
        .wait(1)
        .call(this.frame_16)
        .wait(1)
        .call(this.frame_17)
        .wait(1)
        .call(this.frame_18)
        .wait(1)
        .call(this.frame_19)
        .wait(1)
        .call(this.frame_20)
        .wait(1)
        .call(this.frame_21)
        .wait(1)
        .call(this.frame_22)
        .wait(1)
        .call(this.frame_23)
        .wait(1)
        .call(this.frame_24)
        .wait(1)
        .call(this.frame_25)
        .wait(1)
        .call(this.frame_26)
        .wait(1)
        .call(this.frame_27)
        .wait(1)
        .call(this.frame_28)
        .wait(1)
        .call(this.frame_29)
        .wait(1)
        .call(this.frame_30)
        .wait(1)
        .call(this.frame_31)
        .wait(1)
        .call(this.frame_32)
        .wait(1)
        .call(this.frame_33)
        .wait(1)
        .call(this.frame_34)
        .wait(1)
        .call(this.frame_35)
        .wait(1)
        .call(this.frame_36)
        .wait(1)
        .call(this.frame_37)
        .wait(1)
        .call(this.frame_38)
        .wait(1)
        .call(this.frame_39)
        .wait(1)
        .call(this.frame_40)
        .wait(1)
        .call(this.frame_41)
        .wait(1)
        .call(this.frame_42)
        .wait(1)
        .call(this.frame_43)
        .wait(1)
        .call(this.frame_44)
        .wait(1)
        .call(this.frame_45)
        .wait(1)
        .call(this.frame_46)
        .wait(1)
        .call(this.frame_47)
        .wait(1)
        .call(this.frame_48)
        .wait(1)
        .call(this.frame_49)
        .wait(1)
        .call(this.frame_50)
        .wait(1)
        .call(this.frame_51)
        .wait(1)
        .call(this.frame_52)
        .wait(1)
        .call(this.frame_53)
        .wait(1)
        .call(this.frame_54)
        .wait(1)
        .call(this.frame_55)
        .wait(1)
        .call(this.frame_56)
        .wait(1)
        .call(this.frame_57)
        .wait(1)
        .call(this.frame_58)
        .wait(1)
        .call(this.frame_59)
        .wait(1)
        .call(this.frame_60)
        .wait(1)
        .call(this.frame_61)
        .wait(1)
        .call(this.frame_62)
        .wait(1)
        .call(this.frame_63)
        .wait(1)
        .call(this.frame_64)
        .wait(1)
        .call(this.frame_65)
        .wait(1)
        .call(this.frame_66)
        .wait(1)
        .call(this.frame_67)
        .wait(1)
        .call(this.frame_68)
        .wait(1)
        .call(this.frame_69)
        .wait(1)
        .call(this.frame_70)
        .wait(1)
        .call(this.frame_71)
        .wait(1)
        .call(this.frame_72)
        .wait(1)
        .call(this.frame_73)
        .wait(1)
        .call(this.frame_74)
        .wait(1)
        .call(this.frame_75)
        .wait(1)
        .call(this.frame_76)
        .wait(1)
        .call(this.frame_77)
        .wait(1)
        .call(this.frame_78)
        .wait(1)
        .call(this.frame_79)
        .wait(1)
        .call(this.frame_80)
        .wait(1)
        .call(this.frame_81)
        .wait(1)
        .call(this.frame_82)
        .wait(1)
        .call(this.frame_83)
        .wait(1)
        .call(this.frame_84)
        .wait(1)
        .call(this.frame_85)
        .wait(1)
        .call(this.frame_86)
        .wait(1)
        .call(this.frame_87)
        .wait(1)
        .call(this.frame_88)
        .wait(1)
        .call(this.frame_89)
        .wait(1)
        .call(this.frame_90)
        .wait(1),
    );

    // icons
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'As9FcIbZ07QEuBbAbFOI7HU3IsCDfgAsZGMIjhFbIBMBcIGeh1QBAhNgBgnQABgPgIgHQgIgHgRAAQgjAAhWAtQBchIAAgvQAAgYgPgNQgNgMggAAQghABhkAqQBQhEAAgyQAAgNgHgHQgJgIgPABQg6AAhBAwgAnLIVQAcAAAOALQAOALgBAVQAAASgSAiIQfsnQgQg2gSgrgAoVGZQBEAPAAA6IQNssQgTgrgigfgApBFdIgBAOIQassQgsgigogRIwlMiQAZgEAPgBQA3AAABA0gAJlqhQDDBmAuDeIFGj6QgsjpjFhWg',
      );
    this.shape.setTransform(-2.1, -0.95);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'A2GTAQgIgWgMhFIDVnEIfFAAIDUG/IgUBggAznPeMAgIAAAIhkjoI88AAgAR2RUQg4AAgegnQgVgdg6hxQg/h6AAgUQAAgdAbgjQAbgkAcgFQATgFCOAAQAbAAAOAFQAiAJBlBnQBmBpAAAaIAACiQgWAXgKAAgAQ7K+QAYAiAhAtIAzAAIAAgpQAAgKgZggIgTgGQgMgFgHgBgAmiJMImtgqIAAhLIHehiQAYh+AAg5IunAAIAA1+MAg+AAAIAAWCIutAAIARCcQgBAQAOAKIHfBfIAABLImsAqgAxtAZIcUAAIAAxVI8UAAg',
      );
    this.shape_1.setTransform(10.8248, 1.2329, 0.7726, 0.7726);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Ar3PIQkMkcAAnvQAAmUEMkGQEKkBGXAAQE6AADJDrQC9DggBE/QABD3jDCuQi7Coj5AAQjNAAiDh7QiFh8AAjLQABiyBwh0QBwh1CzAAQBnAABMA9QBRBAABBnQgBBhhSBgQALgnAAgjQAAihi0AAQjLAAAADRQAADVELAAQFvAAABlQQAAjXhviRQh7ifjRAAQi6AAiYB1QiKBqhRC0QgvBmAAClQAAFNDAC1QC7CyFNAAQGIAADcjfQDbjfAAmKQAAnNjxkZQj/krnEAAQm8AAlJFbQk0FGg5HGQgTiJgBheQABn+FKlFQFLlFH+AAQJbAAFoFgQFnFhAAJbQAAIgldFPQlWFKojAAQnrAAkVkjg',
      );
    this.shape_2.setTransform(0.45, 0.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Ap4J5QkHkHAAlyQAAlxEHkHQEHkHFxAAQFyAAEHEHQEHEHAAFxQAAFzkGEGQkHEHlzAAQlxAAkHkHgAiwkRQBxBkA/CtQA/CtByBkQByBlCKAAQC1AABjhgQBkhfAAi3QAAlNjujtQjujulNAAQlMAAjuDuQjdDdgPEvQALicBbhQQBnhbCtAAQCKAAByBkgAoOhcQgoAnAAA1QAAA2AnAnQAnAnA2AAQA3AAAmgnQAognAAg2QAAg1gognQgmgng3AAQg1AAgnAngAFWBdQgognAAg2QAAg1AognQAngnA2AAQA2AAAmAnQAoAnAAA1QAAA2gnAnQgmAng3AAQg2AAgngng',
      );
    this.shape_3.setTransform(4.6168, -5.3332, 1.4001, 1.4001);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f()
      .s('#FFFFFF')
      .ss(10, 1, 1)
      .p(
        'AJ5p4QEHEHAAFxQAAFzkGEGQkHEHlzAAQlxAAkHkHQkHkHAAlyQAAlxEHkHQEHkHFxAAQFyAAEHEHgAAsgWIIuIzQDPjpAAk0QAAk3jYjsQjWjtlPgYgAgrsoQlOAYjXDtQjYDsAAE3QAAE1DPDmIIuorgAIbJdInvnyIAAK/QEbgUDUi5gAgrBrInvHvQDRC8EeAUg',
      );
    this.shape_4.setTransform(0.4596, 0.4596, 1.5078, 1.5078);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Ap4J5QkHkHAAlyQAAlxEHkHQEHkHFxAAQFyAAEHEHQEHEHAAFxQAAFzkGEGQkHEHlzAAQlxAAkHkHgAAsMqQEbgUDUi5InvnygAoaJaQDRC8EeAUIAAq/gAAsgWIIuIzQDPjpAAk0QAAk3jYjsQjWjtlPgYgApQojQjYDsAAE3QAAE1DPDmIIuorIAAsYQlOAYjXDtg',
      );
    this.shape_5.setTransform(0.4596, 0.4596, 1.5078, 1.5078);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AkaT2Qgig4AAgtQAAgmAxgYQAOgFAxgDQAlguAAgPQAAgagihaQgjhZgSgWQgFgHh8g8Qh9g9hLg3QgDgChShTIgHAKQgHArgwAtQgwAtgtAPQgrAOAGAAQgiAAglg3QgWghAAgrQAAgeAmgZQATgEAogOQAmgVAZhZQgvghgbgtIg0hYQgKACgVAAQhSAAiFhBQgegOg7g6QhBg9AAgXQAAg0AfgnQAfgnA0AAQAQAAAyAcQAVBRAYASQACACBhAvQAAgUAFguQAXgvAYhXQg1g4gJgYQgchPAAhUQAAhsBFhZQAAgJgJgJQgtAJg4A9QgSgLhWhGIAAhJIAmglQAegcAGAAQAPAAAbAKQAcALANAAQAWAAAQgZQBLhvBUhFQAYgQAmgWQAlgaAAghQAAgQgJgeQgIgegCgKQA6hEARAAQA4AAAeAhIA5BJQgbAYgpBCIABADQAagCBHgbQBDgZAtAAQBlAAA9AeQAGACAnAfQAmAdAEAAQAHAAA7gWQA5gVANgEIA+gFQgOgtg8hKQgKgFhGgNQgWhTgBALQAAhzB7AAQAfAABBBEQA9A+AMAhQA3CRABBaIBaA3QAtAbAiA0QBcgaAPgrQABgNAHgdQAFgNAagTQAagTAMAAQAkAAAgASQA8AjAAAhQAAAngrA6QgqA7gnATQgUAIgbAMQBXBNBoC5QAXA/AxBWQAgAeBTAQICqALQACgSAOgrQAXg5AlAAQAmAABBAjQAxAbAABTQAAAWgeAkQgGAIhjAwQgcAXhFAhQgcAGhBAAQhQAAhNgqQAACAgRBjQgRA1gcBhIgpCjQgcBkglA1QgsA/mxBnQhGARhrAAQgPAAgigFIAfBNQABAEAABWIACA1QAAAkgsBYQgqBTgcAeQgbAfgmAAQhLAAgdgygAhqtoQguAageA1IgzBhQhWCNj+DiQg2Awg0AgIhiA0Qg3AfgYAwQgiBCAAA1QAAAaBgCtQAVArA6BVQCXC1DZBkQAaARBHAiQBUAcCaAAQENAADNheQAegMA5gkQBOhHArjFQAiibAAiUQAAh9gXhqQgWhqh4iiQhyibhhhFQh3hYh5gzQgqgSgeAAQhCAAg4AhgAt0n6QggBDAAAaQAABfA7AAQAXAAAahVQAVhKAAgkQAAg9gsAAQgVAAggBEgAsls5QhVBVAAAhQAAAbAbAAQAFAAAlgsIAsg0QBDhAAtgdIAAgZQgNgRgLAAQggAAhUBWgAniuIQhMAjAAAXQAAAqA7AAQBiAABIgoQAWgLAMgbQg1g4gkAAQgdAAhFAigAEuH1QgDAAglgUQiyhgAAiwQAAgTAXgrQAXgtAQgLQA1gtAtAAQBVAABoBKQBvBRAABPQAABqgOAYIhZBbgAnjGWQhmg1AAheQAAhcAXgdIBQhXQAUgDAMAAQBPAABhAyQBdAvA3BAQAYAcAAAqQAAA+gtA6QgnAxhwAAQhnAAhSgqgAm7iKQgnguAAg9QAAhXBXhWQBYhXBXAAQA7AAAvAmQAwAnAAA5QAABChpBtQhpBthDAAQg7AAgpgzgACjj1QhKh7AAhIQAAggAHgPQAJgQAnglQApgmASgKQARgKA6AAQArAAAdAKQBDAYAqBcQAlBOAABSQAABZg0A4QgzA4hXAAQhAAAhPiGg',
      );
    this.shape_6.setTransform(13.575, 13.575);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AihT9Qgxg4hehiQkckajQlBIhVijQgnhChIiSQgJgagwi5IgwijIA0k6QAdA2BPCbIAwBhQATAgBqBKQB4BSAcAdQAJAKBnCeQCdDwBmDoQArBgA2ClIBXEJIAA0AICCAAIAAT6QA2iuCBleQA0h9CbkMQAvhXBuiWQAlgoBjg+QBfg6AmgvQAsg2AvhjIBMijIAuEuQgaB6hLECQgDAKhQCTQgoBShUCYQh3C8iuDFIlKFkgAjTjuQh6gghShqQhJhgAAkAQAAkTCEkLQAfAXA1AyQIaJvAAC7QAAA+geA6QitAygcAAQiqAAhMgVgAFGmZQAAhThhiYQhiiXAAAKQAAgaAXh1QAYh0AJgUQAQgdB5ixQCFELAAEIQAAEJhPBuIg9A2QAJgyAAgxgAgKvGQhMhrAAgEQAAgjAnhGQAig8AfgiQAiAIApBNQAmBHAAAnQAAAOgYBgQgZBpgDAZg',
      );
    this.shape_7.setTransform(0.475, 0.45);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AjtQZQDOlUAAmyQAAhfgKhqIkiGIQhsCPiUAwQgzARguAAQhYAAhPg6QgwgmgRg0QgPgwAAgsQAAg9AagnQAagnAAgYQAAgohMgbQhMgcgahQQgJgdAAgdQAAhdBihdQAygmAwgRQBLgXBPAAQBlgBBuAnIHQCTIkwmxQhoiTAAibQAAiXB8haQA0gfA1AAQB8AAAuA6QAuA6AdgBQAfABAvg6QAug6BSAAQCBAABPCgQASA8AAA0QAACyiACjIkYGGIHJiPQBsgnBmABQBQAABKAXQAxARAyAmQBiBdAABbQAAAfgKAdQgZBQhMAcQhMAbAAAoQAAAZAaAmQAaAnAAA7QAAAsgRAyQgPA0guAmQhRA6haAAQgsAAgzgRQiVgwhriPIkjmIQAMB6AAB3QAAGZicFFg',
      );
    this.shape_8.setTransform(0.525, -1.55);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AHTTrQhOgtgEAAIjXAAQhaAAjJhCQhrgfjJhUIh1hcQhFgth/hrQhGhJhLh+QhRiGgXhaQgliZgBjjQgugxhFhXQgQgbgWhgQgUhbAAgmQgBggAIg2QAGg8AAgbQhzhUAAh0QAAhZAWgqQAFgHAUgXQAWgaAAgFQAAgggQg9QgQg9AAggQAAguA5g0QA4g0AxAAQAlAAAoAVIAlATQADgEAkgOQASgHA7AAQBfAABdBQICDAAQAXAAA1AXQAxAUB9CNIBtgBQA8AAARALQDlBBA9A3QBmBcBdCmQAIALAqBzQBkAIDDAlQCEAlCPBcQCbBmBDBlQABACAMAeQBVDSAADYQAACchDD7QgOBJgnCAQggBShoBqQhsBxhOAbQh7AriRAAQgxAAhPgtgACbJHQAAA9ASB3QANAlAjAyQAuBEAIAPQBsC+DmAuIBLAOQDDAACakFQAMgSAVgkQAbg1AtkeIAZiAQAPhNABg0QAAhJgXiDQgQhghchyQhUhphdg2QhyhCiYgcIiXggQAOAgAVBJQAEAjALA+QAuAOBxAqQAzAVBGA+QBFA9AhAwQAsBDAABMQAAAXgYBNIgDAAQgJgwgehXQgmhBhFgnIiKg7QByBzAqBMQAIAPAVBVQAUBUABAQQgBBbghCeQglCsgqA8QhVB5g9ADIgLgCQBUBIBrAAQALAAAjgFQAfgFARAAQAQAAAAATQAAAehEAXQg3ASgpAAQgnAAgvgRQhoglhDhPQgpguhFiEQgMgWgWguQgRg7AAiWQAAhfAGgtQABgKAjhyQBqlNAAhnQAAg1gfhwQgOg6grh6QhUizihh7QiviGi4AAQgKAAgWAGQgUAGgLAAQghAAglgwQg1hGgcgUQhBgwhhAAQgPAAgZAKQgZALgMAAQgSAAgwgwQgugwhMAAQgPAAgdAJQgdAIgOAAQABAAgfgWQgegVgmAAQhrAAAACfQABAQAOAfQA6hiA5gHIAEADIhaCrQhAB/AAApQAABXBYA5QAQgtB8ixQB5ipABgFQAAgigQgRIgsgfQAQgTAOAAQAbAAA2AjQA2AjAAAZQAAAUgrAlIg+AyQhBBBhcDFQhcDJgBBUQAABiBoCdIAMABQAjibAuhOQBhiiCNicQAWgZA6gtQBDg3ARAAQARAAAOASQgLAfg8A/IhXBdQhOBchWCJQgTAfg5CeQg5CdAAAbQAACxBBCyQBDC6B2B+QAtAvDWCdQAnAjBUA0QEiB9DZAKIBnAGQgzg2hZh5QgOgngqhjQgVgjABgFIAAmaQAAgMAcgVQAiCgALB8gADBj1QgYhsgkhKQgmgygmhbIBsB6IACgIQABgbg2hoIhJiIQB0AyA/CiQAKAcBAD8IggCpIgjAFQgUiAgOg+gAoPuFQgvg7ADgRQgSgXgvguQACgUASAAQAZAABaBCQBPA6ASBXQgVAQgjAhg',
      );
    this.shape_9.setTransform(4.7012, 4.64, 0.8161, 0.8161);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AJ8TbQhkg3gQgHQgvgThfgRQhggSgxgTQi8hJAAi6QAAhqBhgvICZhBQBWglA6gzIAxgwQAUgSA4AAQCpAAAtCRQAIAcAABUQAABIAbAnQAjAsAwA4QArA3AABGQAABWgyA+Qg3BDhTAAQgnAAhMgqgAPRNmQgrgrAAg/QAAhVA/hAQBAhABUAAQBCAAAqAsQAqArAABDQAABKhFBDQhFBDhKAAQg/AAgrgrgAAIFnQAAhRAog5QArg/BPAAQAYAAAZAMQBcAtAAB2QAABRg0A0QgzA1hQAAQh4AAAAiggAMLFIQAAhpA7hIQA+hPBnAAQCmAAAACyQAABohABLQhDBPhlAAQieAAAAi0gAGkEiQgng1AAhGQAAhWA2hIQA6hQBSAAQBCAAAtA5QAtA4AABEQAABTg5BMQg+BQhSAAQhCAAgsg7gAruhBQgYgDg8ALQhFANgVAAQhQAAg1g1Qg0g2AAhRQAAiFCChGQAfgMA7giQAqgeAfhMQAlhWAZgZQAyg0BmgBIAkgCQAqAAAwAjQAUARAUA6QAcBWCAByQByBlAABCQAABihUBIQhTBIhmAAgAzhpCQgthBAAhUQAAhEAtgwQAsgvBDAAQBDAAA4BBQA4BCAABEQAABLgoA1QgrA4hLAAQhSAAgyhHgAjKpUQgyg5AAhDQAAhAA1g6QA0g6A+AAQA9AAAqAsQAsAtAAA8QAABEgoBDQgtBNg+AAQhCAAgzg5gAv1wqQAAjaCqAAQBdAAAzBDQAvA+AABeQAABOglBHQgtBWhHAAQjQAAAAjwgAoFuRQgrg+AAhIQAAhRAxhBQA3hGBPAAQBJAAAtBCQAnA7AABNQAABbgtA8QgxBDhXAAQhEAAgwhGg',
      );
    this.shape_10.setTransform(0.4783, 0.5468, 0.8815, 0.8815);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AvYPZQmZmZAApAQAAo/GZmZQGZmZI/AAQJAAAGZGZQGZGZAAI/QAAJAmZGZQmZGZpAAAQo/AAmZmZgAlLUdQCjApCoAAQDNAADHg+Ihqh3IndgkgAlLKxICcGgIHcAkIFdkwIhqkvIn6iPgAvVOfIgkiXIiUheQBMCCBsBzgANGAYIkMH1IBpEuIGSgNQDgknAplvIh7j3gA0/h+QgGA4AABGQAAFSCbEkIC5B2IDPkAIhZmfIkSlGgAteBMIBXGZIGqC4IFxkrIhWm9ImOjJgAGntCIAAHmIGYFZIF/h2IAOmpIgGgGIABAAImamdgAnarlIAVG4IGODJIHCj5IAAnnInFjogA07iiICmhzIDWn5IgYiNQkvFDg1G2gAM+vcIF2F4QiKkNjzi8gAu/u0IAaCbIG3AeIGilGIhTj6QnVA3lLFQg',
      );
    this.shape_11.setTransform(4.525, -1.075);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('rgba(0,0,153,0)')
      .s()
      .p(
        'AqaKcQkVkVAAmHQAAmFEVkVQEVkVGFAAQGHAAEVEVQEUEVAAGFQAAGHkUEVQkVEUmHAAQmFAAkVkUgAl6KIQgxA6g7AwQDdCQEJAAQEKAADdiQQg6gwgyg6IBDg6QAzA6A/A2QCeh/BYizQBci6AAjSQAAjQhci6QhYi1ieh9QhBA4gxA3IhDg6QAyg5A6gxQjdiPkKAAQkJAAjdCPQA7AxAxA5IhDA6Qgzg5g/g2QidB9hZC1QhbC6AADQQAADSBbC6QBZC0CdB+QA+g1A0g7gADRFxIBPgeQAlBYA4BQIhCA6Qg/hbgrhpgAl8H7QA4hRAlhXIBQAeQgrBpg/BbgACKA0IBWAAQAGBiAYBaIhQAeQgdhrgHhvgAj9DwQAYhaAGhiIBWAAQgGBvgeBrgACKgzQAHhvAdhqIBQAdQgYBbgGBhgAjfgzQgGhhgYhbIBQgdQAeBqAGBvgADRlwQAqhoBAhcIBCA6Qg4BQglBYgAl8n6IBDg6QA/BcArBoIhQAeQglhXg4hRg',
      );
    this.shape_12.setTransform(-0.375, 0.475);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AnmLyQA6gxAxg5IhCg6Qg0A7g/A1Qich+hai1Qhbi6ABjRQgBjRBbi6QBai1Cch9QBAA3AzA5IBCg6Qgxg5g6gxQDdiQEJAAQEKAADdCQQg6AxgyA5IBDA6QAxg4BBg4QCdB+BZC0QBbC6AADRQAADRhbC6QhZC0idB/QhAg3gyg5IhDA6QAyA5A6AxQjdCPkKABQkJgBjdiPgADRFwQAqBqBABbIBCg6Qg4hQglhYgAl8H7IBDA6QA+hbArhqIhPgdQglBXg4BRgACuENIBQgdQgYhagHhiIhVAAQAHBvAdBqgAj+DwIBQAdQAehqAHhvIhWAAQgGBigZBagACKg0IBVAAQAHhgAYhbIhQgeQgdBrgHBugAj+jvQAZBbAGBgIBWAAQgHhugehrgADRlwIBPAdQAlhXA4hQIhCg6QhABcgqBogAl8n6QA4BRAlBWIBPgdQgqhog/hcg',
      );
    this.shape_13.setTransform(-0.35, 0.5);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AhkUdIBThwIh5jdIh9DdIBTBwIgqAmIhLhhQgWAbgiA9IgsgXIBEhrIhtiYIhOD7IhFgXQBGjMAAhYQAAimhNktQAAgCg7iIQk3rPAAgUQAAhiCfg3QB1goDNgQIEBgQQgbhQAAhSQAAj3C0i0QCzi0D4AAQD3AAC0C0QC0C0AAD3QAAEYjhC5QgoAahEAwQgRANiMFBQiCErgcBOIgrC9QgmCVAACPQAAAyAYBjQAZBlAWAqIhGAXIhPj7IhrCYIBCBrIgrAXQgNgYgnhAQgZAcg1BFgAhcOuIBwDcIBoiqIiKizgAmVPgIBkCqIB0jcQgjg8guhFgAASMRICUCgIAgjWQgNg4glhlgAngLbIAhDWICTigIiBjTQgVA7geBigAjuMHIBkCHIBgiHQglg7g/hQgAh2ImIBoC7ICKjlIhWkEgAmVH8ICLDlIBoi7IiekugAC+ISIAiCAQAHhTAmigQgYAfg3BUgAn5KSIAiiAIhPhzQAGAPAnDkgAkaC+QAVBBAuBaIBLCWQAyhbBajWIgwkHIi4AAgADIhnQgwB2hIC9IBaEIQB5iRAAgPIAAmpIhbAOgAo9EzQAAATB5COIBckJIh5kyIhcgOgAFaD4ICqmQQhlAZhFgEgApzD4IAAl7QgmgFibgzgAAvCAIBRjWIh6AAgAlICAIApjWQgGABhmgBIgPAAgAjciVICbAAQgLg6gUhVQgRhJgwg1gAgHiaIBCAAQASAAAagHIArgIQhtgphGg+gAowneIBxExQB3ATgIAAIA/AAIBGlcIiBAAQgYAAjMAYgAo7jBQAGgBA1AAIg7iVgAtulcQAABYEAAxIAAkJQkAA9AABDgAA7oyQgYAigDAOQgBAOAAAwQAAAdAlBKQA/B9DTAAQAiAABcgLQhNgVhlhgQhXhUgzhTQguhMgKAAQgNAAgYAhgACOpxIAAAQQCLDTBtBKQAPANAiAUQBLAcAhAAQA3AAA7gvQBghMA0hjQASgmgBgOIgoAAQgbAAlOhTQiEghgDAAIgcAAQg9AAg7AcgAhBqWQg1BLAAAtQAAAzBNBeQASAXAsARIgXg5QgKgXAAgkQAAg9AJgRQADgKAjgrQAjgpAAgFQAAgJgohRQgpADg2BLgAIfp9QC6A4BeAAIAYgBQAcgbAAhcQAAjagxgoQglgegiAAQiQAAiBAoQgrAJhMAYQhrAui6BnQACATAtBXQA1gfBdAAQBfAAC5A3gAiiq/QgEAfATA2QBDh+BZglQgFghgRgtQgaAJgkAAQgjAAgigIgAF9zKQhLAqhnCCQhnCDhJAqQAGAeAQAnIAUAAQCVhjCYg1QBTgcCngcQAzgIgNAAICEAAQgNgbg/hEQg+hDgagNQhvg2hFAAQgLAAg2AfgAh/uOIAKAKQAkAKAQAAQAHAAARgFQAPgFAJAAIAAgQIgKgmQgEgfAAgxIAAgiQgrAug1BwgAA/x9Qg2AnAABFQAAAxAJAzQAGAGAKAAQAmgeA7g7QBhiLBnhVQidAVhvBOg',
      );
    this.shape_14.setTransform(0.475, 0.475);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#FFFFFF')
      .s()
      .p(
        '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',
      );
    this.shape_15.setTransform(0.5047, 0.4683, 0.8469, 0.8469);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AO8RaQAAgPgHgKQgMgOhchYIjsjgQghgcg6g8IgSgkQgHgMgbgUQgSgOAAgeQAAgdhmhJQhzhSjhhIQjBg9iugXQi8gZhaguQjlh4iUi8QiojWAAjrQAAjmCyitQCyiuDlAAQF9AAEvGbQBUByAmCwIA6E3QATBNAwCfQAfBjA6BqQBGB9BCAuIAbAAQARAAAQAVQAVAcADADIAdAKIAyA0QBrBzDaDiQATAUAfAcIA0AJQAmAKAAAqQAAAchNBKQhMBLgWAAQg2AAAAhFgADQgyQgkBWhLBNQhRBRhWAYQFIBpCyBsQh6jVhYkmQgMAMgGAOgAmrCbQBZATAlAAQAPAAAcgDQAXgCARAAIhvh1gAkzAjQCDCBADAAQARAAA9gTQA9gTARgLIi2i3gApkBjQBFAkBDAFQgtgvgxgpQgQAPgaAggAokAjIBjBjIBqhjIhqhngAi6hWIC/C7QBOguAYg5Ii6i7gAr9AKIB9BKQALAAAsg2IhqhiQgnAkgjAqgAmrhRIBiBcIBshhIhshnQgpAqg5BCgAqZhWIBjBhIBmhhIhqhngAt+hmQANATAnAkQArAoAMAAQAMAABChPIhmhngAhCjPIC4C4QA2hXAAhCQAAgCiDiDgAkzjPIBsBsIBmhsIhmhmgAsVjKIBiBnIBqhsIhqhmQggAghCBLgAokjPIBmBoIBnhoIhqhmgAvujqQAXAoBCBGQAagZBBg6IhihmQgmAfgsAsgAA3lLIB2BzIAAh6QAAgJgMhTgAi6lLIBrBmIBihmIhihjgAmrlHIBmBiIBohmQghghhLhCgAqZlHIBjBiIBmhmQgggihKhBQghAgg+BHgAuOlHIBjBiIBmhmIhmhnQgqApg5BCgAxCmMQASAqA0BeIBKhHIhnhjQgLALgeAXgAhCnEIBrBrIBihrQgrgrg7g3gAkznEIBsBrIBmhrIhmhigAoknAIBmBnIBnhrQgvgvg7gzgAsVnAIBiBnIBqhrIhqhiQgnAjg7BDgAwGnAIBqBnQAjgkA8hHIhjhigAxKmmQALgJAQgVIgqgpgAi6o8IBrBqIBihqIhihfgAmro5IBmBnIBohqQgngkhFg7gAqZo5QArAyA4A1IBmhqQgfgfhLhAgAuOo5IBjBnIBmhqIhmhfgAxjopQAAAUBOBDQAggfA/hLIiYiTQgVBTAABTgAA3o5IBXBYIAAgPQAAglgkhRQgYARgbAcgAhCq1IBrBqQAtg2AAgEQAAgOgfgyQgdgtgOgNgAkvq1IBoBqIBmhqIhmhjQgiAdhGBGgAokq1QAfAjBHBHIBnhuIhqhfgAsVq1IBiBqIBqhuQgkghhKg+gAxCr1ICmCqQAsgyAzg8Ii/i7QglAqghBVgAi6stIBrBmIBOhOQgvhHg0gkQgdAag5A5gAmrstIBmBmIBohrIhshegAqZstQAhAkBCBCIBmhrIhqhegAvuuKIDDDDIBmhrIjGi+QhAA6gjAsgAkvuiQAhAhBLBBIBJhXQgMgTgqgjQgpgjgRAAQgTAAgyBOgAokuiIBmBiIBnhmIhqhjgAtyv+IC/C+QBDg7AngrIipigQguAThSA1gAmrwbIBmBjIBHhIQiAhGgHAAQgLAAgbArgArNxQICXCYIBmhnQhEhGgMAAQhKAAhjAVgAnBwxQANgMAWgOQgjgJgqgIgAq+QdQhShSAAh1QAAh4BRhPQBRhOB4AAQB5AABQBPQBQBQAAB4QAAB1hSBRQhTBRh0AAQh3AAhRhSgAn9Q3QARAAAegKQAAgnAGgJIBIhcQAkgvAAg5QAAh6hHAAQg+AAgQCEQgSCYglAaQgOALgfAAIgvAAQAvA3BYAAgAmzQkIAQAAQCJhAAAiOQAAheg/g9QhAg9hdAAQheAAhAA+Qg/A+AABeQAACQB2AAQBQAAAAhrQAAgPgDgeQgDgdAAgQQAAiBBrAAQBnAAAACfQAABBg7A/Qg6A/gBARIAAAAQABAAADATg',
      );
    this.shape_16.setTransform(-4.525, -10.125);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AvaPcQjcjcAAk4QAAk3DcjcQDcjeE2AAQBDAACAAdQAvhpAAgiQAAiTgTiEQgZirAAgIQABiMAwhAQAkguBOgeQAGgDATAAQDgAAgBExIgcFZQgDApAQBMQARBNATAjQBhikAAilIgblJIAAg2QAAjiDXAAQAPAAAzAeQAvAbAcBUQAZBKgFA+IgfFZQAABQAcBQQAFAPA4CFIADAAQAthsABhSQAAhtgIg4QgViVAAhJQAAhpAxhRQA7hgBjAAQBYAABABMQAMAOAYBAQANAlAABZQABBCgYCCQgYB/ABBEIAFApQAOBlA2B2QBKCoAACfQABCthNCgIgfBaQgZBCgdAoQgZAjhZAYQgHABgxAAQhoAAgwgnQgngggshoQgFgggZhHQgMARgZAgQgpAphpAAQhIAAg3gbIgGANQgeEsjRDGQjTDJkrAAQk4AAjcjcgAufgWQi/C+gHELIAAAGIAAAHIAAAGQAAEXDGDGQBlBlB6AwQB1AwCJABIAGAAQDPgBCihuQA3gkAwgxQAxgxAkg3QByi5gDi5IAAgFQAAiJgwh2Qgxh6hlhjQjEjGkYAAIgGAAIgGAAIgGAAQkLAGjADAgALAigQhDCMgHBNIgGAmQgEAXAAAOQAABcAcB1QAaBsA3BrQAKAaAWAiQAeAcBfAAQBJAAAWgZQBHhMAticQAoiLAAh5QAAiMg4iNQgUgpgkhYQgGgegPg9Qh3AIgOACQADABgDAAQgEAAAEgBQgKgChRgIQgJBMhDCKgAErGPQAXA6BCAAQBcAAArgPQA2hbAAgQQAAgfgMg9QgMg+AAgfQAAhMA0i0IATgvQAPgjAAgFQAAgfgkhMQgxhkgDgJIgWhXQhBAIgsAAQgvAAgxgIQgQBTgeBLIg/CRQAAAGAaBCIAdBWQAZBkAABHQAABGgKA0QgKAwAAgMQABArAXA+gAial0QABAagNAmQgTA1gCAJQBtAdCCB5QCCB5ApBpIAAggQAAhVgvhyIhVi/IgVhaIgYAAQgPAAgeAEQggAEgNAAQgPAAgngEQglgEgTAAgAMWn1IDZAAIAAhBIjZAAgAiZn4IDXAAIAAhGIjXAAQADA6gDAMgAFSpjIDBAAQgDgQADguIjOAAgALytSQAACKAUAmID9AAIAci/QABgNgIgrQgbichzAAIgHAAQiSAAABDjgAjHtvQAAAmAcCgID5AAQAUhCAAiNQAAgXgSg4QgSg4gMgRQglg0gwAAQikAAAADVgAEjutIAUCmIDtAAQARhgAAgpQgBjziEAAQiNAAAADWgAurI+QgZgZAAgjQAAgjAZgZQAYgZAjAAQAkAAAZAZQAZAZAAAjQAAAjgZAZQgZAZgkAAQgjAAgYgZgArKFIQgUgUgBgdQABgdAUgVQAVgUAcAAQAeAAAUAUQAVAVAAAdQAAAdgVAUQgUAVgeAAQgcAAgVgVgAtrDxQgUgTABgbQgBgbAUgTQASgTAcAAQAaAAAUATQASATAAAbQAAAbgSATQgUATgaAAQgcAAgSgTg',
      );
    this.shape_17.setTransform(-13.45, 2.125);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AHZLmQiBhig4ifIjDAoQgiAugYA8QAHAEASACQALAJAAAgQAAAfgLAMIicAAQgSgVAAgWQAAgpAfgBQAfgCAfAAQAhg6AXg+QhLg5AAhCQAAggAggrInUnEQgIAFAAAOQAAAKBHBZQBMBeALAjQAjBuAACSQAABWgTAjIgTAEQgsBcgsA+QhABXhuA1QhvA2hvAAQjSgBiViWQiViXAAjRQAAjKCCiKQB8iGDLghQAAgJgRgQQASgeAXAAQAqABBZAWQBgAZAZAXIAOAAICgmfQhGgrAAhmQAAgmBMhMQAEgCALgBQAWAAASAVQAUAUgBAVQABASgXAbIgjArQgIAJABADQgBAYAlAJQAqAJAIANIABAcQAAAaglBZIgyB7II1G8QAHABAEgLIBAiZQBDilA1h7QgJgNhCgfQg7gcAAgTQAAguBlABQA1gBBLAGICAAHQAcAcAAAcQAAAig4AcQgwAYgmAAQgGAAgPgDIgVgDQgJABgYA0QgXA0AAANQAAAWBPBmIAYgRQBcg5A0gRQA9gVBsAAQBiAAApAMQBZAcBiBQQBeBOAzBRQAmA5APBIQACAWAHAhQgFAHgMAAQgKAAgZgbQgDADAAAGQAAANAGAnQAFAhAAAXQAADOiXCTQiaCUjMAAQimAAiChigANeE3QgUATgtAeQgSAIhkAYQhmAZjSAxQAjCEB0BRQBvBPCMAAQCzAAB9h8QB9h8AAiyQAAgqgWhoQh1AnjFBWgAvrgzQhsA0hDBpQhDBpAAB5QAAC0B+B7QB+B7C0AAQCbAABwhZQBuhaAmiZIk0gwQg+gEhZgOQgSgGAAgeQAAgNAKgUIAOgcQAKgkAUiMQAUiNAAgmIhNAAQgrAAhSApgADaHDQAngFATAAQgGgSAAgcIgjAAgAFaF7QAGAfgBAUIF8hbQgLgLAAgPgApnCqQg+AzhKBhIFlBBQAAgLAEgRQADgYAAgHQAAisiaiVQgUA4g2BvgAm5jYIHtHsQAtABASgjIAbhKIo2mxQgEATgNAegAIagUQBCBdCMCZQAOABAhAHIA7AkIExiBQiLjrj0ABQiPAAhbBJgAC/EJIBAAAQgBioCdi8QgmgugegfgAFaD9IFRgRIjJjeQhmBggiCPgAslDuQA8gqAuhbIBMiZQgsgPhagdg',
      );
    this.shape_18.setTransform(3.45, -14.55);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AtrVOQgcgsAAgYQAAhQAqhQQATgzAuhmQAfg+BThrQBtiOARgZQAcgrAAhgQAAgTgWgyQgXgzAAgUQAAgLAjhJQAjhKAKgPQgHABgmALQgdAHgOAAIh1ghQgSgWgEgcIgJg3QgOg3gLgYQiHk9AAgIQAAgcAPglQAOglAAgEQAAgGgTgZQgUgZAAgSQAAgRA1hoQAxhjATgaIgDgcQAAgbAohCQAohCAYgUQASgGAagOQAggeA/gkQAVADAogSQABgOAAgRIgBgpIgBgpQAAg5AagrQAOgVAzgcQAzgbAaAAQC4AAAYBRQAJAbADBQIAOAQQABALAGAPQBkAaAHAAICZgZQBPgNBFADIDNAJQAkAAAegXQAogbASgHIA0AAQAaAAAngWQApgXAZAAQA1AAAAA+QAABEhvAcQAJAJAfATIAAAKQAEBRg6AAQgMAAgWgIQgWgIgNAAIgZANQgYANgVAAQgXAAgJgLQgJgLgHAAIlQAwQgOABgggLQgfgLgMAAQgIAAhaAtQgCAAghAgQgFABgJAAQgIAAgUgEQgTgEgKAAQgRAAgjA/IgtBSQgqA8gbAXQgVAGgjAZQgDAmgNBMQgHAXgCADQAFAIAbAXQAAALAHATQAYAhBJAiQBVAnAVARQgBABAAAkQAAAMA0A1QA1A2AAAwQAABFgcAuQgVA0gpBQIgFANIACAFQAggjA8hJIBNimQAphRAvg5IAaAAQgsBMAAAOQAAAGACAFIBAh2IAVAAIgWBQQAEADASAAIgCAlQgDAYAAANQALgTAshWIAVAAIAHANQAOgpATgeIAWAAQgKAcAAAVQAegvAqhkQArhmAgguIAVAAIi1GwQAIABA1htQA0htAWAAQAHAAAGAJQAUgrAuhQIATAAIhKDZQARAHABAJQgBgLgoB1QAQgOAfg0IAPAAIhhD3QgKAhgeBDIgQAQQgEAGghBQQgqBnghA3QhrC0ieDMQhsCNhmBSQhCAlh3BJIgkAkQguAihaApQgDABgcAAQgOAAgUAMQgSAKgKAEQg/ASgjAAgAr8T/IA6gLQBvgVBXg0QBbg1BWg2QBjg6BzhzIC+jJQAmgoBjjNQBjjOAAgvQAAhChEAAQhKAAhcBGIiQByQAGACALALQALALAEAAQALAAAYgHQAUgHANAAQATAAAGASIAHAhQAMAeAAADQAAAbg9AlQgUATgjAVQgnAChRALQgYAHhEA9QgFABgMAAQgPAAgSgIQAAAIgDAQIgCAZQAAARAkAyQAjAyAAAVQAAALgBAIQguA7gRAAQgLAAgQgFQgSgGgHAAQgJAAgLANQhEATg7AAQgVAAgmg0IAHg7IhVB4QgYAzgpBNIhLB1QghA+AABHIAuAAIAAAAgAngBGIAqAdQAUAQAAAbQAAAmgnBOQgoBPAAAVQAAAPAWAxQAWAxAAAnQAAAagQA1QgPA5AAAXIAACYIAcAAQAOAAAegOQAegNANAAQAJAAAMAEQALAEAJAAQAMAAAIgJQgdhBglgiIAAiMIBQnmQgSgbguhYIgcAAQgpAog1BNgAjYg5IAkASQASAKAAAUQAAAlgxBMQgGAJgYAWQAZAqAAAOQAAA1gZA0QgnBQgEAOIgKB5QATATAJAAQAGAAAcgUQAegUAIgDIBogLQA2gHAkg5QhNgHhNgJQgGgMgbgeQgCgEAAgKQAAgSBdi3QBdi3AAgbQAAgDhgh6gAszljQAAARACACQA4B9BoD6IAPA+IA6AYQAIAAACgGQAEgbAmgxQA0gzBPhsQgHgCgqgFQgVghgKgOQhThghBgvQg5goh7g4QgKAmAAAQgAj4AWQAGgGAAgPQgIAAgIgIQAAASAKALgAlAk/QAMAGANAdQANAdAAAOQAAAHgLAMQAAAYgDAvQgGAHgkALQAMAZAdAsICii7IAAgUQg5gWhMg6QhbhHAHgrIgUAAQg9AqhOgLQBLA6B0A5gAlhizIAAhcIh7hFQgPgFgZgMQhBgtg+hAQg+g/AAgUQAAgIBMhUIhkhHIg0BcQgmBDAAAXQAAAFALASQAXAmAuAVQBDAfAMAKQA9AtBRBUQAOAEAXAOQBFBRACAAQAIAAAMgDQANgDAHAAIAFgCQAHACAFAGgAmzsSIAAAaQAAAPg7A/IguAlQgmAeg5BDQATAbAtAkQAsATA9AAQAVAAA0ghQAzggADgSQgPAKgQAAQgLAAgGgFIAAgWQAAgJAngoQApgnALgFQAUgGAigOQAhgXAag1IArhXQBIhvAsAAQAJAAADAcIATAAQAgg5AAgUQAAgrgkgJQgKgDg9AAQgMAAg2AtIAAAEQABBOhmBMIhuAAQgKAAgfgTQgfgUgEgIIgmheIguAAQgkAUhGAxQgtAmhGB5QBqBHAnAAQAsAAApgtQAqguAQgBgAm3ygQAADBBPBBQATAPBEAAQAjAAAphMQAphNATADQACgSAJgeQgOAIgJAPQgKAQgXAAQgDACgEAAQgTAAAAgwQAAg/gRghIgyAAQgIAAgPAFQgOAFgJAAQgKAAgZgHQgXgHgMAAQAFAAg1AggABdweIgNBWQBWg2AGAAQAGAAAsAUQAsAUAFAAQAMAAAbgHQAWgHAOgCIC6gUQAIgBAzgUQAFAAAUASQATARAGAAQAKAAASgHQAVgHAMAAQA/AAALAGQgZgOgtgVIAAgmQAVgMAsgUIAvgJQAQgEAVgjIgGgKIg9AgQgPAHg9AAQgUAAgbATQgiAYgIACQgDASgKAKQgeADgQgBIkOgSIgEAAQggAAilAZgAlkuvIAAgVIAqgCQAPAAAaADQgHAegpAAQgPAAgUgKgAlkvWIAAgaIA0AAIAAAagAkiwDIAAhFIAdAAIAKAJIAABBIgBAAIgLACIgMABQgJAAgGgIgAkcwvIAAAHIAMgGIgDgHgAmJwDIAAgiIAAgoIAbAAIAKAKIAABAgAmEwwIAFACIAGgLIgGgDgAmYxjIAAgeQATgSARAAQAKAAATASIAAAaIgaAAIgHgJQgHAHAAAGgAkGxtIgKgIIgLAIIgUAAQAHgmAaAAQAKAAASASIAAAUg',
      );
    this.shape_19.setTransform(20.125, 7.025);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#FFFFFF')
      .s()
      .p(
        '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',
      );
    this.shape_20.setTransform(0.475, 0.475);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#FFFFFF')
      .s()
      .p(
        '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',
      );
    this.shape_21.setTransform(13.5895, 0.4725, 0.921, 0.921);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'ALQO9QgGAAgRgOQgPgPAAgIIAApiICUAAIALzyIGUAAIAAdIQAAAxglAAgALoOeIG1AAQAcAAABgqIAA70QgQARgJAGIAAbuImoAAQgRARAAAIgABQO9QglAAAAgcIAApsICfAAIANgMIAAzlIDMAAIAATlIAMAMICpAAIAAJoQABAHgOANQgPAMgIAAgABoOeIGyAAQAbAAAAgdIAAohIgUASIAAIIIgMALImhAAIgMAZgAozO9QgIAAgPgMQgOgMABgIIAApoICTAAIAAzxID1AAIAATlIAOAMICXAAIAAJsQAAAcglAAgAobOeIG2AAQAKAAAPgSIAAosIgVASIAAITImoAAQgSASAAAHgAy3O9QglAAAAg5IAA9AIFxAAIAATlIANAMIC0AAIAAJjQAAAJgPAOQgNAOgJAAgAyfOeIG5AAQAaAAAAggIAAoiIgWATIAAIGQAAAFgLALImgAAgAHEDyIAAyuIApAAIAARuQAAAGANALIgnA+IgCAAIgCAAQgLAAAAgPgAtIDyIAAyuIAqAAIAARuQAAAGANALIgnA+IgCAAIgCAAQgMAAAAgPgAivEBIAAy9IArAAIAARuQAAAKANAHQgNATgKATQgRAYgOAAIgCAAg',
      );
    this.shape_22.setTransform(0.464, 0.046, 0.9201, 0.9201);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics.f().s('#FFFFFF').ss(6, 1, 1).p('AwlAAMAhLAAA');
    this.shape_23.setTransform(-1.9, -90.2);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f('#FFFFFF')
      .s()
      .p(
        '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',
      );
    this.shape_24.setTransform(-2.585, 2.5081, 0.8624, 0.8624);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgdC8QhEgVgVg/QgihiAYg3QAchDCBhRQgXBsARBTQAUBcBIBGIAAgBIACADIgCgCIAYAeQg2AMgsAAQgoAAgegKgAAuCXIhVj1QgWCMBrBpgAhfAvQAUA9A1ApIhEjKQgZApAUA7g',
      );
    this.shape_25.setTransform(-5.786, -41.4564, 0.4821, 0.4821);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics.f('#FFFFFF').s().p('Ajwg+IgBgLIHCgxIAhD1g');
    this.shape_26.setTransform(84.1036, -49.2909, 0.4821, 0.4821);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics.f('#FFFFFF').s().p('ABaikICqCzIoHCWg');
    this.shape_27.setTransform(74.0641, -96.6076, 0.4821, 0.4821);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics.f('#FFFFFF').s().p('AE6jSIBoGQItDAUg');
    this.shape_28.setTransform(94.842, -80.1082, 0.4821, 0.4821);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'EgTBAg+IAJhmQAGg+gBgpQgDh7gIjYIgMlTIgJjZQgFiDABhXQADj5A9i8QgggSgRgEQihgog/gNQg5gMgRgZQgYghAchGQhlBUhqgSQg8gJh9hEIAsgrQAZgZASgPQBShCAnhsQAahIATiJQBfrAA0lYQAXiUB4g1QBkgrCGAfQA/AOA9gRQCPgpBdgBQB/gBBnBBQAkAXAUAfQBEBpBXCTIAXAnQALAWgBARQgGBGAnAxQAeAlBEAlQBAAjAEAPQADAPgtA4QgCADgCAHIgCAMQALAOAqAQQAgASgSAoQgLAXgVAjIglA7QAmAXAIAEQAnASAHANQANAUgfAjQgJAKABAaIADAtQABA9gaAiQgbAig6AHQhYANhRgNQgfgEgRAKQgRAJgKAaIg5CTQgiBYgTA9QgTA+ArBDQAoA/BDAZQBHAbBCA+QBUBOB2ByIDIDEQA9A8BuAmQA+AWB+AoQAUAHAhAJIA3APQA9iTAeiCQAjiSAAiLQABlFgFkRQgBhYgUhFQgbhcAZhQQAYhQBOhOIhDgRQgigJgWgEQg7gLgYgRQg1glg5hyQgeh4AVhDQAXhOBig3QFnjKEMlYQAfgnAUg1QAMgiARhCQARhFAugSQAugSA9AmQBHAtA9BRQAiAtA/BtQCpEmAqEzQAPBwgdCeQgJAwgiAOQggAMgygUQhngph3gMQhmgKh+ALIkDAUQg5AGgNAPQgOAPAFA0QBKgUAPAJQAQAJgKA5QA7AIASAUQAQATgCA1QAGAPAKAfQAKAbALAOQAqAxgNBPIgMBAQgHAmADAZQAEAhgMARQgMARggAJQhCASgiAvQgjAuABBFQABBCAGCEQAHCFAABDQADFigFFMQAAAtgIBEIgNBwQgGBCgoAgQghAchSAWQhSAWhqgLQgngEiTgdQhZgQiFgeIjegzQgFgBgGACQgIABAGAAIAGCEQADBNABA1QAAAhgZAiQiyD7gxEDgASt6sQgxA4glAkQhqBshbBHQh8BiAKCEQAIB0BhBYQAXAUAoALQAkALAlgCQBBgBB/gLQCBgLA/gCQAqgBA8AIIBbAOIhxjDQhEh3gkhVQgkhWgliCQgmiQgUhCIhJBUgAW/0kQBICnA4BCQAUizhAiYQhBiYh9hCQAiCTBICpg',
      );
    this.shape_29.setTransform(-25.1652, 4.787, 0.4821, 0.4821);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f('#FFFFFF')
      .s()
      .p('AlGHAIgBgLIHCgwIAhD2gAHClRIBpGPItDAVgAjLp6ICpC0IoHCWg');
    this.shape_30.setTransform(88.2615, -73.9616, 0.4821, 0.4821);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f('#FFFFFF')
      .s()
      .p(
        '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',
      );
    this.shape_31.setTransform(2.8038, -2.4269, 0.9249, 0.9249);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AmXUoQAAgKAMgKIAAgtQAAggACgEQACgHDOivQLdpwLot7IAzAOIAAApIhABsQBABFAAAKQAAAOg1A7Qg2A7gRAJQgJgCgZAHQgIAGhsBnIvvOtQh0BzjwDaQgdAZhKAYQgKgIAAgOgAhLPxIiGBxQhmBYAAAeIABAcIWf1ZIgogkQmoHprkKRgAtnRcQgcAfgcAAIgVAAQgpgkhPhAQgfgOgnglIgHgdQgngig6hDQhkiRAAkEQAAgpA0hsQAqhYCYhAQCjhFAWgeQAWgfARhEQAIAAAMgCQAMgCAIAAQAoAAAYAlQAZAjAcAAQA+AABJhBQBKhCgBg+QAAgDgZgrQgCgLAAgaQAAgcAegIIAxgNQAWgOAnhCQAvhRAKgMQCGijCmAAQBtAABEAcQA/AaBYBJQCqiJFBkZQARgaArgyQg6gzgkAAQgVAAgcgfQgbgfAAgVQAAgCAzg5QADgBAFAAQBZAAAABQQAAASAyA+QAigbAzg1QgRgcgqgVIgYAAQgbAAgZgeQgagdAAgbQABgLATgRQAUgRALAAIAeAAQAZAAAnApQgCAHAAALQAAAyAvAnQAYgRAYgfQAAgTAlgkQgDgHgTgNIAAghQA4gpAJAAQAWAAApAfQAqgfAJAAIBRA6QABAFAAALQAAAegaARQAoAmAAAKQAAAPgVAYQgVAYgQAAQgMAAgcgfIgWAcQgNAQgRAAIgMgDIgLgCQgBAAgfAlIBKAuQAggSAHAAQgDAABEApIAAA3Qg2AngkAAQgSAAgigfIgCgwIg+g0QgWARgdAmQAgAgAUAJQAOAAAeAHQA5AYAAA3QAAAOgRASQgQASgNAAQg8AAgkg3QAHgbAAgFQAAgNgzgxQggAog1AyQgJAAgVAHQgJAHiECKIknE+QBqB6AACzQAACjhIBSQgnAuiqBnQgaAPgYA5IgMAyQgJAegcAAQgdAAgbgeQgcgfgUAAQgcAAhEBLQhEBLgJAgQgFAPAAAaQABAWAtAoQAuAoAAAlQAAAegXALIgtAVQgbAOgwBWQhABqgqAyQhQBZhsAkQhFAWhiAAQhUAAithsgAoDI9QAJAPgBANIgBAKQiMBli9CMIhYBAQA1BPBbA3QBiA6BbAAQCJAABYhOQAjgfBaiBQBEhkBIgdQhpgtAAhEQAAhUBhh1QBhh1BSAAQBAAAAfA4QAOgrAuhLQBLgyB7iCQAlg7AAh6QAAhwhNhbQiICNkMEZQhjBrgOAAQgNAAgEgEIisC3QARATAAAKQAAAQglAZIgWgRQgxAphkBXgAu3DJQilBDgZAXIg7BKQAtALBPAbQDEBhABCtIgBAgQBZiSBXh+QADgCAGAAQAHAAAIACQAJACAHAAQAUAABziMQgOgLgDgKQAQgYAUgOIAfAVIBqhcQBJhDAAglQAAgKAFgGQAHgICTiKQCkiaDNjDQhchEh/gWIg1gIQhwAAhmCIQgoA/hSBYQgRAKgtAKQAgA4AAAOQAABxhiBZQhgBbhzAAQgzAAgxhJQgVBphvAvgAoiIWIAKAPQAxgkBhhXQgMgMgQgIgApYHmQAMAIAXAUQAmglBVhfQgFgKgPgOgAp1HHIALAHICFh3QgIgJgSgLgAlvFfQAHAKAMAKICjioQAAgEgLgLgAmXE8IAKALQA4gwB5hvIgXgPgAm+EaIAQAKICeijQgLgLgKAAgANgu6QAUAcAaARIC+jLQgYgZgTgLgATTyGQAjASgDAAQAPAAANgcIgcgcQgMALgUAbgARDyvQAXAWAtAhQA/hGAigzQgKgJgfgYgAQ10FQATASADAAIAegcQgTgTgEAAQgbAAgCAdgAmBJtQgBgwBchbQBdhbgBgJIgjgVIAAgqQANgTAqAAQApAAAJAQIABAqQAAATgDANIjEDhIAmAAQAXAAARAMQAEAZAGAbQgYAWgWAAQhiAAABhQgAsnDnQAAhCA6AAQAVAAAQAGIAAAwIAMAEQAVAAAxgbQAsgZATgSIA+hFQAogoAoAAQAwAAAAA5QAAA8gsAAQgTAAgGgIIgLgbQgWAXguArQh0BghfAAQhHAAAAg5g',
      );
    this.shape_32.setTransform(0.4814, 0.5207, 0.8096, 0.8096);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics
      .f('#FFFFFF')
      .s()
      .p(
        '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',
      );
    this.shape_33.setTransform(0.612, 0.5204, 0.8249, 0.8249);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f('#FFFFFF')
      .s()
      .p(
        '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',
      );
    this.shape_34.setTransform(-0.7444, -12.6719, 1.0258, 1.0258);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f('#FFFFFF')
      .s()
      .p(
        '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',
      );
    this.shape_35.setTransform(0.45, 0.475);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'APuQZQgjghAAgmQAAggApgiIBDgzQgHiFktmUIgEAHQACAvAZBhQAZBhAAAxQAABwhXByQhbB3huAAQhlAAAAg5QAAgJBhhgQBhhgAAhMQAAhIienUIACgBQgCgFgIAAIgDAAIkYB6QgsARkHBMIgOFUQgLDlgzBYQgTAig5AaQgyAWgsAAQhlAAAAhMQAAgQADgIQA1gtAjggQA2gwAAgxQAAhDg3jtIhED5QgtCmg5A6QgoAmhsABQhoAAAAhEQAAgSA+g5QBIhDAIgNQAVgeAgjWQAdjHAAhDIgWiKIgZjkQgIhPhkiEQhpiLhIAAQgQAAgcADQgcAEgPAAQhRAAhKgmQhagtAAhIQAAg/BNgVQBDgRA8gMIB7hDQBPgoA0AAQBGgBDRCPQDnCeBEAXQB5AnDPAAQAXABAPgCII2gzQA1gCBWAsQBWAsgDAAQAlAABIhxQBEhpAEgtQACgQAAglQAAjSh+AAQhHAAghBEQghBFghAAQgkAAAAgrQAAhbBJg6QBDg1BfAAQBoAABCBlQA5BYAABvQAAB5goB0QgvCFhWA/QAkA7AAB5QAADagQBTQgjC2AAgFQAAASBICCQBJCGAEAoIASC1QAOBkAAAKQAAAsg8A6Qg8A5guAAQglAAgkghgAPIHuQCpElAABHQAAAdgsAqQg7A4gFAHQAYAZAaABQAlgBAkgjQAkglAAgkQAAgighjlQgIhAhJhyQhEhqAAg7QAAgyAbhiQAbhhAAgyQAAgogNgxIAKgMQgCgKgFgFQgGgGAAgCQAAgQAHgcQAGgeAAgPQAAgigWgzQgWg0AAgLQAAgPBOhTQBohvAAjlQAAhdg5hLQApBkAABnQAABThPCPQhVCchJAAQgIAAhUgvQhUgvhMAAQgNAAimAOIlkAdIgQAAQjvAAhsgmQg8gUj5igQjfiPg1AAQgFAAi9BEQi9BEgIAFQgKAHAAAPQAAArBIAfQA6AXAyAAQAUAAAlgHQAmgHASAAQBeAAB0ClQBrCZAIBoQADBjAfCvQASA1BBA+QBZBWAMAQQAfApAYCWQATCAAABPQAAAlgCASQgFAbg3AxQhIBBgDAGIBUAIQAigQAtgkQASgiAPixQAPjgAWjfIAYgjQAVgiAAiiQAAhFAcgNQAZAUAAAzQAABdgfBzQCZgkFDiFQAcgIA0gZQAHgGACgLQgshJAAgwQAAgIAGgEIASAAQADADApBSQBCCKCABTQAnAZANAAQAHAAAKgHQAKgIAHAAQAyAACqElgAovIMQgbDDggA+QgOAdgwAfQgwAhgRAiIBaAIQAggNAvgnQAZgrAoiXQAvi9A5hfQgugyhRhTQgDBugWChgAJwGHQAyCkAABQQAABag4BCIh8B1IBLAAQAxAABNh6QBKhyAAg4QAAgOgTg2IgYhNQgOhFgEiFQguglh0hWIBOD1gAriosQg0g+AAhnIASgWIATAJQAEAoAUBNQAiBNBUAAQANAAALgNQgHgZgHg3QAJgBAJgHQAnA8AAAeQAAA+gnAAQhkAAg3hDgAusqaIAIgvIAZAAQAYAXAAAIIAAAtQgJAFgQAMQgNgHgTgngAuQqNQAGAIAPACIAAgaQgFAAgQAQgAuoqXIAMAAIAAgUIgMAAg',
      );
    this.shape_36.setTransform(-9.525, -0.55);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AitUqQgcgKgJgCQh9gYhqAAQgJAAgTADIgcACQg0AAAAghQABgGAQgcQARgbAAgLQAAgZgbgwQgjhDgDgGQhWjUgah3IgChOQgOAAgbADQgdACgOAAQhaABAAhCQAAgsBJhyQBJhxAAgQQAAgEgEgQQgGgOAAgIIAAigQAAguAsiwQAPg+AyhfQA1hiBZkZQAFgQAlg/QAfg0AAgYQAAgRgHgmQgHgiAAgUQAAh3Amg4QBAhfB3g9QB4g+BxAAQBqAABwAzQAUAOBEAwQAVANBGAYQBFANA9AMQBOAPAZA0QhAAFh/AfQgeAOguBRQgKASgpAnICHCPQBIBUAdBRQAyCPAADyQAAAKAOAsIARA7QATBvA8CvQAHATBFCNQA1BrAAAzQAABWhsgBQgYAAg7gdQg7gegPgRQgbgyg+hpQgXBNgvB+QhuDlhiCSQgQAVgEAjQgEAngGARQgPAZgWAmQAaAEAlAIIBYAgQANATAAAQQgBAsgxAAQgOAAgagJQgbgKgPABQAnAigBANQAAAkgrgBQgbAAg4gVQg1gWgdAAQgJAAgPAOQgPAOgIAAQgJAAg3gcQgJANAGAdQgcAigdAAQgFAAgdgMgAlWhxQAaBOACAPQAOBGAAAaQAACkkEErIgnAlQgUASAAAfQAABVBDC4QAWA7A9B2QANAUAaA5IAIAiQAcgHAwAAIBrACQA8AAgCg2QAAhZAKgSQAoABBPgKQAWgNAtgMIAFAEIAAAeQg6AegsAKQgQBegBAWIBnAAQARAAAxg7QAyg4AFgXQABgkAThGQEdn/BVmKQAUhaAAkmQAAhrgvh5QgVg2g2g/QhShhgIgKIgfgxQgrAMgjAAQguAAhdgXQhagVgxAAIiUAiIAAE7QAAAYgoBmQglBjgSAcIg5BgQgBAMAXBHgAF0xIQhKAagYAWQBIgRAcgBQAUAAA2gTQBAgZAPgDQgGAAgSgFQgPgEgIAAQglAAhHAagAgdx6QAABNBbgBQg2gJAAg1QAAgPAOgUQANgTAPAAQAuAAAAA6QAAAUgLASQAUgJAAgeQABhphKgBQg8AAgBBZgAgsztIAAAZQAJgCAWgPQAQgLAQABIAAgUIghAAQgNgBgRAXg',
      );
    this.shape_37.setTransform(0.45, 0.45);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics
      .f('#FFFFFF')
      .s()
      .p(
        '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',
      );
    this.shape_38.setTransform(0.45, 0.45);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AD1ToQhuhggWggQiij1gSkPQg4gSh4gNQhygMg8gWIgDAEIAAAKQAAATAiBkQAiBjAPAcQAWAvBdB8IA6A9QAoAtAAAWQABA0hFAAQgOAAhGgVQjdg9iYlYQgLgYgbh8QgMg1gNhkQgogdgjgcQg8gugbguQgIgYgagsQgYgHgwgSQgbgQglgpQgpgrgVgNQgVgNhcgZQhHgSgegtQgigyAAgoQAAg/BCAAQAJABARADQAPADAIABQg3glAAgwQAAhBBNAAQARAAAiAQQAgAQATABQA0gBAdgUQAFgFA3g+QBEhMA0grQA9gvB3gvQB0gtBQgOQBJABCNgWICoiBQBng/DHiPQCeiBBHhjQALgrA6hPQAQAFAqASQAsAcBHBVQBKBbAHAsQACAKAAARIAAAqQAABQgrBbQgsBdAAAbQAAAaAQAzQAQAwAAAgQAACzi7BWQALA4ALABQA/AAA7g3QAigiA1haQA8hrAUgbQBUhyB3grQBQgeA8AAQA3AAAAAYQAAAUgFAuQgHArAAAXQAABGAWA8IArB6QBLDkAABrQAAA/g4BSQg3BVAAAvQAABGAiBjQgcAdgvABQhRgBijhhQiVhXhGhKIhDhgQgpg0g7AAQgLAAgOAfQgNAgAAAOQAAAEAUA0QBJDIAABuQAAB3hjDUQhkDSABB4IACBFQAAAHgFAgIgEA+QgQALgUAAQgZAAh1higAF3T/QgVgogBg/QAAhQAhhVIA7iYQACgPAGgjQAEgNA6iJQAlhVAAhJQAAg/g3jcQhZB9hEAAQgVAAgJgYICPiyQBHhpAAhvQAAgUAEgLIAOAAQAiAhgBBhQAlgEAZgBQA0AAAoA3IBCBeQBdBcCbBYQAZAJBoAvQgRgvAAg0QAAhqAphBQAVgWAegnQAOgdgBhZQABhdhPjwQgqiCAAggQAAgzAghhQg0AKhkAqQhvBTg7ByQgPApgwBaQhWB5hmACIgbgBQgiAAgLAfIgWAAQgWhEhCiBQgWgdi9jAQACgWAhAAQA4AABjBuQBjBtAFAAQAcAAAlgjQA6g6AAhgQAAgcgNg0QgOgzgBgdQAAg9AthZQAshYAAg1QAAhEgzhCIhfhuQiNDwm0EiQg4AwhhBGQgpAOhCACQhVAAgXADQhiAThZAfQikA4h3CHQg6BDgcANQgrAJhJAWQgpAUAFAAQgKAAgegWQgegWgaAAIghAAIAAAfQBXBDAABRIgDAHQgFgDgGAAIgbADQgLAAghgZQgggZgZACIAAAcQAAAkBUAoQBMAlApAAQAOAABbBDQBZBCAjAAQERABAAjEQAAgwgZhPQgYhOAAglQACgKAEAAIAHACQBsB5AADNQAAARgDAJQgSA5gdAXQgvAnjDApQAVA0BTBEIBRBEQARAtAHBNQAJBnAEAWQANBIBNB8QBOB/A5AoQAxAjBRAdQj/kbAAkwIACgxIAFgFQAFgDAKAAQgDgBAoAaQAtAcBHARQBvAZDPAKQAMAUAEBUQAFBgAGAWQBZFdEECrIAAAAgAvHgaQgkgjABgqQAAg1AqgnQApgmA4AAQB2AAAAB5QAAA5gsAgQgrAfg6ABQgqAAgjgjgAs9hZQgOAOgBAHQAAAOANAYIATAAQAuguAAgQIAAguIgyAAQAAAjgNAOgAuuibIAAAfIAHAHIApAAQAMgMAAgMQAAgfgbAAQgQAAgRARgAsIj7QgWgfgEgDQgHgEgtgLIAHglIA5AAQBEBCAAANIAAAeQgIAHgPAAQgLAAgUgeg',
      );
    this.shape_39.setTransform(0.45, 0.45);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'ASwT1Igog+QgmgthPg0QhshFgSgPQglgog+hAQgbAagyAAQgJAAgLgCQgMgDgHAAQghAAgVBPQgRALgVAAQgoAAgag7QgVgwAAguQAAiNBCgmQAZgHAwgUIAAgLQAAiMihiwQh5iGiihoQgFADgiAdQgYAVgXAAQg2AAgggSQhIgrhbioQgLgigihCQgigZhBg9IgBAJQAAAIANAeQAOAeAAAJQAABQgwAAQg2AAhAhSQg2hEgXhAQgLhLgoh/QglgfhDg7QhdhZhSgjIhvgZQhOgUhrg3Qhzg6gyg1QgngpAAgyQAAggAdghQgIgVAAgVQAAhXBIAAQAnAABaAtQBaAtARAAQAGAABCg5QBDg9ALgIQARgKBcgZQBcgZAXAAQBrAADvA8QC1AvC1CHICEBsQBuBcAFAAIBVghQBVggAtAAQARAAAbAIQAiAKALACQBqALBtA1QCKBCAABWQAAA+gbAAQgRAAgogTQgmgTgTAAQgoAAgvA0QgqAugQAsQgHAUAAAmQAABDAiBaIA9CXQAqB7A+DnQAaCoBFFhQAPA/AWAfQAaAmBGA+QBDA/AZAoQBMBxAABVQAABog5AAQgYAAgcgpgAOEN+IBSBeICPBuQBZBDAkA7IAAgYQAAgOgIgIQgPhNhzh1Qh/iFgYg4Qgyh0gdjKQgokMgMg4QgRhJhPjwIg6iSQgkhdAAg3QAAhYA4hZQA/hjBTAAQAPAAAZAFQAcAEALAAQgeg7iEgtQhxgmhVAAQgkAAhTAoQhSAogUAAQgdAAgwgqIhDhCQi2ihjgheQghgShAgZQiPgpioAAQgeAAhIAYQhJAZgUASIhBBFQgkAjgyAAQgrAAhhgyQhfgzgEAAQgfAAAAAiQAABFDHBbQA9AbCdAfQBHAOgHAAQAJAAATgGQAQgFALAAQAbAAAAAYIgEAOQgLAAgUAFQgUAEgLAAQgPAAgTgEQgZgEgKAAQhjgHiMg0Qidg7guhBQgHAqAAgGQABAsBRAwQA8AdA9AgQAlAVBGAcQA/AGBrAdQCGBCCuCbQA6A0DcDWIAAgkQAAgXgHgzQgHguAAgdQAAgSADgPQALACAbAJQAOAIARBuIAUCHQAXB0B3CVQA2BCAdAAQAOAAANgSQgthZgNgtQhLj+AAhVQAAgdAJgcQAOADASANQAaAcAjCsQAmC0AVAjQAaArA3AiQBOAxAPANQCyCgBKBYQCNCqAACNQAAAUgEAIQgDAIhKAuQhJAuAAAVQAAAaAeBjQANhABUgGQBVgGAPgqQAiADA5BCgAnVm4QACAXAiBQQAiBSAQAXIBTBSIAAgaQAAhPgrhRQgCgDh1hzgApVtsQAAhyBYAAQBcAAAAByQAABshaAAQhaAAAAhsgAn5tJIAAA0IASAAQALAAAQgRQARgQAAgKIAAgeQgNgDgWgCQgNAagOAAgAopuFQAHAEALADIANgNIAAgWQgCgHgEAAIgTAAgAn7x+QBbAAANCAQgkhUhEAAQhJAAgfBaQAGiGBiAAg',
      );
    this.shape_40.setTransform(3.7732, -14.5317, 0.8625, 0.8625);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'ANxB7QguABg5goQgzglgYglQiXB1htAAQh9AAheh6QhmBeiEAYQgxAJAMABQhgAAhviAQiWB6h8AAQg5AAhDgnQhBgogYgrQhrBMgNAHQgfARggAKIAAhDIAKAAIAAAGQBIgMAmhAIA5huIAcAAIAQAUQACBLAsAzQA0A+BZABQC8gBA0jBQAKgPARAAQAXAAAJAPQAJBGALAZQAUAyAxAZQA7AdAmAAQBXAABNhKQBEhBAShLQADADAaAAQALAAAIARQAJAlATA/QALAbA0AiQA0AhAkAAQAmAAA/gdQA+gcAXgaQARgvA4hUIAZAAIALAOQACBGAvA5QA2BCBRACIAAAyQgXAGAGAAQgNgBgOgJg',
      );
    this.shape_41.setTransform(-5.05, 94.2);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics
      .f('#FFFFFF')
      .s()
      .p(
        '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',
      );
    this.shape_42.setTransform(2.475, -7.55);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f('#FFFFFF')
      .s()
      .p(
        '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',
      );
    this.shape_43.setTransform(0.475, 0.45);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics
      .f('#FFFFFF')
      .s()
      .p(
        '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',
      );
    this.shape_44.setTransform(0.475, 20.1);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics
      .f('#FFFFFF')
      .s()
      .p(
        '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',
      );
    this.shape_45.setTransform(0.0141, 7.4779, 0.966, 0.966);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f('#FFFFFF')
      .s()
      .p(
        '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',
      );
    this.shape_46.setTransform(0.475, 0.475);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AnDTFIhthdQhXhHiThlQhegvi4hqQhnhChWiqQgLgXgZiDQgYiFAAgcQAAgNAKiAQAEhTAUilQAhiBA5j7QhLg1gThPQgKgnAAh9QAAiqC2iqQC4irCpAAQBiAABOA+QBOA+AXBdQAGAZATAgQAfgKA7gPQB3gYA1AAIGQAAQCJAAB+AxIA0iEQAVgpA/gsQBAgsAugKQAOgDAuAAQDLAACsC9QCeCuAACZQAAB1gKAtQgUBUhIAtQAjCAAxDnQAoD1AACmQgBgNgJBAQgcC2gLAkQgbBThTBwQgkAxg2AjQgJAIhUAqQhHAmhyBDQhqBWjtCzQghAXhjAhQhjAjgsAGQgPABiiAAQgYAAg0ADQgzADgaAAQh2AAi0hogAygiXQgjDMAACGQAABeAeCHQAHAnAYBVQAwBtBlBIQBZAwCpBlQBhBCCTBxQAoAfBnBMQBcA8FbAAQB4AABfgcQA5gRB/hmQCIhtCOhaQBMgpC7hxQBnhJAohtQA9ijAAi4QAAiOgfjEIg4lQQhyAPAQAAQgvAAgVgOQgJgFgggmIh1iVQhHhThGgoQg6gUhyg1QgfgSgBhGIAAgGIi5gnIorAAIi5AnIgGA0QgDAfgVAJIg5AZQiVA9g0AwQghAhi8DiIgfAGQgRAFgLAAQANgBhzgOQgGAyguEegAhESFQgMAAglgjQghgfgLgPQgGgbgRgzQB0AvBPAAQATAAB3gRIAdgfIgnB+Qg3AigPAAgABDO5IjogEQjFgEg+h5QgHgOAAgsQAAh2B8AAQAjAAA+ALQBLANAZACQAWACAkgBIA0AAQBjgCBHgJQB2gQAUAAQB7AAAAB2QAAC8lRAAIgbgBgAj+LfIAAAvQA9AgCAAAICdAAQBUAAA+gRIARgPIAAgvIgmgRQgYAAg4AMQg2ALgfAAQiJAAgQgDQhogOgPgEgAIhJAQgOhxgPgYQgMgUg4glQhLgvgDgFQgzgoAAgkQAAgYAbgfQAcgeAAghQAAgPgGgmQgFgiAAgUQAAgzAdgqQAegrAxAAQD9AABrESQATAwAAB4QAAC8hcBBQhHAyg2AAQhQAAgIg+gAIDBtQgtAsABA+QgBA+AtAsQAsAsA9AAQAiAAAbgMIAHAAIABgEQAUgKARgSQAsgsAAg+QAAg+gsgsQgrgsg/AAQg9AAgsAsgAsuIHQgIgMgShGQgOgzAAgsQAAhvAWhEQASg2A/hMQA/hKAzgaQBQgnA9AAQCEAAAACAQAAAQgEAdQgFAdAAAQQAABEAvAgIAHAxIgYAhQgZAjg/AnQhAAqgUAdQgKAPgOBsQgIBMhBAAQiKAAhAh3gAq7BtQgtAsABA+QgBA+AtAsQAsAsA9AAQAiAAAbgMIADgCIAFgCIAHgDIAbgVIABgBIABgCIABgBQAsgsAAg+QAAg+gsgsQgrgsg/AAQg9AAgsAsg',
      );
    this.shape_47.setTransform(0.4296, 2.4535, 0.9547, 0.9547);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f('#FFFFFF')
      .s()
      .p(
        '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',
      );
    this.shape_48.setTransform(0.6332, 0.4502, 0.8945, 0.8945);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AGfInItTAAQh2DnjlAAQj0AAhijnIiuAAQgOgLgagZQgvg7AAjIQAAmSEyilQAlgUAhAAIFlAAQCCiLD3j3QAggfAkgNQA1gUBJAAIJYAAQA0AABqAfQB2AiBNBZQAlAoA/BtQAsBPAmALQAYAHBoAAQBBAAAZAIQATAGAZAaQAaAbAAASIAADRQAtArAABfQAAAegDAnIgGBFQgHDOglBtQgtArg8AGQAOgCiFAAQh7DnjmAAQjYAAh9jngAJXEGQhEBAAABdQABBbBGBFQBEBEBdAAQBYAABEhGQBFhGAAhYQAAhdhEhAQhEhBhdAAQhcAAhEBBgAuwEFQhABAAABeQAABcBCBEQBDBEBcAAQBZAABDhGQBFhGAAhYQgBhbhDhCQhDhBhaAAQhgAAhBBAgAP7CiQBwBvgBCVIBtAAQAPgOAXgnQAfhXAAi6QAAgOgNglIg/ADQhzAAgBiGQAAhyB3hCQgMgJgBgJQi1AAgsgOQgrgPgbgrIgshQQiRjjjGAAIqyAAQgXAAghAYQghAYjMDPQjADDgLAAIlWAAQg1AAg0A9QBaAHAABMQAABYhiBLQhZBEheAIIAAClIASBWIBzAAQgCiXBuhuQBthtCXAAQCVAABuBtQBuBtADCYIMmAAQADiWBphvQBqhtCWAAQCVAABvBvgAz0BgIAUAAQAaAAAagHQAqgMA1g0QA6g1AAgmQABgUgIgJIhaAAQhHAAg5C/gASjiUQgaArAAATQAAAbAvA2IA1AAIgCh0QAAgiAEgjIgjAAQgRAAgYAqgADEjVQgSgTAAgbQAAAMASk5QAhglA9AAIBdAAQCJAABHAQQBzAZAAEJQAAA1geAZgAnNjVQgTgRAAgQQAAgMBvh0QAzg+BChMQBUhaA3AAQAUAAAmADQAgACAYAAQBzAAAAA0QAAA1gUD/IgWAYg',
      );
    this.shape_49.setTransform(3.45, -14.525);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AsJMPQgbgBgYgqQgVgkAAgdQAAgtAfgjQAfgjAsAAID9AAIAAiRQAAgTgTAAQAKABgxANQgfAJhAgBQiWAAh0hsQh0hsAAiUQAAi4CPiKQCQiIC6AAQBcAABzArQB+AwAxBAIAAmWIrEg2QgOABguADQglADgVABQgWgBgUgUIAAgnIAegSQAVgCAqgBQDDAAD5AIIGbAjQEVAZJKA5QAWAOABAVQgBApgrgFItFhFIAAGRQALAGASgBQA5ABBHg/IBxhjIDGAAIAABCQiDAHhgCmIADAKIE0AAIAQgLQArjuDiAAQB+AABRBOQBQBOAAB/QgBB8hRBLQhSBMh7AAQjBAAhHjXIgbgCQiTABhxBTQgPALg1A9Qg0A8AAAKIAAGTIEdAAQAtAAAiAjQAiAjAAAtQAAAagbApQgaApgaAAgAmTIvIGNAAIAAinImNAAgAsejWQiDBtAACBQAABAAiAfQAuAqA0AAIIqAAIAAlhQgqg4hfgkQhUgghPAAQiEAAh7BmgAJokpQg+A1gNBTIEAAAIAAA+QhLAMiwAPQAxCgCkAAQBbAABAg9QBAg8AAhcQAAhgg+hAQg9hBhgABQhUgBg7A1g',
      );
    this.shape_50.setTransform(0.4534, 0.4503, 1.1661, 1.1661);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AOZISQgKgCgYAAQhqAAhKAdIijBGIh0AMQA9hoAzhFQABAAAAgBQAAAAAAAAQABAAAAAAQAAgBAAAAQgDgCgHAAQhCAAiaA9QgTAIhCAwQhEAygEAAIhMAAQADgtBciAIgXAAQgXgCgUAGQiNArhrAzQgpAbhUAlQgjAGicAAQgVAAghAEQgpADgNAAQgtAAgegIIiyhuQhPgmiIhgQhCg/hVhuIiLi4IEOAAIAHgKQAKh0AOjuIF9BtQirApidAwIgRCiIH2AEQAbgPAlg0IA2hSQBIAPBPAbIDPhDQgCgCgYgBIgFAAQg8hKhmiDIAAieQAVggA3gwQBSgnBbgBQgKABBcAHQAnAoAaA0IAfBJQATAwAYAOQA7ASByA9QAIAICJFSIEFAAIAAiqIG0AAIAmHKQg2AFhPAaIBGElIhgAAQgFgOgZgzQgpAhgxAgIjRAFQAng9AvgwgAOwF+IAABFQAeAHBBATQgMARgeAdIAAA0QAogPBSgiIhAifQhBAIguAHgAusFGQBLA4CcBOQCwBYA/ABQANAAAagDQAXgDARAAIBKABQBKAACdhAQCchABrgCQAPAAAegGQAcgEATAAQAEAAAEACIhKBdQBnghDIg3QA5gHB2gRIAAAHIhhB/QCkg3BcgJIAAlMI+XAAQBDBZBgBwgAOqEeIEmgnIgbkkIkLAAgAFgh2IACAdQADATAAAKQAAAKgKAeIgLApICbAAQgXh/gLgoQgeh2ghggQgzgug3AAQgOAAgxASQgOASgjAzQgZBDgiBHQgxAfhUAQIiMAeQAAAggGAdIF0AAQAYAAAogpQAFgGAWg2QARgqAdAAQACAAADAEgAmEAVICLAAQAFgJAGgZIhZgoQgfArgeAfgAvFjQICpgcIipgtQAEAWgEAzgAA0jWIAUAAICBjZQgJgigyhfIh2gYQg3AAg9AuQgPAMgWAlQgWAjAAATIAABCIB1hMQB7BiAAAOIAAgBQgCAAgjB4g',
      );
    this.shape_51.setTransform(0.475, 0.45);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgkUwQgkhlhbg5QhDAzhaAOQheAOg0AAQhxAAhnhdQhohdhKkvIhEkaIhtDcIgqg4IBOoAIF5F5IAAA9IjhhxIBxEgQBqDlBCBEQBABEBJgFQA3AFBWgXQBUgWAzg9QAzg/gBhlIAAw3IlzAAIAAiSIFzAAIAAnTQAAghgegrQgfgqgOgwQgOgvgBgrQABgqAWg2QAXg0AsgiQAugjA3AAQA4AAAtAjQAtAiAWA0QAXA2AAAqQAAArgOAvQgOAwgfAqQgfArAAAhIAAHTIF0AAIAACSIl0AAIAAQ3QAABlAyA/QAzA9BUAWQBXAXA3gFQBIAFBBhEQBChEBpjlIBxkgIjhBxIAAg9IF5l5IBPIAIgqA4IhujcIhEEaQhJEvhoBdQhnBdhyAAQg0AAhegOQhagOhDgzQhbA5gjBlgAg9yFQgXAWAAAnQABA+BTA+QBUg+AAg+QAAgngXgWQgWgXgnAAQgmAAgXAXg',
      );
    this.shape_52.setTransform(3.45, -14.55);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'ANuVRIh4iwIiDAAQgFAAgaAKIggAMQjIAoh2AAQlSAAjbgaQkggjl8i9QinhTgogZQhthJgvhgQgSglAAgnQAAgFAPghQAPggAEgKQAFgWALhUQAMiBAkkAQAOhGBnjqQBDiYCmjNQDkkaAmg4QAYgkAWhQQAVhOAUgjQALgUBNg9QAxgpC5hEQAqgPCgAAQBcAABnAPQCNAUAmAAQAKAAATgGQASgHALAAQAUAAAbAYQAcAYAJAUQAXBNAyCDQAFAKAzBHQApA3AAAcQAAADAEAHQAFAHAAAGQAAAcgUAwQgEALhBBeQgTAog5A+Ig1AOQAAAPAFAcQAEAcAAAOQAAAYgXAsQgZAtgTAKQgdAOguAAQhRAAgqg+QgZgjgbhnQhEAfggAAQAGAAhRgcIg/AAQgeAAgxgmQgGABgDAQQgPBdAABHQAAAXAHAwQAHAuAAAXIADECQAZgKAsgZQBKg1DLAAQBkAAA0ALQANADArAUQAsATAGAAQBFglBRgoQCphGFRAAQB8AACnBXIAAB9IiZhFQgwgShyAAIhpAAQjHAAjDBMQgIADgsAcQgdAVgaAAQgSAAglgIQgtgMgLgBQhVgLhxAAQhyAAg+ALIhAAcQg9AbhxBBQhvBmjuCwQgMAKgYAKIghAAIAAgQIC6ipQA5hGCIiAQABgPAGgiQAHggAAgTIAAnZQAAgQAShLQAUhRACgWQg3gOgggnQg7hGAAglIAAhDIANABQBcCOA9ABIAeAAIAGhOQADgoAogaIAcAEQggBNAABlQAAAZAaAgQAbAfAZAAQApAAAcgfIAAimQAAgMAUgsQASgrAJgLIAAEPQAKARAeAAQAUAAAagWQAbgXAAgTIAAi+QAAgmAugjIgDEQQAAAQgMApIACACQA9AAA1ghQA7goAAg5QAAgUgNguQgNgtAAgWQAAgPAPidQAHgMAJgEIAqFMQAAAyghAXQArAgATAAQAkAAArhHQAphCAAgoQAAgRgGgOQgtg3g3iAQgCghgNhQQgUhFg7AAQgjAAgRAmQAJAfAAAjQAAALgCALQgVAGAEAAQgLAAgKgQQADgIAAgLQAAhDhMgSQgfgHhiAAQjVAAg4ANQg3AMhSApQhcAxgYAlQgJAmgYBEQgVAYgdA0IAAArQAAAqhrB9IiTClQgxA4hfCCQhcCfhWDXIgPBZQgVCKglDXQgDATgcBKQgdBJAAAIQAAAPAWAeQBTBtB8A6IDkBrQCGA7BmAcIBTAQQE4BMHIAAQBCAACAgjQB/giBCAAQA3AAAKADQBSAWBUBjQAKAMBwCfgADEpWIAaBiQASA3A6AAQA0AAAAhQQAAiAgpAAQgEAAhtA3gAQkRwIiLiWQghgzhOhYIhvgzIAAgRIAYAAQBIAAA1AQQBwAgBmBXQB3BmAABjQAABGg8AAQgdAAgggxgAicK/QimgVhHjgIAMgLQARAFAXALIAYAhQBRBmBEAAIGQAAQAPAAA+gVQA/gUAJgJIAegiQAQgSAUAAQAUAAALAKQAAAmgLBCQgxBvkXAAQiZAAiOgSgAhfvhQgQhRhWAKIAAgZQAagOAaAAQAcAAAeAYQAeAYAAAbQAAARgSASgABswbQgHgFgFAAQAAgUgNgpQgZglhDAGQANgfApAAQBnAAAABlIgCATQgOAOgKAAQgFAAgJgGg',
      );
    this.shape_53.setTransform(0.475, 0.475);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'ApbT6IHdvWIBkB7IBViqQhSgbg3AAQgeAAhHAJQhDAJgjAAQiZAAhohTQhKg7gOgHQgngUhNAAQhDAAiJAgQiHAghEAAQkiAAAAirQAAh3HChCQAChPAfg2QASgeBHhIQCKlXCRAAQAmAAAgAOQAVh0B1h2QB6h9BxAAQBTAAA5BTQB3jQC5AAQCFAABkBXQBlBXAACCQAAA1gPAzQA0gQBFAAQB2AABRBSQBSBRgBB1QAABNgkBOQAdgGAXAAQB9AACBBPQCTBaAABzQAABulTCoQhhCCj7AAQhiAAiHAUIjjAjIkhJyIhwiHIm3HogAmCPeIEak4IBcBwIDmnyIhdgZIiIEVIhkh6gAB4glQAABnhNA/QCxBAA6AAQBSAAE8g2QAzgIAfAAQCvAAA8hhICshgQB/hPAAgtQAAhMhtgnQhOgcheAAQh5AAhMBSQAiAzAAAfQAACPjLAAQh8AAhPguQglgVAAgjQAAgkAlgLQCdA2AxAAQBdAAAAgzQAAgXhRg8QBKh0AAhqQAAgxgzgeQgrgYg2AAQh2AAhVBPQgWAGgSAAQgwAAAAgjQAAgRAQgTQBjh2C/AAQBeAABHA2QBPA6AABZQAAAhgEAiQA/hVAAhFQAAhJgyg8Qgyg7hHAAQimAAhBBQQhQgDgXgqQBDhIATgdQAgg3ABhJQgBhPhEg2QhEg1hQAAQioAAiQFQQgrjDhoAAQhPAAhhBfQhlBkAACPIhCBYQguiCgnAAQhGAAhBCLQhWC+gIAJIgzA3QgRAZgDAwIDugUQAGAMAAAMQAAAqgnAoQiwAAkGAvIh2ATQhcASAAAZQgBBEC1AAQBFAACIgfQCIghBFAAQCFAAByBSQByBSBhAAQEtAAAAilQASgZAeAAQAdAAAXAZgAHMQBQAAiAC4hPQgRA/gBBBQgDBbgFANQgPA2g8AAQhTAAAAhPgAAmQBQAAiAC4hPQgRA/gCBBQgBBYgGAQQgPA2g8AAQhTAAAAhPgAslQBQAAiAC4hPQgQBAgCBAQgDBYgEAQQgQA2g8AAQhTAAAAhPgAzLQBQAAiAC5hPQgSA/gBBBQgDBbgEANQgQA2g8AAQhTAAAAhPgAKfJbQgBh/C5hPQgRA+gCBCQgDBagDAOQgRA1g8AAQhSAAAAhPgAD4JbQAAh/C5hPQgRA+gBBCQgEBagDAOQgPA1g+AAQhTAAAAhPgApSJbQAAh/C4hPQgRA/gBBBQgDBXgEARQgQA1g8AAQhTAAAAhPgAv4JbQAAh/C4hPQgQA+gCBCQgDBagEAOQgQA1g8AAQhTAAAAhPgAmZo2QALAAAMAEQARhHAqhAQA1hOA8AAQBjAAgBCYQgQAtgqAAQgIAAgJgDQgIhZgKAAQg4AAgaBVIgaCBQgMAwgvADQgbg3gIAAQgmAAgXA8IgYBcQgjB2hdBaQBZnSB+AAg',
      );
    this.shape_54.setTransform(0.45, 0.475);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AnWT1QkQh3i8jgQjSj8AAkSQAAjGAlhsIA3h6QB7knDGiEQBUg4EJhiIioi7QiLidAAgOQAAgRBQg7IDNiiQCyiLAIAAIGtAAQARAAHEFrQACAFAAAJQABACkzFkQApAOBYAfQDuBaCMClQByCGBnELQALAcANB7QAMBuAAAvQAAEKjUEDQjEDxkGBnIhYAZQipAzjVAAQkmAAiwhMgAlgn7QjGA4h5BgQifB8haDPQhVDDgCDWIAAAuQgDDmDmDzQCXCeDdBYQArARA6ATQCZAlCaAAQA3AACzgYQC/gaC0h7QCph2BxipQAVgcAig3QBDiHAAh1QAAjFgThJQgYg7gfhUQgtiDh1iHQh2iIh7g4Qj9hzkXAAQiuAAiyAzgAAWqHID4ATIDokOInFAAgAkNp0ID3gTIgaj7InFAAgAjvvKIHfAAIirknIiJAAgAFRvSIDrAAIlskfIhEAAgAo/vSIDuAAIDFkfIhDAAgApIOtQglgshFhIQhKhGg+hqQhGh5AAhXQAAjAAchUQAPgvBujLQA2hmBlhRQAFgFA4gdQAhgUA7gdIBugeQApgNBNgTQBZgOB2AAQBsAABkAOQAEAABgAcQAwAKBQAYQEXBoCYGNQAeBKAADVQAAAPgbBXQghBxg6BMQhnCIhbBNIhpAzQgdAShAAdQiNAqiqAIQgMAAgZAEQgYADgPAAQl4AAjQibgAnEjaQgbAPgwAgQhnBchFCaIgyBrQgPAqAABLQAACDAcBlQAbBfBrB5QBqB5BcAsQCbBKD5AAQCvAABjgaQB3ggBbhHQBEg3BOheQBahuARhDQAdh3ABgSIgChQQAAhVgOgpIgyhxQhJijhlhTIhKgvQi6h2kLAAQkIAAi8B2g',
      );
    this.shape_55.setTransform(0.45, 0.475);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AGMSgQgxAbgQAAQgsAAg2hyIg1h5IgmgOQg8gcg5igQgyiOAAhTIAAgZQAAgkAYgKQAJgDAygFQgWgRgugYQhDA7gMBXQgRCBgLAvQgVBZgrBPQiKD4jmAAQgqAAgwgSQgFgCgLgJQgLgJgGAAQALABhVAqQhbAsiaABQhvAAhggkQiCgvAAheQAAhTB5h2QBphiBegtIETh8QChhJBmhIIhbgmQgjgQgrg1QhJgJghgJQg/gRgegdQAPgdA+AAQBfAABgA2QBfA3A8AAQBxAABAhqQgMABgbADQgZACgOAAQhwAAhMgvQgjgVhFhJQg3g4gugKQg9gOgsgWQgIgQABgJQgBgcAnAAQBsABCQBvQAaAcAzApQAyAeB9AAQAsgBAIgTQgHgQABgcIgCgGQgBgEgIAAIgZADQgPADgJAAQhJAAgxg2Qgyg0AAhKQABggAWg6QgigbhJAAQhVAAhtAtQgFAAgCgOQAAgtBvgbQBUgUBDAAIAgADQAWADALAAQAFAABChAIBPhNQgEg9gBgiQABieA5hAQALgMAhgIQgkBzABBmQgBA6AWAbQBhgQgKgBQA2ABA6AnQA7AnAKAzQACAPAAAWQAAAZgEAZQASAPAPAAQArAAAAg3QAAhdgdhEQgfgihHhSQhOheABhvIACgZQADgRAAgIQAFgIAPAAQAcAAAiCHQALAtA3AvQBEA8AWAiQAtBKAAB2QAAAXgEANIAEAjQBmg5gBhxQABhMgphLQgOgNghgvQgXgtAAhnQAAg3ATgRQBIAkAJCqQArAdAUAxIAhBcQAlgVBDiSIBYjDQAohdBcimQCdjuCKAAQBZAAAxCFQAmBkAABuQAABmgkBzQgDAJgWAmQgTAfgDALQADgDAQAsQAUA3AAAcQAABAgdBEQg/CPiPBVQiDBQimAQQiKAPhFBEQAIAaAcAwQAFg6ALgMQAKgNAzAAQBOABCWAxQCnA5AYA2QACAIAIAZQAHAMB1A5QBvAzAAAnQAAAVgbAkQCUCUAAAPQAAAUgiAXQgkAXgUAAQgTABgnhcQglhcgWgIQgPgBgYgJQgrg1hkhhQh9hjg5ghQhgg5hzgQIgbBvQDjArCPCVQCZCfAADfQAACcg5BSQgQAXhhAVQhWASgqAAQhBABiIgpQhSgahohkQhphmgchRQgJgWgZhHQgShRgDAAQgLAAgIAKQgoAKgrgDQgEABgBADQABCwDFDZQA/A2BYBZQACAQAIAXQAPAcBcAlQBUAgAAAcQAAAWgVAeQgWAegUAAQgMAAiOiOgApII7ImADBQkbCeAABpQABB2EvAAQBygBA+geQA0gbBRhWQAJAIAAAJQAAAGgJAVQgIAUAAALQAAAqBCAAQBCAABggtQBggsAqgyQBjhzAfjSQAfjQAzhAQgNgQhNhrQi+C5jsB/gANQNWQhaBehJAvIApAAQAcABBVgTQBfgUAIgNQAagqAXjVQhbBug0A3gAK1K2QiLCMh0A6QAUAcAwAAQBpAACZifQCZieAAhpQAAghgagfQg6B2iMCOgAH5DkQgWAngvBBQgTAOgrApQgIAXglAoQgqAQg4AfQgIAFAAAgQABAsAdAAQBcAAB3h9QB2h9gBhgQgNgFgxAAIgOABgAmvhqQAAAuAlAmQAkAnAtAAQA0AAAAgqQAAgUgIgJQg6ghhbg3QgNAZAAALgAMXwdQgfA1inFlQhvDtiICVIhVBmQAHADA6AsQA1AlAGABQAIAAAygWQA5gYAMgCQBWgUCugkQCQgmBVhbQAegfAthqQArhoABgsQgBg3guAAQgEAAg9ARQgEgEAAgFIAAgEQCQhyAAjPQAAhegYhQQgihxhFgBQh1AAhxDDgAh/moQgIADgEAAQAeAgALAaIAXA9QASAmAeAAQAuABAAg0QABgsgugkQgsghgtAAQgDAAgJAEg',
      );
    this.shape_56.setTransform(0.4592, 0.4497, 0.865, 0.865);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AQlU/IAAx0QgcgPgnAAQhIAAgKAdQgBADAAAQQAAAvABAPIAqAZQAbARABAPIAAPcIhpAAIAAlNQgOgEgQgBQgQABgPAEIAAFNIg9AAIAAmKIAPhQIArj3IANgTIAXAAIBDFKIAAozQhAgeiZAAIAAPrIg+AAIAA3hQguhEjFAAQkSAAiWBRIAAXUIhSAAIAAwxIgMgGQg3gEjRgUIAARPIgzAAIAA0uQgjgRgVAAQhfAAghAZIAAUmIgqAAIAAwxIgIgDIj/BeIAAPWIhJAAIAAvuQA9g0AAgEQAAhNgQgJQgFgDhsAAIgRAQIAARvIgvAAIAAyBIBqmFIAcAAIBBDeQArCWACBFIAHAGQBRgxB8hqQAGguAHgoIB5l9IAcAAIBdEgIExASIAAh1IGEyFIAmAAIEDLwQAuB1BTEDIAAF0ICkB1QgCgkAGhIIBxluIAdAAIB/GoIAARegAltBTIAnAAIAAgzIgnAAgAEAotIAtAAIAAhSIgtAAQADAQgDBCgAjqOaQAAilgGgJQAXgQARAAQAfAAAAAUIAACqQgygEgPAEgAtrL2QAAgZAhgBQARAAATAKQgFCOABAkIhBABgAlFOQIgGgFQgCATABh0QAAgqAPgmIAtAAIAAC5QgPgDgmAAgAsHOSIAAilQAAgFAEgGQAGgHAAgBIAoAAIAPANIAACrQgSgDgvADgAtzF9IARgCIAQgCIAAA3IghANgALQG8IAAhAIAOAAQAigBAAArQAAAJgGANgArxFRIAeAAQAAAkAEAPIgHAAQgNAAgOAEgAkRFpIAAgzQAJAFAdAAIAAAugAwAD4IAAgmIAmAAIAAAmgAnjBqQgKgCgHAAIAAgvQAHAAAKACQAKACAHABIAAAuQgHAAgKgCgAo6BoIAAgzIAqAEIAAAvgAImgMIAAhsQAZAIAbAAIAABsQgfgIgVAAgAAfhwQAUAAAfgIIAABsQgQAAgjAIgAEcgeIAAhnIBJAAIAABng',
      );
    this.shape_57.setTransform(0.45, -22.65);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics
      .f('#FFFFFF')
      .s()
      .p(
        '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',
      );
    this.shape_58.setTransform(0.5201, -32.3506, 0.9425, 0.9425);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AnfS/QgzgRhhgyQgXgPh8iFQiWigh6jxQh7j4ghjVQgEgggIiiQgKjNAAgVQAAh9AiihQAEgTAmhjQAmhkAKgQIBihwQAsg4BmhrQDwjHFqgXQClgKBXAAQFlAACnAyQFdBrDlFeQA3BVAlClQAhCVAAB2QAADjgYC6Ig9DKQgMA5gmBzQjhHYj4C0QhRA6ipA3QgiAEhHAOQhtAZiZAAQknAAi4hfgAn4yRQgmAMhvA+QhoA7gjAcQiEBrgmBNQhrDXgeEYQAAAIgHAgQgFAZgBAMQAAAPAGAbQAEAaAAAPQAAAqApDrQAKBGAaBzQAzCxBNCjQAnBWCqC0QAoAyBfBeQBMA7DDA6QBfAbC7ABQDpAACXhEQA9gTBtg6QBZhMBrh9QByiHAthfQBSizAkiRQBRlMAAjEQAAhggoioQgBgNg1iYQgVhGglhgQhwiji9hlQi0hijLgRIgkgFQgYgEgRAAImFAAQh6AAi8A2gAjvQEQA8hVCzAAQBQAAA1AMQAVAFAuAkQAuAjAAAQIAAAhQhWguhhAAIh5AAQhzAAhOA1QAAgVAMgmgABzGhQACgUAAgbIgDhhQAAhwArinQAbhiAwhsQAdgnAwhJQBQidDChdQApgTByglQB8gpAfAAQAGABAgAGQAmBHAABvQAACahnDqQgZApgzBWQg4BriEB5Qg+A4itBAQhfAkAJAAgAJSmoQhkBJg7BgQgjBXgrBsQDyi/BZjZQgjALg7AhgAlEFvQhNgZghgLQgwgUgygnQihh7h8jTQgNgfgthlQgkhGgWiAQgOhXAAgQQAAigBIAAQgLAACLAkQA8AMBzAhIAwAeQCJBOBBBIQBUBhAqBJQB5DVATDvQACBPAEBdQgVAAgjAEQgjADgXAAQgZAAiHgogAsbkXQAcBXBOBlQBOBkBNAuQgRhGhHhwQhAhog8g8QgMgMg4gbQAHAOAMAlg',
      );
    this.shape_59.setTransform(-2.55, -1.05);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics
      .f('#FFFFFF')
      .s()
      .p(
        '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',
      );
    this.shape_60.setTransform(3.475, -14.525);

    this.shape_61 = new cjs.Shape();
    this.shape_61.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgPRaIACA3QAAANgCAKQgwAohmBIgABJTxQgHgZgXibQgPhsgdidQgCgggRhKQgGgPgigXQgigYgQAAQgHABgGATQgaBXheAzQg2Aeh+AjQglAFhJATQiGAph5BAQiPBMlxDbID2myQCVkLA6i2IAfhvQARgyAzg8QA0g8AvgVIgRgyQgMgbgWgNQgggUhNgHIh2gNIjggmQgpgDhKgQIgegXIEUkoQCpixB2hkQByhgCPANIGLAmQAPACCViUICriqQA5g1BrhaQAxgWBJgjQCchICmgBQC1AADNAzQA6DBAADRQABDgiMDaQgOAXhUBaIjBDBQikCnABAMIAqGPQADAhghBiQghBkgYAYIo3I4QgYgUgEgOgArPE1QgWAlgcBGQghCnhgC5Ii+FEQDEhsGWjFQAygLBegdQBIgbA+hKQA/hJAAhKQAAgnhYhyQhGhcg8gtQhZhCgtABQiJAAhVClgABoKnIBQF+QBFhEB1h8ICZicQBqhwAAg+IgilggAF7l0IACARQAABTgpA6QhMBuiKChIjgEJQArA0AsA5QAwBEAFA1INktgQg1idhOhvQiOjJjJhIQgngThPghItiNfQA4AGBFA0IBwBVIEvj+ICfiQQBohTBUAAQAaAAAOAIgAkwDIQAdAbBbBRQCyjRBziDQBahbBtiOQADgKAAgPQAAgSgHgHIgzAAgApxpfQgZAThOBLQhSBVjxDyIF5BRIHmnlIlYgiIgLAAQg6AAgYARgALPyYQhsAigjAWQhSA1goAeQhLA2gfAsQCvAaDDDDQDDDDAZCvQC8i2A3jVQAfh0gBgMIgbk1Ik7gbIgHAAQgoAAhnAfgAg4NbQgCALAAANIACAhIABAhQigCNiIBygAywFXQAAgEBxiAQBph3AbgbQALgMATABQANgBAUAEQASAEANAAIlMEnIgBAAQgFAAgBgNgA0aCiIB7iWIBJAAIi8Ceg',
      );
    this.shape_61.setTransform(-2.4992, 2.5283, 0.9082, 0.9082);

    this.shape_62 = new cjs.Shape();
    this.shape_62.graphics
      .f('#FFFFFF')
      .s()
      .p(
        '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',
      );
    this.shape_62.setTransform(1.45, 3.45);

    this.shape_63 = new cjs.Shape();
    this.shape_63.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgVT6QhKhMkAkMInbnmQkdkiivjQQhDhQgThIQgOg2AAh5QAAg1AkheQAihXAmgwQA+hPCZiJQCSiBBgg+QCMhdEWhfQAxgQAHgBIK2AAQAFABAwAQQEhBmCEBWQBSA0CeCMQCkCSA1BFQAqA5AiBhQAhBhAABEQAACsh7CWQgUAYhUBVQj/ENliFzQoNIlgagBQgOAAgHgBgACgN+Qg7BMhLCMQgHAYAAArQBUhQCJiuQAohCAghqIA2i0QhYCMh2C3gAk4LvQAgBpAoBDQAiA6BGBLIB2B5IAAhGIldoYIA3C0gAATFRIAAKMIG/q4IjKgcgAnSElIG/K4IAAqMIj1hIgALdDDIjABaQg9CkiFFwIIZqCQg0ADhjARgAlbMxQg6imiIluQg3gbhUgnQhTgkhBAAQgcAAgcgIgAhGD2QgyALgTABICLAYICLgYQgTgBgygLQgtgJgZAAQgZAAgtAJgAGGDkIBhAJQAGABCZgrIh0gPQgSAAh6AwgApQC9QglACgRAAQCLAvATgBIBdgDIiKgtIgEgGQgNgBgqAHgAASC3IDwAqIC+hLImuk3gAnACWIC+BLIDwgkIAAlegAKACQQAcAFAQAAQAaAABbg3QB0hFAIgEIixlBIi6G/QANgIAVAAQARAAAbAFgAuhAVQDgCAAGAAICJgCIi6m/gAvJCGICCAAQiDhfhngTQAVAZBTBZgAPLAuQgcAThoBAIBBABQA9AAAkgjQAkgkAjgnQgmAGg/AUgAAxjZIHNFOIC+naIldiMgAq8llIDCHaIHJlTIkukTgAPYAAQAqgBBNgWQANgIBlhzImKijIgPAAgAzBiSQAjAyBOBJQAWAMAmAEQAwAEAMADICwk1IgQAAgAT8jOIAaAAQAghuAAgwQAAgbiuitgA02lsQAAAnAgB3IAaAAIB0lmQiuCwAAAYgAL7mUIHFC0IiinOIjRgggAwequIiiHOIHFi0IhSk6gAACkDIEGjyIoQAAgArNmhIEwh4IlviQgAGdoZIE0B0IA7kEgAxmrlQhKA4ghAsQgWAfgRAvIgeBTQC9i7BriiQg9Arg7AtgAUWnjQgQg3g1hnQgkgthJg3Ih2hYQB9C4CrCigAsMwDIAAEHIHKDQIJ/AAIHPjQIAAkHInUjCIpwAAgAM6sBIC3ATIi3jkgAvxruIC7gTIAAjRg',
      );
    this.shape_63.setTransform(0.4722, 0.4866, 1.0367, 1.0367);

    this.shape_64 = new cjs.Shape();
    this.shape_64.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AnfLlQhFAAhXgLQkugmhugoQj9hWAAi9QAAiuCOg4Iint3IA0AAQB8AABzA8QgZB7AAAWQAACkBpATQAshBBAh1IA5DPQBEgzBBAAQBCAABLAzQANg0AehqIBgBQQBDA1AnAAQAwAAAkgnQAkgmAAgwQAAgjgrhFIhBhlICAglQBPgVAzAAQA0AABPAVICAAlIhBBlQgsBIAAAgQAAAvAlAnQAlAnAvAAQAlAABDg1QAugkAzgsIAsCeQBdgzArAAQBPAAA3AzIA8jLQA9BmAwBMQBpgTAAikQAAgdgKgsQgOg+gBgKQB8g8CnAAIinN3QCOBRAACVQAADSlBBYQjwBCkFAAgAwfC7QAAAEgDABQiPAdAAB+QAADJHhAuQDFASANAAIP8AAQAOAAAYgDQAfgEAJAAQGngcB9hpQBCg2AAhHQAAh8iTggIA4ktIgHACQgsAAAAhIQAAguAYgpQAZgwApgHIBBlZIgpAAQgOAAgKAKQAACEgLAyQgVBXhLBEQgrApgtAAQgmAAgtg6QgsCjAABLQBRgzAbAAQBqABAACmQAABtgtBEIkBAAQhPh0ADioQBagoAAhJQAAhqhjAAQguABgfAfQgfAgAAAvQAABJBBAeIgeB7QgPA9gwAyQgyA3gGAAIl+AAQgdhKAAgoQAAhbBChFQBDhGBbAAQAnAABuAzQAJgsAAhHQAAgmgJhYQg6A9hbAAQhcAAhChGQhChFAAhcQAAg3AuhcQgkgKg+AAQhDAAgfAKQAvBZAAA6QAABchCBFQhCBGhcAAQhWAAg/g9QgKBdAAAeQAABKAKAsQBjgzAyAAQBbAABDBGQBCBGAABaQAAAugeBEIl9AAQgWAAg6hSQgegpgPg8IgYhqQBBgTAAhUQAAhuhsgBQhjAAAABqQAABDBaAuIAAAFQACCthOBqIkBAAQgthKAAhlQAAipBpAAQAbAABSAzIAAgcQAAgmgsivQgmA9gtAAQgdAAgrgaQg4gjgmhYQgihQAAhJIADhRIgpAAIgWAAIBBFUQBaAYAAB2QAAAXgNAZQgPAdgXgHQA3EkAAAFgAhIiOQgfgeAAgpQAAgrAfghQAfgiApABQAsgBAeAiQAeAhAAArQAAArgfAdQggAdgpAAQgnAAghgegAJbjKQAAgvAtgBQAtABAAAvQAAAxgqAAQgwAAAAgxgAq0jKQAAgvAtgBQAtABAAAvQAAAxgwAAQgqAAAAgxg',
      );
    this.shape_64.setTransform(-0.4732, 0.0377, 0.902, 0.902);

    this.shape_65 = new cjs.Shape();
    this.shape_65.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AyRO5QiZi2AAj+QAAk2D9kbQCsjDFYjhIgDgBIgDABQj8A6juAAQimAAAAhbQAAhZCmgwQB1ghB7AAQCbAADYA5IAFAAQg3g0hegtQg+gdhkgtQgygbgMgLQgjggAAgwQAAhLBshnQBhhcBQgeQAogOA9AAQAgAAATALQAaAQAMACQDJhqCCAAQBYAAA1CPIA0CmQBSgOBnhdQBfhXAhAAQA+AAAABkQAAEFinC7QAyApBaA/QMxJDAAIaQAAGwpCDEQmKCFohAAQqYAAk3lygAy/IBQAAFzFpC0QEXCMGdAAQVnAAAAqbQAAh+glhxQhJjnk0kLQhAg2nBlTQgxAThhAcQiUAgj4AAQAuCUAABeQAABigyBTQg7BjhaAAQhBAAgqg4QglgzAAhDQAAhmBcikQr2GJAAIogAm6itQAABhAtAAQApAAAghWQAchHAAg0QAAhXgkhbQhuDMAABWgAv5pTQh1AcAAAnQAAAVA+AAQCUAAFKgwIBcgSQi5gti0AAQg7AAhbAXgAiEzIQkkBMjoDIQgeAagRAfQAhAZCwBfQCFBIA8BDIAHARQAWAWBSAAQHaAAB9k2QAbhEASiAQlWEKi0AAQiSAAAAhvQAAhKA8hWIBwiJIgPAAQgNAAg+ARgAhow7Qg6BpAAAjQAAApBFAAQAlAAA4gcQBBgfAAgfQAAgigbhNQgehWgYAAQgdAAg7BqgApsxAQhxBbAHA1QA5gxBfg9ICfhiQgggYgJAAQg4AAhsBYgAGzN7QgDgcAAgTQAAgQgKgKIitgPQhbgPhEg3QAig1A3g9QAuAwBhAMIBdAEQABgBAAgGQAAg1gvjPQiUgVg9gcQhwg0AAhvQAAhTBMhIQBAg8BYgbQAEgBAEgFIgniEIBmgUIAwCIQB+AKBeA4IgtBhQg2ABhUgbQgCACAAAFQAAAJAzDHIDrAzQB2AuAACJQAABvhaBFQg4AqiEAuIACB+Ih3AQQAAgRgEgcgAIRKRIAPAAQAtAAArgiQArgiAAgrQAAhDg+gVIhygYgADTC/QAAAZAKATQAEAIAwAQQAxAPALAAIAOAAIgni8QhhAZAABQg',
      );
    this.shape_65.setTransform(0.475, 0.475);

    this.shape_66 = new cjs.Shape();
    this.shape_66.graphics
      .f('#FFFFFF')
      .s()
      .p(
        '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',
      );
    this.shape_66.setTransform(0.5014, 0.5744, 1.2071, 1.2071);

    this.shape_67 = new cjs.Shape();
    this.shape_67.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AkhUyIAkoKIllFQQgjgKgegVICjmeIhbAAIhvCFQhDBSg3AnQjOCQkfBoIAAhkIBRgdQA5gUAfgYQB9hwA3g9QA+g+BUhGQBIg5AJgXQALg9gCghQAQi+CfjsIAEAAIAAAMQgTBEgUA7QgtCegYCZIBkheQA+g7ANgyQAYhlAJgqQA7kbCViHIhNAAQhKAAhlA+QhnA/ghBBQgDgFAAgFIABgEQBVkCDzAAQAiAAAtAQQBGAaAGAAQguikgFgHQg4hZiqAAQiaAAiSBnQiVBrgkCSQgOA5gPAnIgChJQAAgNAFgcIAJgpQASiZCbhtQCPhjCiAAQBkAAB3AvIgdhTQhMg0g7gcQilhQh+AAQlWAAkeGLIAAhfQEyl4E5AAQCfAADgB2Qh2kNiUjVIgQgXIgBgBQALgFAIgIIAIgEQATgDAMgOIAKANIAhAuQBCBfBEByIDXF+QiUmSh4i7QgRgcgRgXIgMgQIgHgJQAPgCALgJQANgBAKgGIAMAQQAeAoAbAnQB/C3BGCmQgcjPgziMQgUg4gYgtIgMgXIgMgTIALABQAJAAAIgCIAqAAIAJAUIAIASQAVAwAUA7QA0CTAwDWIhYn6IDRAAIAAKEQAAAvAOCTQAQlrBtlEQANgpAPgoIAUgyIAIgUIBOAAIgHAUIgWA9IgWBHQguCVgmCzIDLnSQAIABAIAAIAEAAQAOALAUACIgiBHIgZA3QiYFRhJEgQCmlMFUAAQEhAACFEaQAmBRAABZQAAADgDACQhHjAhThWQhvhyiwAAQiuAAiIBgQiIBhg3CmQCpiNCZAAQCDAABvBZQgfgCg/gRQg9gPgkAAQkeAAiTFlQDEizD+AAQFLAACCD0QBdCwAAFrQAAAogDAYQgjlghSikQiBkEkjAAQi1AAjLB8QAbgFAaAAIAUAAQDMADCBC1QBzCiAADUQAAAagIAOIgOAAQg3iuhribQiLjGiKAAQgKAAgVAEQgYAEgIAAIBDAeIBEDXQAdBFBFBqQBNBnAsA2QA1BiBtByIC/C9QAAgdgDgzQgEgzAAggQAAgWAVACQA0AsAACJQAAAcgCAiQBRAyAmATQASANBtBhQBNBGAzAXIAAA1QhsAjAEAAQg2AAighCQiahAg0gmQiOiChHhJQhWhbgKgHQh+hDhEgWQgIBcgHB0QgKB8giBQQhqhcgOgUQghhFgNgoQhMglgzgNIhnG+gAmTC+QgVBHABARIAAACQBch9AshYQAbhJAKguQA+goApgJQgggUgJAAQiAAAhXE3gASkMaQAAgWAOgsQAOgrAAgWIAAiSQAAgRAFgnQAGgiAAgWQAcAIAHAQQASAyAABhQAADChDAwQgZAAAAgYgAuHEFQAAiJAdhOQAehMBchmQg6CHghCwQgTBhgcDjQgNiVAAhdgANFEAQgPh+gghFQgwhmAAANQAAgVAPgCQAXAMALARQBsCcAADZQAAA5gFAtIgfAGgAzSgfQAAk8EVh0QjqDOgjEUQgIgUAAgeg',
      );
    this.shape_67.setTransform(0.975, -25.225);

    this.shape_68 = new cjs.Shape();
    this.shape_68.graphics
      .f('#FFFFFF')
      .s()
      .p(
        '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',
      );
    this.shape_68.setTransform(14.475, 19.45);

    this.instance = new lib.taurus();
    this.instance.setTransform(-190, -190);

    this.instance_1 = new lib.sloth();
    this.instance_1.setTransform(-190, -190);

    this.instance_2 = new lib.tiger();
    this.instance_2.setTransform(-190, -190);

    this.instance_3 = new lib.unicorn();
    this.instance_3.setTransform(-190, -190);

    this.instance_4 = new lib.dragon();
    this.instance_4.setTransform(-190, -190);

    this.instance_5 = new lib.elephant();
    this.instance_5.setTransform(-190, -190);

    this.instance_6 = new lib.cobra();
    this.instance_6.setTransform(-190, -190);

    this.instance_7 = new lib.kitsune();
    this.instance_7.setTransform(-190, -190);

    this.instance_8 = new lib.redpanda();
    this.instance_8.setTransform(-190, -190);

    this.instance_9 = new lib.phoenix();
    this.instance_9.setTransform(-190, -190);

    this.instance_10 = new lib.africanboy();
    this.instance_10.setTransform(-190, -190);

    this.instance_11 = new lib.africangirl();
    this.instance_11.setTransform(-190, -190);

    this.instance_12 = new lib.asianboy();
    this.instance_12.setTransform(-190, -190);

    this.instance_13 = new lib.asiangirl();
    this.instance_13.setTransform(-190, -190);

    this.instance_14 = new lib.caucasianboy();
    this.instance_14.setTransform(-190, -190);

    this.instance_15 = new lib.caucasiangirl();
    this.instance_15.setTransform(-190, -190);

    this.instance_16 = new lib.hispanicboy();
    this.instance_16.setTransform(-190, -190);

    this.instance_17 = new lib.hispanicgirl();
    this.instance_17.setTransform(-190, -190);

    this.instance_18 = new lib.indianboy();
    this.instance_18.setTransform(-190, -190);

    this.instance_19 = new lib.indiangirl();
    this.instance_19.setTransform(-190, -190);

    this.instance_20 = new lib.gcbadge1xai('synched', 0);
    this.instance_20.setTransform(0, 0, 1, 1, 0, 0, 0, 171.6, 171.6);

    this.instance_21 = new lib.gcbadge2xai('synched', 0);
    this.instance_21.setTransform(0, 0, 1, 1, 0, 0, 0, 171.6, 171.6);

    this.instance_22 = new lib.gcbadge3xai('synched', 0);
    this.instance_22.setTransform(0, 0, 1, 1, 0, 0, 0, 171.6, 171.6);

    this.instance_23 = new lib.gcbadge4xai('synched', 0);
    this.instance_23.setTransform(0, 0, 1, 1, 0, 0, 0, 171.6, 171.6);

    this.instance_24 = new lib.gcbadge5xai('synched', 0);
    this.instance_24.setTransform(0, 0, 1, 1, 0, 0, 0, 171.6, 171.6);

    this.instance_25 = new lib.gcbadge6xai('synched', 0);
    this.instance_25.setTransform(0, 0, 1, 1, 0, 0, 0, 171.6, 171.6);

    this.instance_26 = new lib.gcbadge7xai('synched', 0);
    this.instance_26.setTransform(0, 0, 1, 1, 0, 0, 0, 171.6, 171.6);

    this.instance_27 = new lib.gcbadge8xai('synched', 0);
    this.instance_27.setTransform(0, 0, 1, 1, 0, 0, 0, 171.6, 171.6);

    this.instance_28 = new lib.gcbadge9xai('synched', 0);
    this.instance_28.setTransform(0, 0.05, 1, 1, 0, 0, 0, 171.6, 171.6);

    this.instance_29 = new lib.gcbadge10xai('synched', 0);
    this.instance_29.setTransform(0, 0, 1, 1, 0, 0, 0, 171.6, 171.6);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .to({ state: [{ t: this.shape_6 }] }, 1)
        .to({ state: [{ t: this.shape_7 }] }, 1)
        .to({ state: [{ t: this.shape_8 }] }, 1)
        .to({ state: [{ t: this.shape_9 }] }, 1)
        .to({ state: [{ t: this.shape_10 }] }, 1)
        .to({ state: [{ t: this.shape_11 }] }, 1)
        .to({ state: [{ t: this.shape_13 }, { t: this.shape_12 }] }, 1)
        .to({ state: [{ t: this.shape_14 }] }, 1)
        .to({ state: [{ t: this.shape_15 }] }, 1)
        .to({ state: [{ t: this.shape_16 }] }, 1)
        .to({ state: [{ t: this.shape_17 }] }, 1)
        .to({ state: [{ t: this.shape_18 }] }, 1)
        .to({ state: [{ t: this.shape_19 }] }, 1)
        .to({ state: [{ t: this.shape_20 }] }, 1)
        .to({ state: [{ t: this.shape_21 }] }, 1)
        .to({ state: [{ t: this.shape_23 }, { t: this.shape_22 }] }, 1)
        .to({ state: [{ t: this.shape_24 }] }, 1)
        .to(
          {
            state: [
              { t: this.shape_30 },
              { t: this.shape_29 },
              { t: this.shape_28 },
              { t: this.shape_27 },
              { t: this.shape_26 },
              { t: this.shape_25 },
            ],
          },
          1,
        )
        .to({ state: [{ t: this.shape_31 }] }, 1)
        .to({ state: [{ t: this.shape_32 }] }, 1)
        .to({ state: [{ t: this.shape_33 }] }, 1)
        .to({ state: [{ t: this.shape_34 }] }, 1)
        .to({ state: [{ t: this.shape_35 }] }, 1)
        .to({ state: [{ t: this.shape_36 }] }, 1)
        .to({ state: [{ t: this.shape_37 }] }, 1)
        .to({ state: [{ t: this.shape_38 }] }, 1)
        .to({ state: [{ t: this.shape_39 }] }, 1)
        .to({ state: [{ t: this.shape_41 }, { t: this.shape_40 }] }, 1)
        .to({ state: [{ t: this.shape_42 }] }, 1)
        .to({ state: [{ t: this.shape_43 }] }, 1)
        .to({ state: [{ t: this.shape_44 }] }, 1)
        .to({ state: [{ t: this.shape_45 }] }, 1)
        .to({ state: [{ t: this.shape_46 }] }, 1)
        .to({ state: [{ t: this.shape_47 }] }, 1)
        .to({ state: [{ t: this.shape_48 }] }, 1)
        .to({ state: [{ t: this.shape_49 }] }, 1)
        .to({ state: [{ t: this.shape_50 }] }, 1)
        .to({ state: [{ t: this.shape_51 }] }, 1)
        .to({ state: [{ t: this.shape_52 }] }, 1)
        .to({ state: [{ t: this.shape_53 }] }, 1)
        .to({ state: [{ t: this.shape_54 }] }, 1)
        .to({ state: [{ t: this.shape_55 }] }, 1)
        .to({ state: [{ t: this.shape_56 }] }, 1)
        .to({ state: [{ t: this.shape_57 }] }, 1)
        .to({ state: [{ t: this.shape_58 }] }, 1)
        .to({ state: [{ t: this.shape_59 }] }, 1)
        .to({ state: [{ t: this.shape_60 }] }, 1)
        .to({ state: [{ t: this.shape_61 }] }, 1)
        .to({ state: [{ t: this.shape_62 }] }, 1)
        .to({ state: [{ t: this.shape_63 }] }, 1)
        .to({ state: [{ t: this.shape_64 }] }, 1)
        .to({ state: [{ t: this.shape_65 }] }, 1)
        .to({ state: [{ t: this.shape_66 }] }, 1)
        .to({ state: [{ t: this.shape_67 }] }, 1)
        .to({ state: [{ t: this.shape_68 }] }, 1)
        .to({ state: [{ t: this.instance }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .to({ state: [{ t: this.instance_2 }] }, 1)
        .to({ state: [{ t: this.instance_3 }] }, 1)
        .to({ state: [{ t: this.instance_4 }] }, 1)
        .to({ state: [{ t: this.instance_5 }] }, 1)
        .to({ state: [{ t: this.instance_6 }] }, 1)
        .to({ state: [{ t: this.instance_7 }] }, 1)
        .to({ state: [{ t: this.instance_8 }] }, 1)
        .to({ state: [{ t: this.instance_9 }] }, 1)
        .to({ state: [{ t: this.instance_10 }] }, 1)
        .to({ state: [{ t: this.instance_11 }] }, 1)
        .to({ state: [{ t: this.instance_12 }] }, 1)
        .to({ state: [{ t: this.instance_13 }] }, 1)
        .to({ state: [{ t: this.instance_14 }] }, 1)
        .to({ state: [{ t: this.instance_15 }] }, 1)
        .to({ state: [{ t: this.instance_16 }] }, 1)
        .to({ state: [{ t: this.instance_17 }] }, 1)
        .to({ state: [{ t: this.instance_18 }] }, 1)
        .to({ state: [{ t: this.instance_19 }] }, 1)
        .to({ state: [{ t: this.instance_20 }] }, 1)
        .to({ state: [{ t: this.instance_21 }] }, 1)
        .to({ state: [{ t: this.instance_22 }] }, 1)
        .to({ state: [{ t: this.instance_23 }] }, 1)
        .to({ state: [{ t: this.instance_24 }] }, 1)
        .to({ state: [{ t: this.instance_25 }] }, 1)
        .to({ state: [{ t: this.instance_26 }] }, 1)
        .to({ state: [{ t: this.instance_27 }] }, 1)
        .to({ state: [{ t: this.instance_28 }] }, 1)
        .to({ state: [{ t: this.instance_29 }] }, 1)
        .to({ state: [] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-190, -190, 380, 380);

  (lib.BadgeShine = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      ///* js
      //	this.stop();
      //*/
      //stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(3));

    // Layer 1
    this.instance = new lib.shineSquare('synched', 0);

    this.instance_1 = new lib.shinePentagon('synched', 0);
    this.instance_1.setTransform(0.5, 1);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [] })
        .to({ state: [{ t: this.instance }] }, 1)
        .to({ state: [{ t: this.instance_1 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-75, -75, 150, 150);

  (lib.comsuntexsymbolsBadge = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // playerIcon
    this.playerIcon = new lib.PlayerIcon();
    this.playerIcon.name = 'playerIcon';
    this.playerIcon.setTransform(0.35, -1, 0.3172, 0.3172, 0, 0, 0, 0.5, 0.5);

    this.timeline.addTween(cjs.Tween.get(this.playerIcon).wait(1));

    // levelIcon
    this.levelIcon = new lib.LevelIcon();
    this.levelIcon.name = 'levelIcon';
    this.levelIcon.setTransform(0, -0.3, 1, 1, 0, 0, 0, 0, -0.3);

    this.timeline.addTween(cjs.Tween.get(this.levelIcon).wait(1));

    // shine
    this.shine = new lib.BadgeShine();
    this.shine.name = 'shine';
    this.shine.setTransform(0.05, 0);

    this.timeline.addTween(cjs.Tween.get(this.shine).wait(1));

    // shapeOutline
    this.shapeOutline = new lib.BadgeShape();
    this.shapeOutline.name = 'shapeOutline';

    this.timeline.addTween(cjs.Tween.get(this.shapeOutline).wait(1));

    // bg
    this.bg = new lib.bg('synched', 0);
    this.bg.name = 'bg';

    this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsBadge,
    new cjs.Rectangle(-80, -80, 160, 160),
    null,
  );

  // stage content:
  (lib.PlayerBadge = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = false;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.skillLevel = new lib.SkillLevel();
    this.skillLevel.name = 'skillLevel';
    this.skillLevel.setTransform(99.95, 179.05);

    this.badge = new lib.comsuntexsymbolsBadge();
    this.badge.name = 'badge';
    this.badge.setTransform(95, 81);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.badge }, { t: this.skillLevel }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new lib.AnMovieClip();
  p.nominalBounds = new cjs.Rectangle(110, 101, 65, 97);
  // library properties:
  lib.properties = {
    id: 'B8DEB2847161C640B28373DD93571676',
    width: 190,
    height: 200,
    fps: 24,
    color: '#2F2F2F',
    opacity: 0.5,
    manifest: [
      { src: 'images/PlayerBadge_atlas_1.png', id: 'PlayerBadge_atlas_1' },
    ],
    preloads: [],
  };

  // bootstrap callback support:

  (lib.Stage = function (canvas) {
    createjs.Stage.call(this, canvas);
  }).prototype = p = new createjs.Stage();

  p.setAutoPlay = function (autoPlay) {
    this.tickEnabled = autoPlay;
  };
  p.play = function () {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
  };
  p.stop = function (ms) {
    if (ms) this.seek(ms);
    this.tickEnabled = false;
  };
  p.seek = function (ms) {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndStop((lib.properties.fps * ms) / 1000);
  };
  p.getDuration = function () {
    return (this.getChildAt(0).totalFrames / lib.properties.fps) * 1000;
  };

  p.getTimelinePosition = function () {
    return (this.getChildAt(0).currentFrame / lib.properties.fps) * 1000;
  };

  an.bootcompsLoaded = an.bootcompsLoaded || [];
  if (!an.bootstrapListeners) {
    an.bootstrapListeners = [];
  }

  an.bootstrapCallback = function (fnCallback) {
    an.bootstrapListeners.push(fnCallback);
    if (an.bootcompsLoaded.length > 0) {
      for (var i = 0; i < an.bootcompsLoaded.length; ++i) {
        fnCallback(an.bootcompsLoaded[i]);
      }
    }
  };

  an.compositions = an.compositions || {};
  an.compositions['B8DEB2847161C640B28373DD93571676'] = {
    getStage: function () {
      return exportRoot.stage;
    },
    getLibrary: function () {
      return lib;
    },
    getSpriteSheet: function () {
      return ss;
    },
    getImages: function () {
      return img;
    },
  };

  an.compositionLoaded = function (id) {
    an.bootcompsLoaded.push(id);
    for (var j = 0; j < an.bootstrapListeners.length; j++) {
      an.bootstrapListeners[j](id);
    }
  };

  an.getComposition = function (id) {
    return an.compositions[id];
  };

  an.makeResponsive = function (
    isResp,
    respDim,
    isScale,
    scaleType,
    domContainers,
    stage,
  ) {
    var lastW,
      lastH,
      lastS = 1;
    window.addEventListener('resize', resizeCanvas);
    resizeCanvas();
    function resizeCanvas() {
      var w = lib.properties.width,
        h = lib.properties.height;
      var iw = window.innerWidth,
        ih = window.innerHeight;
      var pRatio = window.devicePixelRatio || 1,
        xRatio = iw / w,
        yRatio = ih / h,
        sRatio = 1;
      if (isResp) {
        if (
          (respDim == 'width' && lastW == iw) ||
          (respDim == 'height' && lastH == ih)
        ) {
          sRatio = lastS;
        } else if (!isScale) {
          if (iw < w || ih < h) sRatio = Math.min(xRatio, yRatio);
        } else if (scaleType == 1) {
          sRatio = Math.min(xRatio, yRatio);
        } else if (scaleType == 2) {
          sRatio = Math.max(xRatio, yRatio);
        }
      }
      domContainers[0].width = w * pRatio * sRatio;
      domContainers[0].height = h * pRatio * sRatio;
      domContainers.forEach(function (container) {
        container.style.width = w * sRatio + 'px';
        container.style.height = h * sRatio + 'px';
      });
      stage.scaleX = pRatio * sRatio;
      stage.scaleY = pRatio * sRatio;
      lastW = iw;
      lastH = ih;
      lastS = sRatio;
      stage.tickOnUpdate = false;
      stage.update();
      stage.tickOnUpdate = true;
    }
  };
  an.handleSoundStreamOnTick = function (event) {
    if (!event.paused) {
      var stageChild = stage.getChildAt(0);
      if (!stageChild.paused || stageChild.ignorePause) {
        stageChild.syncStreamSounds();
      }
    }
  };
  an.handleFilterCache = function (event) {
    if (!event.paused) {
      var target = event.target;
      if (target) {
        if (target.filterCacheList) {
          for (var index = 0; index < target.filterCacheList.length; index++) {
            var cacheInst = target.filterCacheList[index];
            if (
              cacheInst.startFrame <= target.currentFrame &&
              target.currentFrame <= cacheInst.endFrame
            ) {
              cacheInst.instance.cache(
                cacheInst.x,
                cacheInst.y,
                cacheInst.w,
                cacheInst.h,
              );
            }
          }
        }
      }
    }
  };
}
